function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// Copyright (c) Apptimize, Inc. | https://sdk.apptimize.com/license
!function (e, i) {
  "use strict";

  var t,
      r = {},
      n = function n() {
    return or.__string_rec(this, "");
  },
      w = w || {};

  function a(e, t) {
    var r = Object.create(e);

    for (var i in t) {
      r[i] = t[i];
    }

    return t.toString !== Object.prototype.toString && (r.toString = t.toString), r;
  }

  var z = e.Apptimize = function () {};

  (r["apptimize.Apptimize"] = z).__name__ = "apptimize.Apptimize", z._isInitialized = function () {
    return g._isInitialized();
  }, z.setCustomerUserId = e.setCustomerUserId = function (e) {
    (!it.isNullOrString(e) || null != e && "" == j.ltrim(e)) && (d.w("The `customerUserID` argument cannot be set to a non-string value, be empty or be whitespace only, setting to null instead.", {
      fileName: "src/apptimize/Apptimize.hx",
      lineNumber: 70,
      className: "apptimize.Apptimize",
      methodName: "setCustomerUserId"
    }), e = null);
    var t = z.getCustomerUserId();
    if (null == t || t != e) {
      if (null != t || null != e) {
        var r = z.getApptimizeAnonUserId(),
            i = new le(t, r, Ge.loadObject(Ge.kCustomPropertiesKey), C.getAppKey(), je.sharedInstance(), Xe.sharedInstance()),
            n = new le(e, r, null, C.getAppKey(), je.sharedInstance(), Xe.sharedInstance()),
            a = C.sharedInstance();
        z._isInitialized() && a.dispatchUnenrollmentsForUserChanged(i), Ge.saveString(Ge.kUserIDKey, e), z.setMixpanelCohortId(e), z.setCustomAttributes(null);
        var s = C.sharedInstance().getMetaData(C.getAppKey());
        null != s && s.clearAlterationCache(), z._isInitialized() && (a.logUserTransition(i, n), a.dispatchEnrollmentsForUserChanged(n)), d.v("Customer User ID set to: " + e, {
          fileName: "src/apptimize/Apptimize.hx",
          lineNumber: 114,
          className: "apptimize.Apptimize",
          methodName: "setCustomerUserId"
        });
      } else d.w("Ignoring redundant setCustomerUserId(null)", {
        fileName: "src/apptimize/Apptimize.hx",
        lineNumber: 82,
        className: "apptimize.Apptimize",
        methodName: "setCustomerUserId"
      });
    } else d.w("Not setting customerUserId if ID already set.", {
      fileName: "src/apptimize/Apptimize.hx",
      lineNumber: 78,
      className: "apptimize.Apptimize",
      methodName: "setCustomerUserId"
    });
  }, z.setMixpanelCohortId = function (e) {
    var t;
    t = null == e ? null : "i_" + e, Xe.sharedInstance().setPropertyForNamespace("_cohort_id", t, Je.Mixpanel);
  }, z.getCustomerUserId = e.getCustomerUserId = function () {
    var e = Ge.loadString(Ge.kUserIDKey);
    return (!it.isNullOrString(e) || null != e && "" == j.ltrim(e)) && (d.w("Invalid CustomerUserId saved. Resetting to null.", {
      fileName: "src/apptimize/Apptimize.hx",
      lineNumber: 141,
      className: "apptimize.Apptimize",
      methodName: "getCustomerUserId"
    }), e = null), e;
  }, z.getApptimizeAnonUserId = e.getApptimizeAnonUserId = function () {
    return z._getApptimizeAnonUserId();
  }, z.setCustomAttributes = e.setCustomAttributes = function (e) {
    var t = lt.nativeObjectToStringMap(e);
    Ge.saveStringMap(Ge.kCustomPropertiesKey, t);
    var r = Ge.loadStringMap(Ge.kCustomPropertiesKey);
    d.v("Custom Attributes:\n" + (null == r ? "null" : D.stringify(r.h)), {
      fileName: "src/apptimize/Apptimize.hx",
      lineNumber: 173,
      className: "apptimize.Apptimize",
      methodName: "setCustomAttributes"
    }), C.sharedInstance().onEnvPropsChanged(C.getAppKey());
  }, z.getCustomAttributes = e.getCustomAttributes = function () {
    return lt.stringMapToNativeDictionary(Ge.loadStringMap(Ge.kCustomPropertiesKey));
  }, z.setPilotTargetingId = e.setPilotTargetingId = function (e) {
    it.isNullOrString(e) ? (Xe.sharedInstance().setPropertyForNamespace("pilot_targeting_id", e, Je.ApptimizeLocal), C.sharedInstance().onEnvPropsChanged(C.getAppKey())) : d.e("Invalid PilotTargetingId. Id not set. Please use a valid string.", {
      fileName: "src/apptimize/Apptimize.hx",
      lineNumber: 205,
      className: "apptimize.Apptimize",
      methodName: "setPilotTargetingId"
    });
  }, z.getPilotTargetingId = e.getPilotTargetingId = function () {
    return Xe.sharedInstance().valueForNamespacedProperty("pilot_targeting_id", Je.ApptimizeLocal);
  }, z.setOnEnrolledInExperimentCallback = e.setOnEnrolledInExperimentCallback = function (e) {
    H.setOnEnrolledInExperimentCallback(e), d.v("OnEnrolledInExperimentCallback set!", {
      fileName: "src/apptimize/Apptimize.hx",
      lineNumber: 232,
      className: "apptimize.Apptimize",
      methodName: "setOnEnrolledInExperimentCallback"
    });
  }, z.setOnUnenrolledInExperimentCallback = e.setOnUnenrolledInExperimentCallback = function (e) {
    H.setOnUnenrolledInExperimentCallback(e), d.v("OnUnenrolledInExperimentCallback set!", {
      fileName: "src/apptimize/Apptimize.hx",
      lineNumber: 243,
      className: "apptimize.Apptimize",
      methodName: "setOnUnenrolledInExperimentCallback"
    });
  }, z._getApptimizeAnonUserId = function () {
    var e = Ge.loadString(Ge.kAnonymousGuidKey);
    return null != e && "" != e && q.isValidGuid(e) || (e = q.generateUserGuid(), Ge.saveString(Ge.kAnonymousGuidKey, e)), e;
  }, z.setAppVersion = e.setAppVersion = function (e) {
    je.sharedInstance().setProperty("app_version", e);
    var t = je.sharedInstance().valueForProperty("app_version");
    d.v("App Version set to: " + t, {
      fileName: "src/apptimize/Apptimize.hx",
      lineNumber: 266,
      className: "apptimize.Apptimize",
      methodName: "setAppVersion"
    });
  }, z.setAppName = e.setAppName = function (e) {
    je.sharedInstance().setProperty("app_name", e);
    var t = je.sharedInstance().valueForProperty("app_name");
    d.v("App Name set to: " + t, {
      fileName: "src/apptimize/Apptimize.hx",
      lineNumber: 277,
      className: "apptimize.Apptimize",
      methodName: "setAppName"
    });
  }, z.setOnParticipationCallback = e.setOnParticipationCallback = function (e) {
    H.setOnParticipationCallback(e), d.w("setOnParticipationCallback is deprecated - please use setOnParticipatedInExperimentCallback.", {
      fileName: "src/apptimize/Apptimize.hx",
      lineNumber: 298,
      className: "apptimize.Apptimize",
      methodName: "setOnParticipationCallback"
    });
  }, z.setOnMetadataUpdatedCallback = e.setOnMetadataUpdatedCallback = function (e) {
    H.setOnMetadataUpdatedCallback(e), d.v("OnMetadataProcessedCallback set!", {
      fileName: "src/apptimize/Apptimize.hx",
      lineNumber: 317,
      className: "apptimize.Apptimize",
      methodName: "setOnMetadataUpdatedCallback"
    });
  }, z.setOnApptimizeInitializedCallback = e.setOnApptimizeInitializedCallback = function (e) {
    H.setOnApptimizeInitializedCallback(e), d.v("OnApptimizeInitializedCallback set!", {
      fileName: "src/apptimize/Apptimize.hx",
      lineNumber: 336,
      className: "apptimize.Apptimize",
      methodName: "setOnApptimizeInitializedCallback"
    });
  }, z.setOnParticipatedInExperimentCallback = e.setOnParticipatedInExperimentCallback = function (e) {
    H.setOnParticipatedInExperimentCallback(e), d.v("OnParticipatedInExperimentCallback set!", {
      fileName: "src/apptimize/Apptimize.hx",
      lineNumber: 354,
      className: "apptimize.Apptimize",
      methodName: "setOnParticipatedInExperimentCallback"
    });
  }, z.setup = e.setup = function (e, t) {
    null != e && "" != e ? null == C.getAppKey() || C.getAppKey() != e ? g._setup(e, t, function () {
      null != C.getAppKey() && C.getAppKey() != e && C.clear(), d.v("Set Anonymous User ID: " + z._getApptimizeAnonUserId(), {
        fileName: "src/apptimize/Apptimize.hx",
        lineNumber: 420,
        className: "apptimize.Apptimize",
        methodName: "setup"
      }), d.i("Apptimize " + z.getApptimizeSDKPlatform() + " SDK initialized.\nApptimize SDK Version: " + z.getApptimizeSDKVersion(), {
        fileName: "src/apptimize/Apptimize.hx",
        lineNumber: 421,
        className: "apptimize.Apptimize",
        methodName: "setup"
      }), z._initialize(e);
    }) : d.w('Apptimize is already initialized with app key: "' + e + '".', {
      fileName: "src/apptimize/Apptimize.hx",
      lineNumber: 409,
      className: "apptimize.Apptimize",
      methodName: "setup"
    }) : d.c("Unable to initialize Apptimize due to missing app key.", {
      fileName: "src/apptimize/Apptimize.hx",
      lineNumber: 406,
      className: "apptimize.Apptimize",
      methodName: "setup"
    });
  }, z.updateApptimizeMetadataOnce = e.updateApptimizeMetadataOnce = function () {
    try {
      C.checkForUpdatedMetaData(!0);
    } catch (e) {
      gt.lastError = e;
      var t = ct.caught(e).unwrap();
      d.e("Failed to update Metadata: " + O.string(t), {
        fileName: "src/apptimize/Apptimize.hx",
        lineNumber: 453,
        className: "apptimize.Apptimize",
        methodName: "updateApptimizeMetadataOnce"
      });
    }
  }, z.flushTracking = e.flushTracking = function () {
    z._isInitialized() ? C.sharedInstance().flushTracking() : d.w("Tracking can only be flushed after setup().", {
      fileName: "src/apptimize/Apptimize.hx",
      lineNumber: 468,
      className: "apptimize.Apptimize",
      methodName: "flushTracking"
    });
  }, z.getApptimizeSDKVersion = e.getApptimizeSDKVersion = function () {
    return "1.2.43";
  }, z.getApptimizeSDKPlatform = e.getApptimizeSDKPlatform = function () {
    return "JavaScript";
  }, z._initialize = function (e) {
    C.sharedInstance().loadMetaData(e), g.setState(2), C.sharedInstance().hasMetadata(C.getAppKey()) && g._trySetReady() && H.dispatchOnApptimizeInitialized(), d.i('Apptimize initialized with app key "' + e + '".', {
      fileName: "src/apptimize/Apptimize.hx",
      lineNumber: 523,
      className: "apptimize.Apptimize",
      methodName: "_initialize"
    });
  }, z._getAlterations = function (e, t) {
    if (C._checkForUpdatedMetadataIfNecessary(), z._isInitialized()) {
      var r = new le(e, z._getApptimizeAnonUserId(), t, C.getAppKey(), je.sharedInstance(), Xe.sharedInstance());
      return g._getAlterations(r);
    }

    return [];
  }, z._getCodeBlockMethod = function (e, t, r) {
    C._checkForUpdatedMetadataIfNecessary();

    var i = new le(t, z._getApptimizeAnonUserId(), r, C.getAppKey(), je.sharedInstance(), Xe.sharedInstance());
    return g._getCodeBlockMethod(i, e);
  }, z.runCodeBlock = e.runCodeBlock = function (e, t, r, i) {
    null != r ? (d.w("The `userID` argument is deprecated. Please use the `setCustomerUserId()` method instead.", {
      fileName: "src/apptimize/macros/ABTClientMacro.hx",
      lineNumber: 19,
      className: "apptimize.Apptimize",
      methodName: "runCodeBlock"
    }), it.isString(r) && "" != j.ltrim(r) || (d.w("The `userID` argument cannot be set to a non-string value, be empty or be whitespace only, setting to null instead.", {
      fileName: "src/apptimize/macros/ABTClientMacro.hx",
      lineNumber: 21,
      className: "apptimize.Apptimize",
      methodName: "runCodeBlock"
    }), r = null)) : r = z.getCustomerUserId(), null != i && d.w("The `customAttributes` argument is deprecated. Please use the `setCustomAttributes()` method instead.", {
      fileName: "src/apptimize/macros/ABTClientMacro.hx",
      lineNumber: 31,
      className: "apptimize.Apptimize",
      methodName: "runCodeBlock"
    }), null == i && (i = z.getCustomAttributes());

    var n = lt.nativeObjectToStringMap(i),
        a = z._getCodeBlockMethod(e, r, n),
        s = lt.nativeObjectToStringMap(t);

    if (null != a && "" != a) {
      if (null == t || null == s.h[a]) {
        var l = k.getProperty(t, a);
        null != l ? l.apply(t, []) : d.w("Supplied callbacks do not include method: " + a, {
          fileName: "src/apptimize/Apptimize.hx",
          lineNumber: 625,
          className: "apptimize.Apptimize",
          methodName: "runCodeBlock"
        });
      } else {
        d.v("Calling callback method: " + a, {
          fileName: "src/apptimize/Apptimize.hx",
          lineNumber: 628,
          className: "apptimize.Apptimize",
          methodName: "runCodeBlock"
        });
        var o = s.h[a];
        if (!k.isFunction(o)) return void d.e("runCodeBlock() called with callback that isn't a function/method.", {
          fileName: "src/apptimize/Apptimize.hx",
          lineNumber: 632,
          className: "apptimize.Apptimize",
          methodName: "runCodeBlock"
        });
        o();
      }
    } else d.w("No Code Block with variable name " + e + " found, skipping callback.", {
      fileName: "src/apptimize/Apptimize.hx",
      lineNumber: 617,
      className: "apptimize.Apptimize",
      methodName: "runCodeBlock"
    });
  }, z.isFeatureFlagEnabled = e.isFeatureFlagEnabled = function (e, t, r) {
    return z.getBool(e, !1, t, r);
  }, z.getString = e.getString = function (e, t, r, i) {
    var n = z._getValue(e, r, c.String, null, i);

    return null == n ? t : n;
  }, z.getBool = e.getBool = function (e, t, r, i) {
    var n = z._getValue(e, r, c.Boolean, null, i);

    return null == n ? t : n;
  }, z.getInt = e.getInt = function (e, t, r, i) {
    var n = z._getValue(e, r, c.Integer, null, i);

    return null == n ? t : n;
  }, z.getDouble = e.getDouble = function (e, t, r, i) {
    var n = z._getValue(e, r, c.Double, null, i);

    return null == n ? t : n;
  }, z.getStringArray = e.getStringArray = function (e, t, r, i) {
    var n = z._getValue(e, r, c.Array, c.String, i);

    return null == n ? t : st.toNativeArray(n, at.String);
  }, z.getBoolArray = e.getBoolArray = function (e, t, r, i) {
    var n = z._getValue(e, r, c.Array, c.Boolean, i);

    return null == n ? t : st.toNativeArray(n, at.Bool);
  }, z.getIntArray = e.getIntArray = function (e, t, r, i) {
    var n = z._getValue(e, r, c.Array, c.Integer, i);

    return null == n ? t : st.toNativeArray(n, at.Int);
  }, z.getDoubleArray = e.getDoubleArray = function (e, t, r, i) {
    var n = z._getValue(e, r, c.Array, c.Double, i);

    return null == n ? t : st.toNativeArray(n, at.Double);
  }, z.getStringDictionary = e.getStringDictionary = function (e, t, r, i) {
    var n = z._getValue(e, r, c.Dictionary, c.String, i);

    return null == n ? t : n;
  }, z.getBoolDictionary = e.getBoolDictionary = function (e, t, r, i) {
    var n = z._getValue(e, r, c.Dictionary, c.Boolean, i);

    return null == n ? t : n;
  }, z.getIntDictionary = e.getIntDictionary = function (e, t, r, i) {
    var n = z._getValue(e, r, c.Dictionary, c.Integer, i);

    return null == n ? t : n;
  }, z.getDoubleDictionary = e.getDoubleDictionary = function (e, t, r, i) {
    var n = z._getValue(e, r, c.Dictionary, c.Double, i);

    return null == n ? t : n;
  }, z._getValue = function (e, t, r, i, n) {
    if (!z._isInitialized()) return null;
    null != t ? (d.w("The `userID` argument is deprecated. Please use the `setCustomerUserId()` method instead.", {
      fileName: "src/apptimize/macros/ABTClientMacro.hx",
      lineNumber: 19,
      className: "apptimize.Apptimize",
      methodName: "_getValue"
    }), it.isString(t) && "" != j.ltrim(t) || (d.w("The `userID` argument cannot be set to a non-string value, be empty or be whitespace only, setting to null instead.", {
      fileName: "src/apptimize/macros/ABTClientMacro.hx",
      lineNumber: 21,
      className: "apptimize.Apptimize",
      methodName: "_getValue"
    }), t = null)) : t = z.getCustomerUserId(), null != n && d.w("The `customAttributes` argument is deprecated. Please use the `setCustomAttributes()` method instead.", {
      fileName: "src/apptimize/macros/ABTClientMacro.hx",
      lineNumber: 31,
      className: "apptimize.Apptimize",
      methodName: "_getValue"
    }), null == n && (n = z.getCustomAttributes());
    var a = lt.nativeObjectToStringMap(n),
        s = new le(t, z._getApptimizeAnonUserId(), a, C.getAppKey(), je.sharedInstance(), Xe.sharedInstance());
    return m.getValue(s, e, r, i);
  }, z.getVariantInfo = e.getVariantInfo = function (e, t) {
    null != e ? (d.w("The `userID` argument is deprecated. Please use the `setCustomerUserId()` method instead.", {
      fileName: "src/apptimize/macros/ABTClientMacro.hx",
      lineNumber: 19,
      className: "apptimize.Apptimize",
      methodName: "getVariantInfo"
    }), it.isString(e) && "" != j.ltrim(e) || (d.w("The `userID` argument cannot be set to a non-string value, be empty or be whitespace only, setting to null instead.", {
      fileName: "src/apptimize/macros/ABTClientMacro.hx",
      lineNumber: 21,
      className: "apptimize.Apptimize",
      methodName: "getVariantInfo"
    }), e = null)) : e = z.getCustomerUserId(), null != t && d.w("The `customAttributes` argument is deprecated. Please use the `setCustomAttributes()` method instead.", {
      fileName: "src/apptimize/macros/ABTClientMacro.hx",
      lineNumber: 31,
      className: "apptimize.Apptimize",
      methodName: "getVariantInfo"
    }), null == t && (t = z.getCustomAttributes());

    for (var r = [], i = z._getApptimizeAnonUserId(), n = lt.nativeObjectToStringMap(t), a = new le(e, i, n, C.getAppKey(), je.sharedInstance(), Xe.sharedInstance()), s = 0, l = g._getVariants(a, !1); s < l.length;) {
      var o = l[s];
      ++s, r.push(B.initWithVariant(o, e, i));
    }

    return st.toNativeArray(r, at.VariantInfo);
  }, z.getWinnerVariantInfo = e.getWinnerVariantInfo = function () {
    return g.getWinnerVariantInfo(z.getCustomerUserId(), z._getApptimizeAnonUserId(), z.getCustomAttributes());
  }, z._getVariantInfoForAlteration = function (e, t, r) {
    for (var i = z._getApptimizeAnonUserId(), n = 0, a = z._getAlterations(t, r); n < a.length;) {
      var s = a[n];
      if (++n, s.getKey() == e) return B.initWithVariant(s.getVariant(), t, i);
    }

    return null;
  }, z._getVariantInfoForDynamicVariable = function (e, t, r) {
    null != t ? (d.w("The `userID` argument is deprecated. Please use the `setCustomerUserId()` method instead.", {
      fileName: "src/apptimize/macros/ABTClientMacro.hx",
      lineNumber: 19,
      className: "apptimize.Apptimize",
      methodName: "_getVariantInfoForDynamicVariable"
    }), it.isString(t) && "" != j.ltrim(t) || (d.w("The `userID` argument cannot be set to a non-string value, be empty or be whitespace only, setting to null instead.", {
      fileName: "src/apptimize/macros/ABTClientMacro.hx",
      lineNumber: 21,
      className: "apptimize.Apptimize",
      methodName: "_getVariantInfoForDynamicVariable"
    }), t = null)) : t = z.getCustomerUserId(), null != r && d.w("The `customAttributes` argument is deprecated. Please use the `setCustomAttributes()` method instead.", {
      fileName: "src/apptimize/macros/ABTClientMacro.hx",
      lineNumber: 31,
      className: "apptimize.Apptimize",
      methodName: "_getVariantInfoForDynamicVariable"
    }), null == r && (r = z.getCustomAttributes());
    var i = lt.nativeObjectToStringMap(r);
    return z._getVariantInfoForAlteration(e, t, i);
  }, z._getVariantInfoForExperiment = function (e, t, r) {
    null != t ? (d.w("The `userID` argument is deprecated. Please use the `setCustomerUserId()` method instead.", {
      fileName: "src/apptimize/macros/ABTClientMacro.hx",
      lineNumber: 19,
      className: "apptimize.Apptimize",
      methodName: "_getVariantInfoForExperiment"
    }), it.isString(t) && "" != j.ltrim(t) || (d.w("The `userID` argument cannot be set to a non-string value, be empty or be whitespace only, setting to null instead.", {
      fileName: "src/apptimize/macros/ABTClientMacro.hx",
      lineNumber: 21,
      className: "apptimize.Apptimize",
      methodName: "_getVariantInfoForExperiment"
    }), t = null)) : t = z.getCustomerUserId(), null != r && d.w("The `customAttributes` argument is deprecated. Please use the `setCustomAttributes()` method instead.", {
      fileName: "src/apptimize/macros/ABTClientMacro.hx",
      lineNumber: 31,
      className: "apptimize.Apptimize",
      methodName: "_getVariantInfoForExperiment"
    }), null == r && (r = z.getCustomAttributes());

    for (var i = z._getApptimizeAnonUserId(), n = lt.nativeObjectToStringMap(r), a = new le(t, i, n, C.getAppKey(), je.sharedInstance(), Xe.sharedInstance()), s = 0, l = g._getVariants(a); s < l.length;) {
      var o = l[s];
      if (++s, o.getExperimentName() == e) return B.initWithVariant(o, t, i);
    }

    return null;
  }, z.track = e.track = function (e, t, r) {
    if (z._isInitialized()) {
      null != t ? (d.w("The `userID` argument is deprecated. Please use the `setCustomerUserId()` method instead.", {
        fileName: "src/apptimize/macros/ABTClientMacro.hx",
        lineNumber: 19,
        className: "apptimize.Apptimize",
        methodName: "track"
      }), it.isString(t) && "" != j.ltrim(t) || (d.w("The `userID` argument cannot be set to a non-string value, be empty or be whitespace only, setting to null instead.", {
        fileName: "src/apptimize/macros/ABTClientMacro.hx",
        lineNumber: 21,
        className: "apptimize.Apptimize",
        methodName: "track"
      }), t = null)) : t = z.getCustomerUserId(), null != r && d.w("The `customAttributes` argument is deprecated. Please use the `setCustomAttributes()` method instead.", {
        fileName: "src/apptimize/macros/ABTClientMacro.hx",
        lineNumber: 31,
        className: "apptimize.Apptimize",
        methodName: "track"
      }), null == r && (r = z.getCustomAttributes());
      var i = lt.nativeObjectToStringMap(r),
          n = new le(t, z._getApptimizeAnonUserId(), i, C.getAppKey(), je.sharedInstance(), Xe.sharedInstance());
      g.generateTrackEvent(n, e, null);
    } else d.w("Events can only be tracked after setup() has been called.", {
      fileName: "src/apptimize/Apptimize.hx",
      lineNumber: 1243,
      className: "apptimize.Apptimize",
      methodName: "track"
    });
  }, z.trackValue = e.trackValue = function (e, t, r, i) {
    if (z._isInitialized()) {
      if (null != r ? (d.w("The `userID` argument is deprecated. Please use the `setCustomerUserId()` method instead.", {
        fileName: "src/apptimize/macros/ABTClientMacro.hx",
        lineNumber: 19,
        className: "apptimize.Apptimize",
        methodName: "trackValue"
      }), it.isString(r) && "" != j.ltrim(r) || (d.w("The `userID` argument cannot be set to a non-string value, be empty or be whitespace only, setting to null instead.", {
        fileName: "src/apptimize/macros/ABTClientMacro.hx",
        lineNumber: 21,
        className: "apptimize.Apptimize",
        methodName: "trackValue"
      }), r = null)) : r = z.getCustomerUserId(), null != i && d.w("The `customAttributes` argument is deprecated. Please use the `setCustomAttributes()` method instead.", {
        fileName: "src/apptimize/macros/ABTClientMacro.hx",
        lineNumber: 31,
        className: "apptimize.Apptimize",
        methodName: "trackValue"
      }), null == i && (i = z.getCustomAttributes()), "number" != typeof t && !or.__instanceof(t, at.Int)) return void d.w("trackValue() called with a non-float value. Event not logged.", {
        fileName: "src/apptimize/Apptimize.hx",
        lineNumber: 1274,
        className: "apptimize.Apptimize",
        methodName: "trackValue"
      });
      var n = lt.nativeObjectToStringMap(i),
          a = new le(r, z._getApptimizeAnonUserId(), n, C.getAppKey(), je.sharedInstance(), Xe.sharedInstance());
      g.generateTrackEvent(a, e, t);
    } else d.w("Events can only be tracked after setup() has been called.", {
      fileName: "src/apptimize/Apptimize.hx",
      lineNumber: 1282,
      className: "apptimize.Apptimize",
      methodName: "trackValue"
    });
  }, z.getMetadataSequenceNumber = e.getMetadataSequenceNumber = function () {
    var e = C.sharedInstance().getMetaData(C.getAppKey());
    return null != e ? e.getSequenceNumber() : 0;
  };

  var s = function s() {};

  (r.Apptimize = s).__name__ = "Apptimize", s.__super__ = z, s.prototype = a(z.prototype, {
    __class__: s
  });

  var B = e.VariantInfo = function (e, t, r, i, n, a, s, l, o, u, p) {
    this._variantId = e, this._variantName = t, this._experimentId = r, this._experimentName = i, this._experimentType = B.apptimizeExperimentTypeForString(n), this._experimentTypeName = n, this._cycle = a, this._currentPhase = s, this._participationPhase = l, this._userId = o, this._anonymousUserId = u, this._userHasParticipated = p;
  };

  (r["apptimize.VariantInfo"] = B).__name__ = "apptimize.VariantInfo", B.initWithVariant = function (e, t, r) {
    var i = 0,
        n = "v" + e.getVariantID() + "_" + e.getCycle(),
        a = !1;
    return Xe.sharedInstance().isNamespacedPropertyAvailable(n, Je.ApptimizeInternal) && (i = Xe.sharedInstance().valueForNamespacedProperty(n, Je.ApptimizeInternal), a = !0), new B(e.getVariantID(), e.getVariantName(), e.getExperimentID(), e.getExperimentName(), e.getExperimentType(), e.getCycle(), e.getPhase(), i, t, r, a);
  }, B.apptimizeExperimentTypeForString = function (e) {
    switch (e.toLowerCase()) {
      case "code-block":
        return v.CodeBlock;

      case "double-value":
        return v.DynamicVariables;

      case "feature-config":
        return v.FeatureVariables;

      case "feature-flag":
        return v.FeatureFlag;

      case "int-value":
      case "string-value":
      case "variables":
        return v.DynamicVariables;

      case "wysiwyg":
        return v.Visual;

      default:
        return v.Unknown;
    }
  }, B.prototype = {
    _variantId: null,
    _variantName: null,
    _experimentId: null,
    _experimentName: null,
    _experimentType: null,
    _experimentTypeName: null,
    _currentPhase: null,
    _participationPhase: null,
    _cycle: null,
    _userId: null,
    _anonymousUserId: null,
    _userHasParticipated: null,
    getVariantId: function getVariantId() {
      return this._variantId;
    },
    getVariantName: function getVariantName() {
      return this._variantName;
    },
    getExperimentId: function getExperimentId() {
      return this._experimentId;
    },
    getExperimentName: function getExperimentName() {
      return this._experimentName;
    },
    getExperimentType: function getExperimentType() {
      return this._experimentType;
    },
    getExperimentTypeName: function getExperimentTypeName() {
      return this._experimentTypeName;
    },
    getCurrentPhase: function getCurrentPhase() {
      return this._currentPhase;
    },
    getParticipationPhase: function getParticipationPhase() {
      return this._participationPhase;
    },
    getCycle: function getCycle() {
      return this._cycle;
    },
    getUserId: function getUserId() {
      return this._userId;
    },
    getAnonymousUserId: function getAnonymousUserId() {
      return this._anonymousUserId;
    },
    getUserHasParticipated: function getUserHasParticipated() {
      return this._userHasParticipated;
    },
    __class__: B
  };

  var l = function l(e, t, r, i, n, a, s, _l, o, u, p) {
    B.call(this, e, t, r, i, n, a, s, _l, o, u, p);
  };

  (r.VariantInfo = l).__name__ = "VariantInfo", l.__super__ = B, l.prototype = a(B.prototype, {
    __class__: l
  });

  var o = function o(e, t) {
    this.r = new RegExp(e, t.split("u").join(""));
  };

  (r.EReg = o).__name__ = "EReg", o.prototype = {
    r: null,
    match: function match(e) {
      return this.r.global && (this.r.lastIndex = 0), this.r.m = this.r.exec(e), this.r.s = e, null != this.r.m;
    },
    matched: function matched(e) {
      if (null != this.r.m && 0 <= e && e < this.r.m.length) return this.r.m[e];
      throw ct.thrown("EReg::matched");
    },
    matchedPos: function matchedPos() {
      if (null == this.r.m) throw ct.thrown("No string matched");
      return {
        pos: this.r.m.index,
        len: this.r.m[0].length
      };
    },
    matchSub: function matchSub(e, t, r) {
      var i;
      return null == r && (r = -1), this.r.global ? (this.r.lastIndex = t, this.r.m = this.r.exec(r < 0 ? e : Y.substr(e, 0, t + r)), (i = null != this.r.m) && (this.r.s = e)) : (i = this.match(r < 0 ? Y.substr(e, t, null) : Y.substr(e, t, r))) && (this.r.s = e, this.r.m.index += t), i;
    },
    split: function split(e) {
      var t = "#__delim__#";
      return e.replace(this.r, t).split(t);
    },
    map: function map(e, t) {
      for (var r = 0, i = ""; !(r >= e.length);) {
        if (!this.matchSub(e, r)) {
          i += O.string(Y.substr(e, r, null));
          break;
        }

        var n = this.matchedPos();
        if (i += O.string(Y.substr(e, r, n.pos - r)), i += O.string(t(this)), 0 == n.len ? (i += O.string(Y.substr(e, n.pos, 1)), r = n.pos + 1) : r = n.pos + n.len, !this.r.global) break;
      }

      return !this.r.global && 0 < r && r < e.length && (i += O.string(Y.substr(e, r, null))), i;
    },
    __class__: o
  };

  var Y = function Y() {};

  (r.HxOverrides = Y).__name__ = "HxOverrides", Y.dateStr = function (e) {
    var t = e.getMonth() + 1,
        r = e.getDate(),
        i = e.getHours(),
        n = e.getMinutes(),
        a = e.getSeconds();
    return e.getFullYear() + "-" + (t < 10 ? "0" + t : "" + t) + "-" + (r < 10 ? "0" + r : "" + r) + " " + (i < 10 ? "0" + i : "" + i) + ":" + (n < 10 ? "0" + n : "" + n) + ":" + (a < 10 ? "0" + a : "" + a);
  }, Y.strDate = function (e) {
    switch (e.length) {
      case 8:
        var t = e.split(":"),
            r = new Date();
        return r.setTime(0), r.setUTCHours(t[0]), r.setUTCMinutes(t[1]), r.setUTCSeconds(t[2]), r;

      case 10:
        t = e.split("-");
        return new Date(t[0], t[1] - 1, t[2], 0, 0, 0);

      case 19:
        var i = (t = e.split(" "))[0].split("-"),
            n = t[1].split(":");
        return new Date(i[0], i[1] - 1, i[2], n[0], n[1], n[2]);

      default:
        throw ct.thrown("Invalid date format : " + e);
    }
  }, Y.cca = function (e, t) {
    var r = e.charCodeAt(t);
    if (r == r) return r;
  }, Y.substr = function (e, t, r) {
    if (null == r) r = e.length;else if (r < 0) {
      if (0 != t) return "";
      r = e.length + r;
    }
    return e.substr(t, r);
  }, Y.remove = function (e, t) {
    var r = e.indexOf(t);
    return -1 != r && (e.splice(r, 1), !0);
  }, Y.now = function () {
    return Date.now();
  };

  var F = function F() {};

  (r.Lambda = F).__name__ = "Lambda", F.array = function (e) {
    for (var t = [], r = _r(e); r.hasNext();) {
      var i = r.next();
      t.push(i);
    }

    return t;
  }, F.exists = function (e, t) {
    for (var r = _r(e); r.hasNext();) {
      if (t(r.next())) return !0;
    }

    return !1;
  }, Math.__name__ = "Math";

  var k = function k() {};

  (r.Reflect = k).__name__ = "Reflect", k.field = function (e, t) {
    try {
      return e[t];
    } catch (e) {
      return gt.lastError = e, null;
    }
  }, k.getProperty = function (e, t) {
    var r;
    return null == e ? null : !!e.__properties__ && (r = e.__properties__["get_" + t]) ? e[r]() : e[t];
  }, k.fields = function (e) {
    var t = [];

    if (null != e) {
      var r = Object.prototype.hasOwnProperty;

      for (var i in e) {
        "__id__" != i && "hx__closures__" != i && r.call(e, i) && t.push(i);
      }
    }

    return t;
  }, k.isFunction = function (e) {
    return "function" == typeof e && !(e.__name__ || e.__ename__);
  }, k.deleteField = function (e, t) {
    return !!Object.prototype.hasOwnProperty.call(e, t) && (delete e[t], !0);
  };

  var O = function O() {};

  (r.Std = O).__name__ = "Std", O.string = function (e) {
    return or.__string_rec(e, "");
  }, O.parseInt = function (e) {
    if (null != e) for (var t = 0, r = e.length; t < r;) {
      var i = t++,
          n = e.charCodeAt(i);

      if (n <= 8 || 14 <= n && 32 != n && 45 != n) {
        var a = e.charCodeAt(i + 1),
            s = parseInt(e, 120 == a || 88 == a ? 16 : 10);
        return isNaN(s) ? null : s;
      }
    }
    return null;
  };

  var u = function u() {
    this.b = "";
  };

  (r.StringBuf = u).__name__ = "StringBuf", u.prototype = {
    b: null,
    __class__: u
  };

  var j = function j() {};

  (r.StringTools = j).__name__ = "StringTools", j.isSpace = function (e, t) {
    var r = Y.cca(e, t);
    return 8 < r && r < 14 || 32 == r;
  }, j.ltrim = function (e) {
    for (var t = e.length, r = 0; r < t && j.isSpace(e, r);) {
      ++r;
    }

    return 0 < r ? Y.substr(e, r, t - r) : e;
  }, j.rtrim = function (e) {
    for (var t = e.length, r = 0; r < t && j.isSpace(e, t - r - 1);) {
      ++r;
    }

    return 0 < r ? Y.substr(e, 0, t - r) : e;
  }, j.trim = function (e) {
    return j.ltrim(j.rtrim(e));
  }, j.lpad = function (e, t, r) {
    if (t.length <= 0) return e;
    var i = "";

    for (r -= e.length; i.length < r;) {
      i += null == t ? "null" : "" + t;
    }

    return i += null == e ? "null" : "" + e;
  }, j.replace = function (e, t, r) {
    return e.split(t).join(r);
  }, j.hex = function (e, t) {
    for (var r = ""; r = "0123456789ABCDEF".charAt(15 & e) + r, 0 < (e >>>= 4);) {
      ;
    }

    if (null != t) for (; r.length < t;) {
      r = "0" + r;
    }
    return r;
  };
  var p = w.ValueType = {
    __ename__: "ValueType",
    __constructs__: null,
    TNull: {
      _hx_name: "TNull",
      _hx_index: 0,
      __enum__: "ValueType",
      toString: n
    },
    TInt: {
      _hx_name: "TInt",
      _hx_index: 1,
      __enum__: "ValueType",
      toString: n
    },
    TFloat: {
      _hx_name: "TFloat",
      _hx_index: 2,
      __enum__: "ValueType",
      toString: n
    },
    TBool: {
      _hx_name: "TBool",
      _hx_index: 3,
      __enum__: "ValueType",
      toString: n
    },
    TObject: {
      _hx_name: "TObject",
      _hx_index: 4,
      __enum__: "ValueType",
      toString: n
    },
    TFunction: {
      _hx_name: "TFunction",
      _hx_index: 5,
      __enum__: "ValueType",
      toString: n
    },
    TClass: (t = function t(e) {
      return {
        _hx_index: 6,
        c: e,
        __enum__: "ValueType",
        toString: n
      };
    }, t._hx_name = "TClass", t.__params__ = ["c"], t),
    TEnum: (t = function t(e) {
      return {
        _hx_index: 7,
        e: e,
        __enum__: "ValueType",
        toString: n
      };
    }, t._hx_name = "TEnum", t.__params__ = ["e"], t),
    TUnknown: {
      _hx_name: "TUnknown",
      _hx_index: 8,
      __enum__: "ValueType",
      toString: n
    }
  };
  p.__constructs__ = [p.TNull, p.TInt, p.TFloat, p.TBool, p.TObject, p.TFunction, p.TClass, p.TEnum, p.TUnknown];

  var P = function P() {};

  (r.Type = P).__name__ = "Type", P.createInstance = function (e, t) {
    return new (Function.prototype.bind.apply(e, [null].concat(t)))();
  }, P.createEnum = function (e, t, r) {
    var i = k.field(e, t);
    if (null == i) throw ct.thrown("No such constructor " + t);

    if (k.isFunction(i)) {
      if (null == r) throw ct.thrown("Constructor " + t + " need parameters");
      return i.apply(e, r);
    }

    if (null != r && 0 != r.length) throw ct.thrown("Constructor " + t + " does not need parameters");
    return i;
  }, P.getInstanceFields = function (e) {
    var t = [];

    for (var r in e.prototype) {
      t.push(r);
    }

    return Y.remove(t, "__class__"), Y.remove(t, "__properties__"), t;
  }, P.typeof = function (e) {
    switch (_typeof(e)) {
      case "boolean":
        return p.TBool;

      case "function":
        return e.__name__ || e.__ename__ ? p.TObject : p.TFunction;

      case "number":
        return Math.ceil(e) == e % 2147483648 ? p.TInt : p.TFloat;

      case "object":
        if (null == e) return p.TNull;
        var t = e.__enum__;
        if (null != t) return p.TEnum(w[t]);
        var r = or.getClass(e);
        return null != r ? p.TClass(r) : p.TObject;

      case "string":
        return p.TClass(String);

      case "undefined":
        return p.TNull;

      default:
        return p.TUnknown;
    }
  }, P.enumParameters = function (e) {
    var t = w[e.__enum__].__constructs__[e._hx_index].__params__;

    if (null != t) {
      for (var r = [], i = 0; i < t.length;) {
        var n = t[i];
        ++i, r.push(e[n]);
      }

      return r;
    }

    return [];
  };
  var c = w["apptimize.ABTApptimizeVariableType"] = {
    __ename__: "apptimize.ABTApptimizeVariableType",
    __constructs__: null,
    Invalid: {
      _hx_name: "Invalid",
      _hx_index: 0,
      __enum__: "apptimize.ABTApptimizeVariableType",
      toString: n
    },
    String: {
      _hx_name: "String",
      _hx_index: 1,
      __enum__: "apptimize.ABTApptimizeVariableType",
      toString: n
    },
    Double: {
      _hx_name: "Double",
      _hx_index: 2,
      __enum__: "apptimize.ABTApptimizeVariableType",
      toString: n
    },
    Integer: {
      _hx_name: "Integer",
      _hx_index: 3,
      __enum__: "apptimize.ABTApptimizeVariableType",
      toString: n
    },
    Boolean: {
      _hx_name: "Boolean",
      _hx_index: 4,
      __enum__: "apptimize.ABTApptimizeVariableType",
      toString: n
    },
    Array: {
      _hx_name: "Array",
      _hx_index: 5,
      __enum__: "apptimize.ABTApptimizeVariableType",
      toString: n
    },
    Dictionary: {
      _hx_name: "Dictionary",
      _hx_index: 6,
      __enum__: "apptimize.ABTApptimizeVariableType",
      toString: n
    }
  };
  c.__constructs__ = [c.Invalid, c.String, c.Double, c.Integer, c.Boolean, c.Array, c.Dictionary];

  var m = function m() {};

  (r["apptimize.ABTApptimizeVariable"] = m).__name__ = "apptimize.ABTApptimizeVariable", m.getValue = function (e, t, r, i) {
    C._checkForUpdatedMetadataIfNecessary();

    var n = C.sharedInstance(),
        a = n.getMetaData(e.appkey);
    if (null == a) return null;

    for (var s = n.makeEnvironment(e), l = a.selectAlterationsIntoArray(s), o = 0; o < l.length;) {
      var u = l[o];

      if (++o, u.getKey() == t) {
        var p = u instanceof Ae ? u : null;
        if (null == p) return d.v('Alteration found for key "' + u.getKey() + "\" isn't a value alteration.", {
          fileName: "src/apptimize/ABTApptimizeVariable.hx",
          lineNumber: 41,
          className: "apptimize.ABTApptimizeVariable",
          methodName: "getValue"
        }), null;
        var c = m.apptimizeVariableTypeForString(p.getType()),
            h = null;

        if (null != p.getNestedType() && (h = m.apptimizeVariableTypeForString(p.getNestedType())), c == r && h == i) {
          var _ = p.getVariant();

          if (C.sharedInstance().incrementVariantRunCount(e, _), !p.useDefaultValue()) return p.getValue();
        }
      }
    }

    return d.v('No alteration found for dynamic variable "' + t + '".', {
      fileName: "src/apptimize/ABTApptimizeVariable.hx",
      lineNumber: 63,
      className: "apptimize.ABTApptimizeVariable",
      methodName: "getValue"
    }), null;
  }, m.apptimizeVariableTypeForString = function (e) {
    var t = e.toLowerCase();
    return "string" == t ? c.String : "double" == t ? c.Double : "int" == t ? c.Integer : "boolean" == t ? c.Boolean : "list" == t ? c.Array : "dictionary" == t ? c.Dictionary : c.Invalid;
  };

  var h = function h() {};

  (r["apptimize.util.PlatformLock"] = h).__name__ = "apptimize.util.PlatformLock", h.__isInterface__ = !0, h.prototype = {
    acquire: null,
    release: null,
    __class__: h
  };

  var _ = function _() {};

  (r["apptimize.util.DefaultPlatformLock"] = _).__name__ = "apptimize.util.DefaultPlatformLock", _.__interfaces__ = [h], _.prototype = {
    acquire: function acquire() {
      return !0;
    },
    release: function release() {},
    hxUnserialize: function hxUnserialize(e) {},
    __class__: _
  };

  var f = function f() {};

  (r["apptimize.util.ABTDataLock"] = f).__name__ = "apptimize.util.ABTDataLock", f.getNewLock = function (e) {
    return new _();
  };

  var C = function C() {
    this.sdkParameters = new Se(null), this.resultDispatchQueue = new R("Results Logging Dispatch Queue"), this.resultDispatchQueue.start(), this.newMdFetcher = new V(), this.propChangeFetcher = new V(), this.metaDataCache = new D();
  };

  (r["apptimize.ABTDataStore"] = C).__name__ = "apptimize.ABTDataStore", C.sharedInstance = function () {
    return null == C._instance && (C._instance = new C()), C._instance;
  }, C.clear = function () {
    Ge.clear(), C._instance = null;
  }, C.shutdown = function () {
    null != C._instance && null != C._instance.resultTimer && C._instance.resultTimer.stop(), C._instance = null, C.appKey = null, C.serverGuid = null;
  }, C._getLastCheckTime = function () {
    var e = Ge.loadString(Ge.kMetadataLastCheckTimeKey);
    return null != e ? parseFloat(e) : -1e4;
  }, C._updateLastCheckTime = function (e) {
    Ge.saveString(Ge.kMetadataLastCheckTimeKey, null == e ? "null" : "" + e);
  }, C._resetCheckTimeIfNeeded = function () {
    var e = !1;
    f.CHECK_TIME_LOCK.acquire();

    try {
      var t = parseFloat(He.sharedInstance().valueForProperty(He.METADATA_POLLING_INTERVAL_MS_KEY)),
          r = new Date().getTime();
      t < r - C._getLastCheckTime() && (C._updateLastCheckTime(r), e = !0);
    } catch (e) {
      gt.lastError = e;
      var i = ct.caught(e).unwrap();
      throw f.CHECK_TIME_LOCK.release(), ct.thrown(i);
    }

    return f.CHECK_TIME_LOCK.release(), e;
  }, C._getLastSubmitTime = function () {
    var e = Ge.loadString(Ge.kResultLastSubmitTimeKey);
    return null != e ? parseFloat(e) : -1e4;
  }, C._updateLastSubmitTime = function (e) {
    Ge.saveString(Ge.kResultLastSubmitTimeKey, null == e ? "null" : "" + e);
  }, C.getAppKey = function () {
    return C.appKey;
  }, C.checkForUpdatedMetaData = function (e) {
    null == e && (e = !1), C.shouldDisable() ? d.w("This SDK version disabled; not checking for updated metadata", {
      fileName: "src/apptimize/ABTDataStore.hx",
      lineNumber: 218,
      className: "apptimize.ABTDataStore",
      methodName: "checkForUpdatedMetaData"
    }) : (d.v("Checking for updated metadata...", {
      fileName: "src/apptimize/ABTDataStore.hx",
      lineNumber: 221,
      className: "apptimize.ABTDataStore",
      methodName: "checkForUpdatedMetaData"
    }), z._isInitialized() && (C._resetCheckTimeIfNeeded() || e) && T.sharedInstance().downloadMetaDataForKey(C.getAppKey(), C.sharedInstance()._getCurrentEtag(C.getAppKey())));
  }, C._checkForUpdatedMetadataIfNecessary = function () {}, C.shouldDisable = function () {
    var e = Ge.loadObject(Ge.kDisabledVersions);
    return null != e && -1 < e.indexOf(z.getApptimizeSDKVersion());
  }, C.prototype = {
    resultLogs: null,
    metaDataCache: null,
    newMdFetcher: null,
    propChangeFetcher: null,
    resultDispatchQueue: null,
    sdkParameters: null,
    resultTimer: null,
    initialize: function initialize() {
      if (this.resultLogs = Ge.loadObject(Ge.kResultLogsKey), null == this.resultLogs) {
        var e = He.sharedInstance().valueForProperty(He.RESULTS_CACHE_SIZE_KEY);
        or.getClass(e) == String && null == (e = O.parseInt(e)) && (d.e("Invalid value specified for results_cache_size, defaulting to 10", {
          fileName: "src/apptimize/ABTDataStore.hx",
          lineNumber: 101,
          className: "apptimize.ABTDataStore",
          methodName: "initialize"
        }), e = 10), this.resultLogs = new rt(e);
      }
    },
    hasMetadata: function hasMetadata(e) {
      var t = !1;
      f.METADATA_LOCK.acquire();

      try {
        t = Object.prototype.hasOwnProperty.call(this.metaDataCache.h, e);
      } catch (e) {
        gt.lastError = e;
        var r = ct.caught(e).unwrap();
        throw f.METADATA_LOCK.release(), ct.thrown(r);
      }

      return f.METADATA_LOCK.release(), t;
    },
    _getCurrentEtag: function _getCurrentEtag(e) {
      var t = this.getMetaData(e);
      return null == t ? null : t.getEtag();
    },
    loadMetaData: function loadMetaData(e) {
      C.appKey = e, this.reloadFromDisk(), C.shouldDisable() || C._resetCheckTimeIfNeeded() && T.sharedInstance().downloadMetaDataForKey(e, this._getCurrentEtag(e));
    },
    _resetSubmitTimeIfNeeded: function _resetSubmitTimeIfNeeded(e) {
      null == e && (e = !1);
      var t = !1;
      f.CHECK_TIME_LOCK.acquire();

      try {
        var r = this._getMinTimeBetweenPosts(e),
            i = new Date().getTime();

        r < i - C._getLastSubmitTime() && (C._updateLastSubmitTime(i), t = !0);
      } catch (e) {
        gt.lastError = e;
        var n = ct.caught(e).unwrap();
        throw f.CHECK_TIME_LOCK.release(), ct.thrown(n);
      }

      return f.CHECK_TIME_LOCK.release(), t;
    },
    _getMinTimeBetweenPosts: function _getMinTimeBetweenPosts(e) {
      null == e && (e = !1);
      var t = parseFloat(He.sharedInstance().valueForProperty(He.RESULT_POST_DELAY_MS_KEY)),
          r = this.sdkParameters.minPostFrequencyMs;
      return e ? null == r ? -1 : r : null != r && t < r ? r : t;
    },
    _submitResultsIfNecessary: function _submitResultsIfNecessary() {},
    reloadFromDisk: function reloadFromDisk() {
      var e = Ge.loadObject(Ge.kMetadataKey);
      null != e ? (d.v("Existing metadata loaded from storage, will update if necessary.", {
        fileName: "src/apptimize/ABTDataStore.hx",
        lineNumber: 256,
        className: "apptimize.ABTDataStore",
        methodName: "reloadFromDisk"
      }), this.onMetadataLoaded(e)) : d.v("No existing metadata found in storage.", {
        fileName: "src/apptimize/ABTDataStore.hx",
        lineNumber: 259,
        className: "apptimize.ABTDataStore",
        methodName: "reloadFromDisk"
      });
    },
    getRequestlessEnvironment: function getRequestlessEnvironment(e) {
      var t = z.getApptimizeAnonUserId(),
          r = z.getCustomerUserId(),
          i = Ge.loadStringMap(Ge.kCustomPropertiesKey),
          n = new le(r, t, i, e.getAppKey(), je.sharedInstance(), Xe.sharedInstance());
      return e.makeEnvironment(n, this.sdkParameters);
    },
    getUrlsForMetadata: function getUrlsForMetadata(e) {
      var t = this.getRequestlessEnvironment(e);
      return e.extractNeededSecondaryUrls(t);
    },
    onMetadataLoaded: function onMetadataLoaded(i) {
      var n = this;
      this.sdkParameters = i.extractSdkParameters(this.getRequestlessEnvironment(i));
      var a = this.getUrlsForMetadata(i);
      this.newMdFetcher.fetch(a, i.getSecondaryValues(), function (e, t) {
        var r = n.getUrlsForMetadata(i);
        if (n.newMdFetcher.needNewUrls(a, r)) return d.w("urls changed while fetching values, retrying", {
          fileName: "src/apptimize/ABTDataStore.hx",
          lineNumber: 309,
          className: "apptimize.ABTDataStore",
          methodName: "onMetadataLoaded"
        }), void n.onMetadataLoaded(i);
        i.setSecondaryValues(e), n.overrideMetadata(i, !1, t);
      });
    },
    onMetadataReceived: function onMetadataReceived(i) {
      var n = this;
      if (this.newMdFetcher.fetching()) d.e("onMetadataReceived called while fetch already in progress", {
        fileName: "src/apptimize/ABTDataStore.hx",
        lineNumber: 330,
        className: "apptimize.ABTDataStore",
        methodName: "onMetadataReceived"
      });else {
        this.sdkParameters = i.extractSdkParameters(this.getRequestlessEnvironment(i));
        var a = this.getUrlsForMetadata(i),
            e = null,
            t = this.getMetaData(i.getAppKey());
        null != t && (e = t.getSecondaryValues()), this.newMdFetcher.fetch(a, e, function (e, t) {
          var r = n.getUrlsForMetadata(i);
          if (n.newMdFetcher.needNewUrls(a, r)) return d.w("urls changed while fetching values, retrying", {
            fileName: "src/apptimize/ABTDataStore.hx",
            lineNumber: 346,
            className: "apptimize.ABTDataStore",
            methodName: "onMetadataReceived"
          }), void n.onMetadataReceived(i);
          i.setSecondaryValues(e), n.overrideMetadata(i, !0, t);
        });
      }
    },
    onEnvPropsChanged: function onEnvPropsChanged(n) {
      var a = this,
          s = this.getMetaData(n);

      if (null != s) {
        s.resetFilterEvaluations();
        var l = this.getUrlsForMetadata(s),
            e = s.getSecondaryValues();
        this.newMdFetcher.fetching() || this.propChangeFetcher.fetching() || this.propChangeFetcher.fetch(l, e, function (e, t) {
          if (a.getMetaData(n) == s) {
            var r = a.getUrlsForMetadata(s);
            if (a.newMdFetcher.needNewUrls(l, r)) return d.w("urls changed while fetching values, retrying", {
              fileName: "src/apptimize/ABTDataStore.hx",
              lineNumber: 391,
              className: "apptimize.ABTDataStore",
              methodName: "onEnvPropsChanged"
            }), void a.onEnvPropsChanged(n);
            var i = s.clone();
            i.setSecondaryValues(e), a.overrideMetadata(i, !0, t);
          }
        });
      }
    },
    overrideMetadata: function overrideMetadata(e, t, r) {
      var i = null,
          n = !0,
          a = !1;
      f.METADATA_LOCK.acquire();

      try {
        n = e.getAppKey() == C.getAppKey();
        var s = e.getAppKey();
        i = this.metaDataCache.h[s], n && ((null == i || i.getSequenceNumber() < e.getSequenceNumber()) && (a = !0), (a || r) && (this.metaDataCache.h[s] = e, this.sdkParameters = e.extractSdkParameters(this.getRequestlessEnvironment(e)), t && Ge.saveObject(Ge.kDisabledVersions, e.getDisabledVersions())));
      } catch (e) {
        gt.lastError = e;
        var l = ct.caught(e).unwrap();
        throw f.METADATA_LOCK.release(), ct.thrown(l);
      }

      f.METADATA_LOCK.release(), e.copyPersistentValues(i), (a && t || r) && (this.writeToDiskIfNeeded(), this.dispatchEnrollmentChangeCallbacks(i, e)), a ? (H.dispatchOnMetadataUpdated(), d.i('Updated metadata for app key "' + e.getAppKey() + '".', {
        fileName: "src/apptimize/ABTDataStore.hx",
        lineNumber: 451,
        className: "apptimize.ABTDataStore",
        methodName: "overrideMetadata"
      }), d.v("New metadata:\n" + Pt.print(e.getMetaData(), null, "  "), {
        fileName: "src/apptimize/ABTDataStore.hx",
        lineNumber: 453,
        className: "apptimize.ABTDataStore",
        methodName: "overrideMetadata"
      }), null == i && g._trySetReady() && H.dispatchOnApptimizeInitialized()) : d.i("Existing metadata is up-to-date.", {
        fileName: "src/apptimize/ABTDataStore.hx",
        lineNumber: 461,
        className: "apptimize.ABTDataStore",
        methodName: "overrideMetadata"
      });
    },
    getMetaData: function getMetaData(e) {
      if (null == this.metaDataCache) return null;
      var t = null;
      f.METADATA_LOCK.acquire();

      try {
        t = this.metaDataCache.h[e];
      } catch (e) {
        gt.lastError = e;
        var r = ct.caught(e).unwrap();
        throw f.METADATA_LOCK.release(), ct.thrown(r);
      }

      return f.METADATA_LOCK.release(), null != t && t.getAppKey() != e ? (d.e("Metadata appkey does not match requested key", {
        fileName: "src/apptimize/ABTDataStore.hx",
        lineNumber: 478,
        className: "apptimize.ABTDataStore",
        methodName: "getMetaData"
      }), null) : t;
    },
    dispatchEnrollmentChangeCallbacks: function dispatchEnrollmentChangeCallbacks(e, t) {
      if (H.isEnrollmentListenerRegistered() || H.isUnenrollmentListenerRegistered()) {
        for (var r = z.getCustomerUserId(), i = z.getApptimizeAnonUserId(), n = Ge.loadStringMap(Ge.kCustomPropertiesKey), a = new le(r, i, n, C.getAppKey(), je.sharedInstance(), Xe.sharedInstance()), s = t.makeEnvironment(a, this.sdkParameters), l = null == e ? s : e.makeEnvironment(a, this.sdkParameters), o = null == e ? [] : e.uncachedSelectAlterationsIntoArray(l, !1), u = t.uncachedSelectAlterationsIntoArray(s, !1), p = new zt(), c = new zt(), h = 0; h < u.length;) {
          var _ = u[h];
          ++h;

          var m = _.getVariant();

          if (or.getClass(m) == we) {
            var f = m;
            p.add(f.getHotfixName());
          } else c.add(m);
        }

        for (var d = t.getAllVariants(), g = new Array(d.length), v = (h = 0, d.length); h < v;) {
          var A = h++;
          g[A] = d[A].getExperimentID();
        }

        var T = g,
            y = new zt(),
            N = new zt(),
            b = new zt(),
            S = new zt();

        for (h = 0; h < o.length;) {
          _ = o[h];
          ++h;
          m = [_.getVariant()];

          if (or.getClass(m[0]) != we && !F.exists(N, function (t) {
            return function (e) {
              return e == t[0].getVariantID();
            };
          }(m))) {
            var x = B.initWithVariant(m[0], r, i);
            y.add(m[0].getExperimentID()), N.add(m[0].getVariantID()), p.filter(function (t) {
              return function (e) {
                return e == t[0].getExperimentName();
              };
            }(m)).isEmpty() ? F.exists(T, function (t) {
              return function (e) {
                return e == t[0].getExperimentID();
              };
            }(m)) ? F.exists(c, function (t) {
              return function (e) {
                return e.getExperimentID() == t[0].getExperimentID();
              };
            }(m)) ? F.exists(c, function (t) {
              return function (e) {
                return e.getVariantID() == t[0].getVariantID();
              };
            }(m)) || (H.dispatchOnUnenrolledInExperiment(x, G.VariantChanged), b.add(m[0].getExperimentID())) : H.dispatchOnUnenrolledInExperiment(x, G.Other) : H.dispatchOnUnenrolledInExperiment(x, G.ExperimentStopped) : H.dispatchOnUnenrolledInExperiment(x, G.ExperimentWinnerSelected);
          }
        }

        S = new zt();

        for (var E = c.h; null != E;) {
          var I = E.item;
          E = E.next;
          var w = [I];

          if (!F.exists(S, function (t) {
            return function (e) {
              return e == t[0].getVariantID();
            };
          }(w)) && (S.add(w[0].getVariantID()), !F.exists(y, function (t) {
            return function (e) {
              return e == t[0].getExperimentID();
            };
          }(w)) || F.exists(b, function (t) {
            return function (e) {
              return e == t[0].getExperimentID();
            };
          }(w)))) {
            x = B.initWithVariant(w[0], r, i);
            H.dispatchOnEnrolledInExperiment(x);
          }
        }
      }
    },
    dispatchUnenrollmentsForUserChanged: function dispatchUnenrollmentsForUserChanged(e) {
      var t = this.getMetaData(e.appkey);

      if (null != t) {
        for (var r = t.makeEnvironment(e, this.sdkParameters), i = t.uncachedSelectAlterationsIntoArray(r), n = new zt(), a = 0, s = new Array(i.length), l = 0, o = i.length; l < o;) {
          s[h = l++] = i[h].getVariant();
        }

        l = [], o = 0;

        for (var u = s; o < u.length;) {
          var p = u[o];
          ++o, or.getClass(p) != we && l.push(p);
        }

        var c = l;

        for (s = new Array(c.length), l = 0, o = c.length; l < o;) {
          var h;
          s[h = l++] = B.initWithVariant(c[h], r.userID, r.anonID);
        }

        for (l = s; a < l.length;) {
          var _ = [l[a]];
          ++a, F.exists(n, function (t) {
            return function (e) {
              return e == t[0].getVariantId();
            };
          }(_)) || (n.add(_[0].getVariantId()), H.dispatchOnUnenrolledInExperiment(_[0], G.UserIdChanged));
        }
      }
    },
    dispatchEnrollmentsForUserChanged: function dispatchEnrollmentsForUserChanged(e) {
      var t = this.getMetaData(e.appkey);

      if (null != t) {
        for (var r = t.makeEnvironment(e, this.sdkParameters), i = t.uncachedSelectAlterationsIntoArray(r), n = new zt(), a = 0, s = new Array(i.length), l = 0, o = i.length; l < o;) {
          s[h = l++] = i[h].getVariant();
        }

        l = [], o = 0;

        for (var u = s; o < u.length;) {
          var p = u[o];
          ++o, or.getClass(p) != we && l.push(p);
        }

        var c = l;

        for (s = new Array(c.length), l = 0, o = c.length; l < o;) {
          var h;
          s[h = l++] = B.initWithVariant(c[h], r.userID, r.anonID);
        }

        for (l = s; a < l.length;) {
          var _ = [l[a]];
          ++a, F.exists(n, function (t) {
            return function (e) {
              return e == t[0].getVariantId();
            };
          }(_)) || (n.add(_[0].getVariantId()), H.dispatchOnEnrolledInExperiment(_[0]));
        }
      }
    },
    makeEnvironment: function makeEnvironment(e) {
      var t = this.getMetaData(e.appkey);
      return null == t ? null : t.makeEnvironment(e, this.sdkParameters);
    },
    writeToDiskIfNeeded: function writeToDiskIfNeeded() {
      var e = this.getMetaData(C.getAppKey());
      null != e && Ge.saveObject(Ge.kMetadataKey, e, null, !0);
    },
    _saveResultLogs: function _saveResultLogs() {
      Ge.saveObject(Ge.kResultLogsKey, this.resultLogs, null, !0);
    },
    addResultLogEntry: function addResultLogEntry(e, t) {
      var r = e.getUniqueUserID();
      C.resultsLock.acquire();

      try {
        var i = this.resultLogs.getValue(r);
        null == i && (i = new Le(e), this.resultLogs.insert(r, i, mr(this, this._submitResultLog), this.resultDispatchQueue)), i.logEntry(t), i.entryCount() > He.sharedInstance().valueForProperty(He.MAXIMUM_RESULT_ENTRIES_KEY) && this.resultLogs.remove(r, mr(this, this._submitResultLog), this.resultDispatchQueue), null == this.resultTimer && (this.resultTimer = At.delay(mr(this, this._flushTrackingForTimer), this._getMinTimeBetweenPosts())), this._saveResultLogs(), this._submitResultsIfNecessary();
      } catch (e) {
        gt.lastError = e;
        var n = ct.caught(e).unwrap();
        throw C.resultsLock.release(), ct.thrown(n);
      }

      C.resultsLock.release();
    },
    logUserTransition: function logUserTransition(e, t) {
      var r = this.makeEnvironment(e),
          i = this.makeEnvironment(t);

      if (null != r && null != i) {
        var n = new Pe(r, i.userID),
            a = new Ce(i, r.userID);
        this.addResultLogEntry(r, n), this.addResultLogEntry(i, a);
      }
    },
    _submitResultLog: function _submitResultLog(e) {
      C.shouldDisable() || (T.sharedInstance().postResultsForKey(e.getAppKey(), e), this._saveResultLogs());
    },
    flushTracking: function flushTracking() {
      this._resetSubmitTimeIfNeeded(!0) && (this._flushTrackingInternal(), null != this.resultTimer && (this.resultTimer.stop(), this.resultTimer = null));
    },
    _flushTrackingForTimer: function _flushTrackingForTimer() {
      this.resultTimer = null, this._flushTrackingInternal(), this._resetSubmitTimeIfNeeded();
    },
    _flushTrackingInternal: function _flushTrackingInternal() {
      d.v("Posting results...", {
        fileName: "src/apptimize/ABTDataStore.hx",
        lineNumber: 736,
        className: "apptimize.ABTDataStore",
        methodName: "_flushTrackingInternal"
      }), C.resultsLock.acquire();

      try {
        this.resultLogs.clear(mr(this, this._submitResultLog), this.resultDispatchQueue), this._saveResultLogs();
      } catch (e) {
        gt.lastError = e;
        var t = ct.caught(e).unwrap();
        throw C.resultsLock.release(), ct.thrown(t);
      }

      C.resultsLock.release();
    },
    incrementVariantRunCount: function incrementVariantRunCount(e, t) {
      if (or.getClass(t) != we) {
        var r = "v" + t.getVariantID() + "_" + t.getCycle(),
            i = "e" + t.getExperimentID() + "_" + t.getCycle(),
            n = t.getPhase(),
            a = !1;
        if (e.internalProps.isNamespacedPropertyAvailable(r, Je.ApptimizeInternal)) n = e.internalProps.valueForNamespacedProperty(r, Je.ApptimizeInternal);else {
          e.internalProps.valueForNamespacedProperty(r, Je.ApptimizeInternal), e.internalProps.valueForNamespacedProperty(i, Je.ApptimizeInternal);
          e.internalProps.setPropertyForNamespace(r, n, Je.ApptimizeInternal), e.internalProps.setPropertyForNamespace(i, n, Je.ApptimizeInternal), d.v("Setting stickiness attributes " + r + " and " + i + " to participation phase " + t.getPhase(), {
            fileName: "src/apptimize/ABTDataStore.hx",
            lineNumber: 765,
            className: "apptimize.ABTDataStore",
            methodName: "incrementVariantRunCount"
          }), a = !0;
        }
        var s = this.makeEnvironment(e),
            l = new Be(s, t.getVariantID(), t.getCycle(), n);
        d.v('Incrementing variant run count for variant ID "' + t.getVariantID() + '".', {
          fileName: "src/apptimize/ABTDataStore.hx",
          lineNumber: 771,
          className: "apptimize.ABTDataStore",
          methodName: "incrementVariantRunCount"
        });
        var o = B.initWithVariant(t, s.userID, s.anonID);
        H.dispatchOnParticipatedInExperiment(o, a), this.addResultLogEntry(s, l);
      }
    },
    generateEvent: function generateEvent(e, t, r, i) {
      if (z._isInitialized() && null != C.sharedInstance().getMetaData(i.appkey)) {
        var n = this.makeEnvironment(i),
            a = new Fe(n, e, t, r),
            s = 'Event "' + e + '"';
        null != r && (s = s + " with value " + O.string(r.h[g.kABTValueEventKey])), s += " tracked.", d.v(s, {
          fileName: "src/apptimize/ABTDataStore.hx",
          lineNumber: 796,
          className: "apptimize.ABTDataStore",
          methodName: "generateEvent"
        }), this.addResultLogEntry(n, a);
      } else d.w('Event "' + e + '" will not be tracked until Apptimize.setup() is called and MetaData available.', {
        fileName: "src/apptimize/ABTDataStore.hx",
        lineNumber: 782,
        className: "apptimize.ABTDataStore",
        methodName: "generateEvent"
      });
    },
    __class__: C
  };

  var d = function d() {};

  (r["apptimize.ABTLogger"] = d).__name__ = "apptimize.ABTLogger", d.logLevelFromString = function (e) {
    var t = e.toUpperCase();
    return "LOG_LEVEL_VERBOSE" == t ? d.LOG_LEVEL_VERBOSE : "LOG_LEVEL_DEBUG" == t ? d.LOG_LEVEL_DEBUG : "LOG_LEVEL_INFO" == t ? d.LOG_LEVEL_INFO : "LOG_LEVEL_WARN" == t ? d.LOG_LEVEL_WARN : "LOG_LEVEL_ERROR" == t ? d.LOG_LEVEL_ERROR : d.LOG_LEVEL_NONE;
  }, d.setLogLevel = function (e) {
    d.logLevel = e;
  }, d.c = function (e, t) {
    d.log_out(e, t), Qe.throwException(e);
  }, d.e = function (e, t) {
    d.logLevel <= d.LOG_LEVEL_ERROR && d.log_out(e, t);
  }, d.w = function (e, t) {
    d.logLevel <= d.LOG_LEVEL_WARN && d.log_out(e, t);
  }, d.i = function (e, t) {
    d.logLevel <= d.LOG_LEVEL_INFO && d.log_out(e, t);
  }, d.d = function (e, t) {
    d.logLevel <= d.LOG_LEVEL_DEBUG && d.log_out(e, t);
  }, d.v = function (e, t) {
    d.logLevel <= d.LOG_LEVEL_VERBOSE && d.log_out(e, t);
  }, d.log_out = function (e, t) {
    d.useTraceForLogging && dt.trace != d.trace ? dt.trace(e, t) : d.traceInternal("Apptimize: " + e, t);
  }, d.redirectTraceStatements = function () {
    dt.trace = d.trace;
  }, d.traceInternal = function (e, t) {
    "undefined" != typeof console && null != console.log && console.log(e);
  }, d.trace = function (e, t) {
    var r = O.string(e);
    d.v(r, t);
  };

  var g = function g() {};

  (r["apptimize.ApptimizeInternal"] = g).__name__ = "apptimize.ApptimizeInternal", g._isInitialized = function () {
    var e = !1;
    f.INITIALIZATION.acquire();

    try {
      e = 2 == g._state || 3 == g._state;
    } catch (e) {
      gt.lastError = e;
      var t = ct.caught(e).unwrap();
      throw f.INITIALIZATION.release(), ct.thrown(t);
    }

    return f.INITIALIZATION.release(), e;
  }, g.setState = function (e) {
    f.INITIALIZATION.acquire();

    try {
      g._state = e;
    } catch (e) {
      gt.lastError = e;
      var t = ct.caught(e).unwrap();
      throw f.INITIALIZATION.release(), ct.thrown(t);
    }

    f.INITIALIZATION.release();
  }, g._trySetReady = function () {
    var e = !1;
    f.INITIALIZATION.acquire();

    try {
      2 == g._state && (e = !0, g._state = 3);
    } catch (e) {
      gt.lastError = e;
      var t = ct.caught(e).unwrap();
      throw f.INITIALIZATION.release(), ct.thrown(t);
    }

    return f.INITIALIZATION.release(), e;
  }, g._setup = function (e, t, r) {
    var i = !0;
    f.INITIALIZATION.acquire();

    try {
      0 != g._state ? (d.w("Apptimize setup has already been called.", {
        fileName: "src/apptimize/ApptimizeInternal.hx",
        lineNumber: 73,
        className: "apptimize.ApptimizeInternal",
        methodName: "_setup"
      }), i = !1) : g._state = 1;
    } catch (e) {
      gt.lastError = e;
      var n = ct.caught(e).unwrap();
      throw f.INITIALIZATION.release(), ct.thrown(n);
    }

    if (f.INITIALIZATION.release(), 0 != i) {
      d.redirectTraceStatements();
      var a = He.sharedInstance();

      if (null != t && a.setProperties(lt.nativeObjectToStringMap(t)), a.isPropertyAvailable(He.LOG_LEVEL_KEY)) {
        var s = a.valueForProperty(He.LOG_LEVEL_KEY);
        d.setLogLevel(d.logLevelFromString(s));
      }

      if (a.isPropertyAvailable(He.APPTIMIZE_ENVIRONMENT_KEY) || a.isPropertyAvailable(He.APPTIMIZE_REGION_KEY)) {
        var l = a.valueForProperty(He.APPTIMIZE_ENVIRONMENT_KEY);
        null == l && (l = "prod");
        var o = a.valueForProperty(He.APPTIMIZE_REGION_KEY);

        switch (null == o && (o = "default"), o) {
          case "eucs":
            switch (l) {
              case "local":
                a.setProperty(He.META_DATA_URL_KEY, "https://local.apptimize.co/api/metadata/v4/"), a.setProperty(He.GROUPS_BASE_URL_KEY, "https://local.apptimize.co"), a.setProperty(He.APPTIMIZE_MAXEXP_SEED_KEY, 0);
                break;

              case "prod":
                a.setProperty(He.META_DATA_URL_LL_KEY, "https://md-ll.apptimize.eu/api/metadata/v4/"), a.setProperty(He.META_DATA_URL_HL_KEY, "https://md-hl.apptimize.eu/api/metadata/v4/"), a.setProperty(He.GROUPS_BASE_URL_KEY, "https://mapi.apptimize.eu"), a.setProperty(He.APPTIMIZE_MAXEXP_SEED_KEY, 6925);
                break;

              case "staging":
                "default" != o && d.v("Apptimize region '" + o + "' does not have a staging environment. Falling back to default region.", {
                  fileName: "src/apptimize/ApptimizeInternal.hx",
                  lineNumber: 116,
                  className: "apptimize.ApptimizeInternal",
                  methodName: "_setup"
                }), a.setProperty(He.META_DATA_URL_KEY, "https://staging-md.apptimize.co/api/metadata/v4/"), a.setProperty(He.GROUPS_BASE_URL_KEY, "https://staging-mapi.apptimize.co"), a.setProperty(He.APPTIMIZE_MAXEXP_SEED_KEY, 206245);
            }

            break;

          case "gcp":
            switch (l) {
              case "local":
                a.setProperty(He.META_DATA_URL_KEY, "https://local.apptimize.co/api/metadata/v4/"), a.setProperty(He.GROUPS_BASE_URL_KEY, "https://local.apptimize.co"), a.setProperty(He.APPTIMIZE_MAXEXP_SEED_KEY, 0);
                break;

              case "staging":
                a.setProperty(He.META_DATA_URL_KEY, "https://gcp-stag-md.apptimize.co/api/metadata/v4/"), a.setProperty(He.GROUPS_BASE_URL_KEY, "https://gcp-stag-mapi.apptimize.co"), a.setProperty(He.APPTIMIZE_MAXEXP_SEED_KEY, 206245);
            }

            break;

          default:
            switch (l) {
              case "local":
                a.setProperty(He.META_DATA_URL_KEY, "https://local.apptimize.co/api/metadata/v4/"), a.setProperty(He.GROUPS_BASE_URL_KEY, "https://local.apptimize.co"), a.setProperty(He.APPTIMIZE_MAXEXP_SEED_KEY, 0);
                break;

              case "staging":
                "default" != o && d.v("Apptimize region '" + o + "' does not have a staging environment. Falling back to default region.", {
                  fileName: "src/apptimize/ApptimizeInternal.hx",
                  lineNumber: 116,
                  className: "apptimize.ApptimizeInternal",
                  methodName: "_setup"
                }), a.setProperty(He.META_DATA_URL_KEY, "https://staging-md.apptimize.co/api/metadata/v4/"), a.setProperty(He.GROUPS_BASE_URL_KEY, "https://staging-mapi.apptimize.co"), a.setProperty(He.APPTIMIZE_MAXEXP_SEED_KEY, 206245);
            }

        }
      }

      null != e && d.v('Initializing Apptimize with app key: "' + e + '".', {
        fileName: "src/apptimize/ApptimizeInternal.hx",
        lineNumber: 129,
        className: "apptimize.ApptimizeInternal",
        methodName: "_setup"
      }), C.sharedInstance().initialize(), Me.initialize();
      var u = 8;
      a.isPropertyAvailable(He.RESULT_POST_THREAD_POOL_SIZE_KEY) && (u = a.valueForProperty(He.RESULT_POST_THREAD_POOL_SIZE_KEY)), Ge.loadFromHighLatency(function () {
        L.loadPendingLogs(), r(), L.startDispatching(u);
      });
    }
  }, g.shutdown = function () {
    f.INITIALIZATION.acquire();

    try {
      2 == g._state || 3 == g._state ? (L.savePendingLogs(), Ge.saveToHighLatency(), Me.shutdownPlatform(), C.shutdown(), Ge.shutdown(), g._state = 0, d.i("Apptimize has shutdown", {
        fileName: "src/apptimize/ApptimizeInternal.hx",
        lineNumber: 160,
        className: "apptimize.ApptimizeInternal",
        methodName: "shutdown"
      })) : d.w("Apptimize is not initialized. Unable to shutdown().", {
        fileName: "src/apptimize/ApptimizeInternal.hx",
        lineNumber: 162,
        className: "apptimize.ApptimizeInternal",
        methodName: "shutdown"
      });
    } catch (e) {
      gt.lastError = e;
      var t = ct.caught(e).unwrap();
      throw f.INITIALIZATION.release(), ct.thrown(t);
    }

    f.INITIALIZATION.release();
  }, g.generateTrackEvent = function (e, t, r) {
    var i = null;

    if (null != r) {
      var n = new D();
      n.h[g.kABTValueEventKey] = r, i = n;
    }

    C.sharedInstance().generateEvent(t, g.kABTEventSourceApptimize, i, e);
  }, g._getCodeBlockMethod = function (e, t) {
    var r = t;
    if (null == r || "" == r) d.w("Attempting to runCodeBlock() without specifying a code block name! Returning baseline original variant.", {
      fileName: "src/apptimize/ApptimizeInternal.hx",
      lineNumber: 179,
      className: "apptimize.ApptimizeInternal",
      methodName: "_getCodeBlockMethod"
    });else {
      for (var i = 0, n = g._getAlterations(e); i < n.length;) {
        var a = n[i];

        if (++i, null != a && or.getClass(a) == ve) {
          var s = a;
          if (s.getVariant().getCodeBlockName() != r) continue;
          return C.sharedInstance().incrementVariantRunCount(e, s.getVariant()), s.methodName;
        }
      }

      d.w('Not participating in any code block experiments with name "' + t + '". Returning baseline original variant.', {
        fileName: "src/apptimize/ApptimizeInternal.hx",
        lineNumber: 194,
        className: "apptimize.ApptimizeInternal",
        methodName: "_getCodeBlockMethod"
      });
    }
    return "baseline";
  }, g.getWinnerVariantInfo = function (e, t, r) {
    for (var i = [], n = lt.nativeObjectToStringMap(r), a = new le(e, t, n, C.getAppKey(), je.sharedInstance(), Xe.sharedInstance()), s = 0, l = g._getVariants(a, !0); s < l.length;) {
      var o = l[s];
      ++s;
      var u = o;
      i.push(A.initWithVariant(u, e, t));
    }

    return st.toNativeArray(i, at.WinnerVariantInfo);
  }, g._getVariants = function (e, t) {
    null == t && (t = !1), C._checkForUpdatedMetadataIfNecessary();

    for (var r = g._getAlterations(e), i = new wt(), n = 0; n < r.length;) {
      var a = r[n];
      ++n;
      var s = a.getVariant();

      if (t && or.getClass(s) == we || !t && or.getClass(s) != we) {
        var l = s.getVariantID();

        if (!i.h.hasOwnProperty(l)) {
          var o = s.getVariantID();
          i.h[o] = s;
        }
      }
    }

    return F.array(i);
  }, g._getAlterations = function (e) {
    var t = [],
        r = C.sharedInstance(),
        i = r.getMetaData(e.appkey);
    return null != i && (t = i.selectAlterationsIntoArray(r.makeEnvironment(e))), t;
  };
  var v = w["apptimize.ApptimizeExperimentType"] = {
    __ename__: "apptimize.ApptimizeExperimentType",
    __constructs__: null,
    CodeBlock: {
      _hx_name: "CodeBlock",
      _hx_index: 0,
      __enum__: "apptimize.ApptimizeExperimentType",
      toString: n
    },
    FeatureFlag: {
      _hx_name: "FeatureFlag",
      _hx_index: 1,
      __enum__: "apptimize.ApptimizeExperimentType",
      toString: n
    },
    DynamicVariables: {
      _hx_name: "DynamicVariables",
      _hx_index: 2,
      __enum__: "apptimize.ApptimizeExperimentType",
      toString: n
    },
    Visual: {
      _hx_name: "Visual",
      _hx_index: 3,
      __enum__: "apptimize.ApptimizeExperimentType",
      toString: n
    },
    Unknown: {
      _hx_name: "Unknown",
      _hx_index: 4,
      __enum__: "apptimize.ApptimizeExperimentType",
      toString: n
    },
    FeatureVariables: {
      _hx_name: "FeatureVariables",
      _hx_index: 5,
      __enum__: "apptimize.ApptimizeExperimentType",
      toString: n
    }
  };
  v.__constructs__ = [v.CodeBlock, v.FeatureFlag, v.DynamicVariables, v.Visual, v.Unknown, v.FeatureVariables];

  var A = e.WinnerVariantInfo = function (e, t, r, i, n) {
    this._variantId = e, this._hotfixName = t, this._userId = r, this._experimentId = n, this._anonymousUserId = i;
  };

  (r["apptimize.WinnerVariantInfo"] = A).__name__ = "apptimize.WinnerVariantInfo", A.initWithVariant = function (e, t, r) {
    return new A(e.getVariantID(), e.getHotfixName(), t, r, e.getExperimentID());
  }, A.prototype = {
    _hotfixName: null,
    _variantId: null,
    _userId: null,
    _anonymousUserId: null,
    _experimentId: null,
    getExperimentId: function getExperimentId() {
      return this._experimentId;
    },
    getWinnerName: function getWinnerName() {
      return this._hotfixName;
    },
    getUserId: function getUserId() {
      return this._userId;
    },
    getVariantId: function getVariantId() {
      return this._variantId;
    },
    getAnonymousUserId: function getAnonymousUserId() {
      return this._anonymousUserId;
    },
    __class__: A
  };

  var T = function T() {};

  (r["apptimize.api.ABTApiClient"] = T).__name__ = "apptimize.api.ABTApiClient", T.sharedInstance = function () {
    return null == T._instance && (T._instance = new T()), T._instance;
  }, T.prototype = {
    downloadMetaDataForKey: function downloadMetaDataForKey(e, t) {
      new y(this, e, t, function (e, t) {
        var r = ye.loadFromString(e);
        r.setEtag(t), C.sharedInstance().onMetadataReceived(r);
      }, function (e) {
        d.e("Failed to download metadata with error: " + e, {
          fileName: "src/apptimize/api/ABTApiClient.hx",
          lineNumber: 24,
          className: "apptimize.api.ABTApiClient",
          methodName: "downloadMetaDataForKey"
        });
      });
    },
    postResultsForKey: function postResultsForKey(e, t) {
      var r = new L(this, e, t, function (e) {}, function (e) {});
      L.pushRequest(r);
    },
    __class__: T
  };

  var y = function y(e, t, r, i, n) {
    var a = this;
    this.apiClient = e, this.appKey = t, this.successCallback = i, this.failureCallback = n;

    var s = this._getMetadataUrl();

    s += t, d.v("Checking for new metadata from url: " + s, {
      fileName: "src/apptimize/api/ABTApiMetadataRequest.hx",
      lineNumber: 27,
      className: "apptimize.api.ABTApiMetadataRequest",
      methodName: "new"
    }), me.get(s, this._headersForRequest(r), function (e) {
      a._apiSuccess(e);
    }, function (e) {
      a.failureCallback(e.text);
    });
  };

  (r["apptimize.api.ABTApiMetadataRequest"] = y).__name__ = "apptimize.api.ABTApiMetadataRequest", y.prototype = {
    apiClient: null,
    appKey: null,
    successCallback: null,
    failureCallback: null,
    _apiSuccess: function _apiSuccess(e) {
      if (304 != e.responseCode) {
        var t = M.jsonFromMetadataDownload(e.bytes);
        if (null != t) d.v("Request for metadata completed successfully.", {
          fileName: "src/apptimize/api/ABTApiMetadataRequest.hx",
          lineNumber: 45,
          className: "apptimize.api.ABTApiMetadataRequest",
          methodName: "_apiSuccess"
        }), this.successCallback(t, e.etag);else {
          var r = "Failed to download metadata with error: response was empty.";
          d.w(r, {
            fileName: "src/apptimize/api/ABTApiMetadataRequest.hx",
            lineNumber: 49,
            className: "apptimize.api.ABTApiMetadataRequest",
            methodName: "_apiSuccess"
          }), this.failureCallback(r);
        }
      } else d.v("Got HTTP response 304, metadata not updated.", {
        fileName: "src/apptimize/api/ABTApiMetadataRequest.hx",
        lineNumber: 38,
        className: "apptimize.api.ABTApiMetadataRequest",
        methodName: "_apiSuccess"
      });
    },
    _getMetadataUrl: function _getMetadataUrl() {
      var e = He.sharedInstance().valueForProperty(He.META_DATA_URL_KEY);
      return null != e ? e : C.sharedInstance().hasMetadata(this.appKey) ? He.sharedInstance().valueForProperty(He.META_DATA_URL_HL_KEY) : He.sharedInstance().valueForProperty(He.META_DATA_URL_LL_KEY);
    },
    _headersForRequest: function _headersForRequest(e) {
      if (null != e) {
        var t = new D();
        return t.h.ETag = e, t.h["If-None-Match"] = e, t;
      }

      return null;
    },
    __class__: y
  };

  var N = function N(e) {
    null == e && (e = 0), this.lock = new sr(), this._value = e;
  };

  (r["hx.concurrent.atomic._AtomicInt.AtomicIntImpl"] = N).__name__ = "hx.concurrent.atomic._AtomicInt.AtomicIntImpl", N.prototype = {
    lock: null,
    _value: null,
    get_value: function get_value() {
      this.lock.acquire();
      var e = this._value;
      return this.lock.release(), e;
    },
    set_value: function set_value(e) {
      return this.lock.acquire(), this._value = e, this.lock.release(), e;
    },
    incrementAndGet: function incrementAndGet(e) {
      null == e && (e = 1), this.lock.acquire();
      var t = this._value += e;
      return this.lock.release(), t;
    },
    __class__: N,
    __properties__: {
      set_value: "set_value",
      get_value: "get_value"
    }
  };

  var b = function b() {};

  (r["haxe.IMap"] = b).__name__ = "haxe.IMap", b.__isInterface__ = !0;

  var D = function D() {
    this.h = Object.create(null);
  };

  (r["haxe.ds.StringMap"] = D).__name__ = "haxe.ds.StringMap", D.__interfaces__ = [b], D.createCopy = function (e) {
    var t = new D();

    for (var r in e) {
      t.h[r] = e[r];
    }

    return t;
  }, D.stringify = function (e) {
    var t = "{",
        r = !0;

    for (var i in e) {
      r ? r = !1 : t += ",", t += i + " => " + O.string(e[i]);
    }

    return t + "}";
  }, D.prototype = {
    h: null,
    __class__: D
  };

  var S = {
    _new: function _new(e) {
      var t = new I();
      return null != e && t.addAll(e), t;
    }
  },
      x = function x() {};

  (r["hx.concurrent.collection.Collection"] = x).__name__ = "hx.concurrent.collection.Collection", x.__isInterface__ = !0, x.prototype = {
    iterator: null,
    __class__: x
  };

  var E = function E() {};

  (r["hx.concurrent.collection.OrderedCollection"] = E).__name__ = "hx.concurrent.collection.OrderedCollection", E.__isInterface__ = !0, E.__interfaces__ = [x];

  var I = function I() {
    this._sync = new sr(), this._items = new zt();
  };

  (r["hx.concurrent.collection._SynchronizedLinkedList.SynchronizedLinkedListImpl"] = I).__name__ = "hx.concurrent.collection._SynchronizedLinkedList.SynchronizedLinkedListImpl", I.__interfaces__ = [E], I.prototype = {
    _items: null,
    _sync: null,
    get_length: function get_length() {
      var r = this;
      return this._sync.execute(function () {
        for (var e = 0, t = r._items.h; null != t;) {
          t.item;
          t = t.next;
          ++e;
        }

        return e;
      });
    },
    add: function add(e) {
      var t = this;

      this._sync.execute(function () {
        t._items.add(e);
      });
    },
    addAll: function addAll(l) {
      var o = this;

      this._sync.execute(function () {
        var e = l;

        switch (e._hx_index) {
          case 0:
            for (var t = e.v.iterator(); t.hasNext();) {
              var r = t.next();

              o._items.add(r);
            }

            break;

          case 1:
            for (var i = e.v, n = 0; n < i.length;) {
              t = i[n];
              ++n, o._items.add(t);
            }

            break;

          case 2:
            for (var a = e.v.h; null != a;) {
              var s = a.item;
              a = a.next;
              t = s;

              o._items.add(t);
            }

        }
      });
    },
    clear: function clear() {
      var e = this;

      this._sync.execute(function () {
        return e._items = new zt();
      });
    },
    remove: function remove(e) {
      var t = this;
      return this._sync.execute(function () {
        return -1 != t.indexOf(e) && t._items.remove(e);
      });
    },
    indexOf: function indexOf(i, n) {
      null == n && (n = 0);
      var a = this;
      return this._sync.execute(function () {
        for (var e = 0, t = a._items.h; null != t;) {
          var r = t.item;
          if (t = t.next, n <= e && r == i) return e;
          ++e;
        }

        return -1;
      });
    },
    iterator: function iterator() {
      var e = this;
      return this._sync.execute(function () {
        return new Ft(e._items.h);
      });
    },
    toArray: function toArray() {
      var n = this;
      return this._sync.execute(function () {
        for (var e = [], t = n._items.h; null != t;) {
          var r = t.item;
          t = t.next;
          var i = r;
          e.push(i);
        }

        return e;
      });
    },
    __class__: I,
    __properties__: {
      get_length: "get_length"
    }
  };

  var R = function R(e) {
    this.delayedTasks = S._new(), this.executor = null, this.name = e;
  };

  (r["apptimize.util.ABTDispatch"] = R).__name__ = "apptimize.util.ABTDispatch", R.dispatchImmediately = function (e) {
    e();
  }, R.prototype = {
    executor: null,
    delayedTasks: null,
    name: null,
    dispatch: function dispatch(e, t) {
      if (null == t && (t = 0), null != this.executor) try {
        var r = rr.a(e);
        this.executor.submit(r, Wt.ONCE(t));
      } catch (e) {
        gt.lastError = e;
        var i = ct.caught(e).unwrap();
        d.e("Dispatcher '" + this.name + "' threw an exception submitting a task: " + O.string(i), {
          fileName: "src/apptimize/util/ABTDispatch.hx",
          lineNumber: 56,
          className: "apptimize.util.ABTDispatch",
          methodName: "dispatch"
        });
      } else this.delayedTasks.add(new Ze(e, t));
    },
    start: function start(e) {
      if (null == e && (e = 1), null == this.executor) {
        e < 1 && (d.w("Invalid thread count of " + e + ". Starting dispatcher '" + this.name + "' with minimum thread pool size of 1.", {
          fileName: "src/apptimize/util/ABTDispatch.hx",
          lineNumber: 76,
          className: "apptimize.util.ABTDispatch",
          methodName: "start"
        }), e = 1), this.executor = Xt.create(e);

        for (var t = new zt(), r = this.delayedTasks.iterator(); r.hasNext();) {
          var i = r.next();

          try {
            var n = or.__cast(Math.max(0, i.startTimestampMs - new Date().getTime()), dr),
                a = rr.a(i.task);

            this.executor.submit(a, Wt.ONCE(n));
          } catch (e) {
            gt.lastError = e;
            var s = ct.caught(e).unwrap();
            t.add(s);
          }
        }

        if (this.delayedTasks.clear(), !t.isEmpty()) {
          d.e("One or more errors occurred starting dispatcher '" + this.name + "':", {
            fileName: "src/apptimize/util/ABTDispatch.hx",
            lineNumber: 97,
            className: "apptimize.util.ABTDispatch",
            methodName: "start"
          });

          for (var l = t.h; null != l;) {
            var o = l.item;
            l = l.next;
            var u = o;
            d.e("Dispatcher '" + this.name + "' threw an exception submitting a task: " + u, {
              fileName: "src/apptimize/util/ABTDispatch.hx",
              lineNumber: 99,
              className: "apptimize.util.ABTDispatch",
              methodName: "start"
            });
          }
        }
      }
    },
    __class__: R
  };

  var L = function L(e, t, r, i, n) {
    this._failureCount = 0, this._apiClient = e, this._appKey = t, this._success = i, this._failure = n, this._uniqueID = r.getUniqueUserKey(), this._url = this._getUrl(t);
    var a = bt.ofString(r.toJSON());
    this._requestBytes = a;
  };

  (r["apptimize.api.ABTApiResultsPost"] = L).__name__ = "apptimize.api.ABTApiResultsPost", L._getPendingResultsCount = function () {
    var e = 0;
    L.PENDING_LOCK.acquire();

    try {
      e = L._pendingResults.get_length();
    } catch (e) {
      gt.lastError = e;
      var t = ct.caught(e).unwrap();
      throw L.PENDING_LOCK.release(), ct.thrown(t);
    }

    return L.PENDING_LOCK.release(), e;
  }, L.onSuccess = function (e, t) {
    L.clearFailureDelay(), L.PENDING_LOCK.acquire();

    try {
      L._pendingResults.remove(e), 0 < L.decrementPendingCount(e._uniqueID) && L.postNextRequestForID(e._uniqueID);
    } catch (e) {
      gt.lastError = e;
      var r = ct.caught(e).unwrap();
      throw L.PENDING_LOCK.release(), ct.thrown(r);
    }

    L.PENDING_LOCK.release(), null != e && null != e._success && e._success(t), L.savePendingLogs();
  }, L.postNextRequestForID = function (e) {
    L.PENDING_LOCK.acquire();

    try {
      for (var t = L._pendingResults.iterator(); t.hasNext();) {
        var r = [t.next()];

        if (r[0]._uniqueID == e) {
          var i = function (e) {
            return function () {
              e[0]._post();
            };
          }(r);

          null != L._postDispatch ? L._postDispatch.dispatch(i, 0) : R.dispatchImmediately(i);
          break;
        }
      }
    } catch (e) {
      gt.lastError = e;
      var n = ct.caught(e).unwrap();
      throw L.PENDING_LOCK.release(), ct.thrown(n);
    }

    L.PENDING_LOCK.release();
  }, L.decrementPendingCount = function (e) {
    var t = 0;
    L.PENDING_LOCK.acquire();

    try {
      if (t = L._pendingMap.h[e], 0 == --t) {
        var r = L._pendingMap;
        Object.prototype.hasOwnProperty.call(r.h, e) && delete r.h[e];
      } else L._pendingMap.h[e] = t;
    } catch (e) {
      gt.lastError = e;
      var i = ct.caught(e).unwrap();
      throw L.PENDING_LOCK.release(), ct.thrown(i);
    }

    return L.PENDING_LOCK.release(), t;
  }, L.incrementFailureDelay = function () {
    var e = 2 * L._failureDelayMs.get_value();

    return e > L.MAX_FAILURE_DELAY_MS && (e = L.MAX_FAILURE_DELAY_MS), L._failureDelayMs.set_value(e), L._failureDelayMs.get_value();
  }, L.clearFailureDelay = function () {
    L._failureDelayMs.set_value(L.DEFAULT_FAILURE_DELAY_MS);
  }, L.onFailure = function (e, t) {
    if (e._failureCount > He.sharedInstance().valueForProperty(He.MAXIMUM_RESULT_POST_FAILURE_KEY)) {
      d.e("Dropping result post after repeated failure.", {
        fileName: "src/apptimize/api/ABTApiResultsPost.hx",
        lineNumber: 267,
        className: "apptimize.api.ABTApiResultsPost",
        methodName: "onFailure"
      }), L.PENDING_LOCK.acquire();

      try {
        L._pendingResults.remove(e), 0 < L.decrementPendingCount(e._uniqueID) && L.postNextRequestForID(e._uniqueID);
      } catch (e) {
        gt.lastError = e;
        var r = ct.caught(e).unwrap();
        throw L.PENDING_LOCK.release(), ct.thrown(r);
      }

      L.PENDING_LOCK.release();
    } else {
      var i = function i() {
        e._post();
      };

      null != L._postDispatch ? L._postDispatch.dispatch(i, L.incrementFailureDelay()) : R.dispatchImmediately(i);
    }

    null != e._failure && e._failure(t), L.savePendingLogs();
  }, L.pushRequest = function (e, t) {
    null == t && (t = !0), L.PENDING_LOCK.acquire();

    try {
      if (L._pendingResults.add(e), Object.prototype.hasOwnProperty.call(L._pendingMap.h, e._uniqueID)) L._pendingMap.h[e._uniqueID] += 1;else {
        L._pendingMap.h[e._uniqueID] = 1;

        var r = function r() {
          e._post();
        };

        null != L._postDispatch ? L._postDispatch.dispatch(r, 0) : R.dispatchImmediately(r);
      }
      t && L.savePendingLogs();
    } catch (e) {
      gt.lastError = e;
      var i = ct.caught(e).unwrap();
      throw L.PENDING_LOCK.release(), ct.thrown(i);
    }

    L.PENDING_LOCK.release();
  }, L.savePendingLogs = function () {
    L.PENDING_LOCK.acquire();

    try {
      Ge.saveObject(Ge.kResultPostsListKey, L._pendingResults.toArray());
    } catch (e) {
      gt.lastError = e;
      var t = ct.caught(e).unwrap();
      throw L.PENDING_LOCK.release(), ct.thrown(t);
    }

    L.PENDING_LOCK.release();
  }, L.loadPendingLogs = function () {
    L.PENDING_LOCK.acquire();

    try {
      if (0 == L._loadedPending) {
        var e = Ge.loadObject(Ge.kResultPostsListKey);

        try {
          for (var t = null == e ? [] : e, r = 0; r < t.length;) {
            var i = t[r];
            ++r, L.pushRequest(i, !1);
          }
        } catch (r) {
          gt.lastError = r;
          var n = ct.caught(r).unwrap();
          d.e("Unable to load pending results posts: " + O.string(n), {
            fileName: "src/apptimize/api/ABTApiResultsPost.hx",
            lineNumber: 335,
            className: "apptimize.api.ABTApiResultsPost",
            methodName: "loadPendingLogs"
          });
        }
      }

      L._loadedPending = !0;
    } catch (r) {
      gt.lastError = r;
      n = ct.caught(r).unwrap();
      throw L.PENDING_LOCK.release(), ct.thrown(n);
    }

    L.PENDING_LOCK.release();
  }, L.startDispatching = function (e) {
    L._postDispatch.start(e);
  }, L.prototype = {
    _apiClient: null,
    _appKey: null,
    _uniqueID: null,
    _requestBytes: null,
    _success: null,
    _failure: null,
    _failureCount: null,
    _url: null,
    _getUrl: function _getUrl(e) {
      var t = C.sharedInstance().getMetaData(e);
      if (null == t) return null;
      var r = t.getCheckinUrls();
      if (null == r || r.length < 1) return null;
      return r[Math.floor((r.length - 1 + 1) * Math.random())] + "v4/";
    },
    _post: function _post() {
      var t = this;

      if (g._isInitialized()) {
        if (null == this._url && (this._url = this._getUrl(this._appKey), null == this._url)) return d.e("Unable to post results until metadata is available.", {
          fileName: "src/apptimize/api/ABTApiResultsPost.hx",
          lineNumber: 155,
          className: "apptimize.api.ABTApiResultsPost",
          methodName: "_post"
        }), void L.onFailure(this, null);
        d.v("Posting results to: " + this._url, {
          fileName: "src/apptimize/api/ABTApiResultsPost.hx",
          lineNumber: 161,
          className: "apptimize.api.ABTApiResultsPost",
          methodName: "_post"
        }), me.post(this._url, this._requestBytes, this._appKey, function (e) {
          d.d("Successfully posted results.", {
            fileName: "src/apptimize/api/ABTApiResultsPost.hx",
            lineNumber: 171,
            className: "apptimize.api.ABTApiResultsPost",
            methodName: "_post"
          }), d.d("Results JSON:\n" + O.string(t._requestBytes), {
            fileName: "src/apptimize/api/ABTApiResultsPost.hx",
            lineNumber: 173,
            className: "apptimize.api.ABTApiResultsPost",
            methodName: "_post"
          }), L.onSuccess(t, e);
        }, function (e) {
          t.incrementFailureCountForCode(e.responseCode), d.e("Failed to post results, queuing for retry later: " + e.responseCode + " " + e.text, {
            fileName: "src/apptimize/api/ABTApiResultsPost.hx",
            lineNumber: 180,
            className: "apptimize.api.ABTApiResultsPost",
            methodName: "_post"
          }), d.e("Results JSON:\n" + O.string(t._requestBytes), {
            fileName: "src/apptimize/api/ABTApiResultsPost.hx",
            lineNumber: 182,
            className: "apptimize.api.ABTApiResultsPost",
            methodName: "_post"
          }), L.onFailure(t, e);
        });
      }
    },
    incrementFailureCountForCode: function incrementFailureCountForCode(e) {
      400 <= e && this._failureCount++;
    },
    hxSerialize: function hxSerialize(e) {
      e.serialize(this._appKey), e.serialize(this._requestBytes), e.serialize(this._failureCount), e.serialize(this._url), e.serialize(this._uniqueID);
    },
    hxUnserialize: function hxUnserialize(e) {
      this._appKey = e.unserialize(), this._requestBytes = e.unserialize(), this._failureCount = e.unserialize(), this._url = e.unserialize(), this._uniqueID = e.unserialize();
    },
    __class__: L
  };

  var U = function U() {};

  (r["apptimize.api.ABTMetadataPoller"] = U).__name__ = "apptimize.api.ABTMetadataPoller", U.stopPolling = function () {
    U._stopMetadataTimer(), U._isPolling = !1;
  }, U.startPolling = function (e) {
    null == e && (e = !0), U._isThreadingEnabled = He.sharedInstance().valueForProperty(He.THREADING_ENABLED_KEY), U._interval = He.sharedInstance().valueForProperty(He.METADATA_POLLING_INTERVAL_MS_KEY), U._backgroundInterval = He.sharedInstance().valueForProperty(He.METADATA_POLLING_BACKGROUND_INTERVAL_MS_KEY), U._stopMetadataTimer();
    var t = e ? U._interval : U._backgroundInterval;
    0 < t && (d.v("Metadata update interval set to " + t + " milliseconds.", {
      fileName: "src/apptimize/api/ABTMetadataPoller.hx",
      lineNumber: 52,
      className: "apptimize.api.ABTMetadataPoller",
      methodName: "startPolling"
    }), U._startMetadataTimer(t), U._isPolling = !0);
  }, U._stopMetadataTimer = function () {
    null != U._metadataTimer && (U._metadataTimer.stop(), U._metadataTimer = null);
  }, U._startMetadataTimer = function (e) {
    null != U._metadataTimer && U._stopMetadataTimer(), (U._metadataTimer = new At(e)).run = z.updateApptimizeMetadataOnce;
  };

  var M = function M() {};

  (r["apptimize.api.ABTMetadataProcessor"] = M).__name__ = "apptimize.api.ABTMetadataProcessor", M.jsonFromMetadataDownload = function (e) {
    var t = ot.decompress(e);
    return t.getString(0, t.length);
  };

  var V = function V() {
    this._fetching = !1;
  };

  (r["apptimize.api.ABTSecondaryValuesClient"] = V).__name__ = "apptimize.api.ABTSecondaryValuesClient", V.prototype = {
    _fetching: null,
    fetching: function fetching() {
      return this._fetching;
    },
    fetch: function fetch(e, t, r) {
      var i = this;
      this._fetching = !0;
      var n = new K(e, t),
          a = !n.missingUrls.isEmpty();
      this.fetchNext(n, function (e) {
        i._fetching = !1, r(e, a);
      });
    },
    fetchNext: function fetchNext(n, a) {
      var s = this;
      if (n.missingUrls.isEmpty()) a(n.allValues);else {
        var l = n.missingUrls.pop();
        me.get(l, null, function (e) {
          var t = bt.ofData(e.bytes),
              r = n.allValues,
              i = new Ot(t.getString(0, t.length)).doParse();
          r.h[l] = i, s.fetchNext(n, a);
        }, function (e) {
          d.e("GET " + l + " failed: " + e.responseCode, {
            fileName: "src/apptimize/api/ABTSecondaryValuesClient.hx",
            lineNumber: 47,
            className: "apptimize.api.ABTSecondaryValuesClient",
            methodName: "fetchNext"
          }), s.fetchNext(n, a);
        });
      }
    },
    needNewUrls: function needNewUrls(e, t) {
      for (var r = [], i = 0, n = t; i < n.length;) {
        var a = n[i];
        ++i, e.indexOf(a) < 0 && r.push(a);
      }

      return 0 < r.length;
    },
    __class__: V
  };

  var K = function K(e, t) {
    for (var r = new zt(), i = new D(), n = 0; n < e.length;) {
      var a = e[n];

      if (++n, null != t && Object.prototype.hasOwnProperty.call(t.h, a)) {
        var s = t.h[a];
        i.h[a] = s;
      } else r.add(a);
    }

    this.missingUrls = r, this.allValues = i;
  };

  (r["apptimize.api.ABTSecValFetchState"] = K).__name__ = "apptimize.api.ABTSecValFetchState", K.prototype = {
    missingUrls: null,
    allValues: null,
    __class__: K
  };

  var q = function q() {};

  (r["apptimize.api.ABTUserGuid"] = q).__name__ = "apptimize.api.ABTUserGuid", q.generateUserGuid = function () {
    return q._userGuid = q.S4() + q.S4() + "-" + q.S4() + "-" + q.S4() + "-" + q.S4() + "-" + q.S4() + q.S4() + q.S4(), q._userGuid;
  }, q.S4 = function (e) {
    null == e && (e = Math.random);
    var t = 65536 * e() | 0;
    return j.hex(t, 4);
  }, q.isValidGuid = function (e) {
    return new o("(^([0-9A-Fa-f]{8}[-][0-9A-Fa-f]{4}[-][0-9A-Fa-f]{4}[-][0-9A-Fa-f]{4}[-][0-9A-Fa-f]{12})$)", "").match(e);
  };
  var G = w["apptimize.events.ApptimizeUnenrollmentReason"] = {
    __ename__: "apptimize.events.ApptimizeUnenrollmentReason",
    __constructs__: null,
    ExperimentStopped: {
      _hx_name: "ExperimentStopped",
      _hx_index: 0,
      __enum__: "apptimize.events.ApptimizeUnenrollmentReason",
      toString: n
    },
    ExperimentWinnerSelected: {
      _hx_name: "ExperimentWinnerSelected",
      _hx_index: 1,
      __enum__: "apptimize.events.ApptimizeUnenrollmentReason",
      toString: n
    },
    VariantChanged: {
      _hx_name: "VariantChanged",
      _hx_index: 2,
      __enum__: "apptimize.events.ApptimizeUnenrollmentReason",
      toString: n
    },
    UserIdChanged: {
      _hx_name: "UserIdChanged",
      _hx_index: 3,
      __enum__: "apptimize.events.ApptimizeUnenrollmentReason",
      toString: n
    },
    Other: {
      _hx_name: "Other",
      _hx_index: 4,
      __enum__: "apptimize.events.ApptimizeUnenrollmentReason",
      toString: n
    },
    Unknown: {
      _hx_name: "Unknown",
      _hx_index: 5,
      __enum__: "apptimize.events.ApptimizeUnenrollmentReason",
      toString: n
    }
  };
  G.__constructs__ = [G.ExperimentStopped, G.ExperimentWinnerSelected, G.VariantChanged, G.UserIdChanged, G.Other, G.Unknown];

  var H = function H() {};

  (r["apptimize.events.ABTEventManager"] = H).__name__ = "apptimize.events.ABTEventManager", H.setOnMetadataUpdatedCallback = function (e) {
    H._onMetadataUpdatedCallback = e;
  }, H.dispatchOnMetadataUpdated = function () {
    null != H._onMetadataUpdatedCallback && H._onMetadataUpdatedCallback();
  }, H.setOnParticipationCallback = function (e) {
    H._onParticipationCallback = e;
  }, H.dispatchOnParticipation = function (e, t) {
    null != H._onParticipationCallback && H._onParticipationCallback(e, t);
  }, H.setOnParticipatedInExperimentCallback = function (e) {
    H._onParticipatedInExperimentCallback = e;
  }, H.dispatchOnParticipatedInExperiment = function (e, t) {
    null != H._onParticipatedInExperimentCallback && H._onParticipatedInExperimentCallback(e, t), H.dispatchOnParticipation(e.getExperimentName(), e.getVariantName());
  }, H.setOnEnrolledInExperimentCallback = function (e) {
    H._onEnrolledInExperimentCallback = e;
  }, H.dispatchOnEnrolledInExperiment = function (e) {
    null != H._onEnrolledInExperimentCallback && H._onEnrolledInExperimentCallback(e);
  }, H.setOnUnenrolledInExperimentCallback = function (e) {
    H._onUnenrolledInExperimentCallback = e;
  }, H.dispatchOnUnenrolledInExperiment = function (e, t) {
    null != H._onUnenrolledInExperimentCallback && H._onUnenrolledInExperimentCallback(e, t);
  }, H.setOnApptimizeInitializedCallback = function (e) {
    H._onApptimizeInitializedCallback = e;
  }, H.dispatchOnApptimizeInitialized = function () {
    null != H._onApptimizeInitializedCallback && H._onApptimizeInitializedCallback();
  }, H.isEnrollmentListenerRegistered = function () {
    return null != H._onEnrolledInExperimentCallback;
  }, H.isUnenrollmentListenerRegistered = function () {
    return null != H._onUnenrolledInExperimentCallback;
  };
  var J = w["apptimize.filter.ABTFilterResult"] = {
    __ename__: "apptimize.filter.ABTFilterResult",
    __constructs__: null,
    ABTFilterResultUnknown: {
      _hx_name: "ABTFilterResultUnknown",
      _hx_index: 0,
      __enum__: "apptimize.filter.ABTFilterResult",
      toString: n
    },
    ABTFilterResultFalse: {
      _hx_name: "ABTFilterResultFalse",
      _hx_index: 1,
      __enum__: "apptimize.filter.ABTFilterResult",
      toString: n
    },
    ABTFilterResultTrue: {
      _hx_name: "ABTFilterResultTrue",
      _hx_index: 2,
      __enum__: "apptimize.filter.ABTFilterResult",
      toString: n
    }
  };
  J.__constructs__ = [J.ABTFilterResultUnknown, J.ABTFilterResultFalse, J.ABTFilterResultTrue];
  var W = w["apptimize.filter.ABTFilterPropertySource"] = {
    __ename__: "apptimize.filter.ABTFilterPropertySource",
    __constructs__: null,
    ABTFilterPropertySourceDevice: {
      _hx_name: "ABTFilterPropertySourceDevice",
      _hx_index: 0,
      __enum__: "apptimize.filter.ABTFilterPropertySource",
      toString: n
    },
    ABTFilterPropertySourceUser: {
      _hx_name: "ABTFilterPropertySourceUser",
      _hx_index: 1,
      __enum__: "apptimize.filter.ABTFilterPropertySource",
      toString: n
    },
    ABTFilterPropertySourcePrefixed: {
      _hx_name: "ABTFilterPropertySourcePrefixed",
      _hx_index: 2,
      __enum__: "apptimize.filter.ABTFilterPropertySource",
      toString: n
    }
  };
  W.__constructs__ = [W.ABTFilterPropertySourceDevice, W.ABTFilterPropertySourceUser, W.ABTFilterPropertySourcePrefixed];
  var X = w["apptimize.filter.ABTFilterType"] = {
    __ename__: "apptimize.filter.ABTFilterType",
    __constructs__: null,
    ABTFilterTypeUnknown: {
      _hx_name: "ABTFilterTypeUnknown",
      _hx_index: 0,
      __enum__: "apptimize.filter.ABTFilterType",
      toString: n
    },
    ABTFilterTypeSimple: {
      _hx_name: "ABTFilterTypeSimple",
      _hx_index: 1,
      __enum__: "apptimize.filter.ABTFilterType",
      toString: n
    },
    ABTFilterTypeList: {
      _hx_name: "ABTFilterTypeList",
      _hx_index: 2,
      __enum__: "apptimize.filter.ABTFilterType",
      toString: n
    },
    ABTFilterTypeSet: {
      _hx_name: "ABTFilterTypeSet",
      _hx_index: 3,
      __enum__: "apptimize.filter.ABTFilterType",
      toString: n
    },
    ABTFilterTypeCompound: {
      _hx_name: "ABTFilterTypeCompound",
      _hx_index: 4,
      __enum__: "apptimize.filter.ABTFilterType",
      toString: n
    },
    ABTFilterTypePropertyless: {
      _hx_name: "ABTFilterTypePropertyless",
      _hx_index: 5,
      __enum__: "apptimize.filter.ABTFilterType",
      toString: n
    },
    ABTFilterTypeNamed: {
      _hx_name: "ABTFilterTypeNamed",
      _hx_index: 6,
      __enum__: "apptimize.filter.ABTFilterType",
      toString: n
    }
  };
  X.__constructs__ = [X.ABTFilterTypeUnknown, X.ABTFilterTypeSimple, X.ABTFilterTypeList, X.ABTFilterTypeSet, X.ABTFilterTypeCompound, X.ABTFilterTypePropertyless, X.ABTFilterTypeNamed];
  var Z = w["apptimize.filter.ABTFilterOperator"] = {
    __ename__: "apptimize.filter.ABTFilterOperator",
    __constructs__: null,
    ABTFilterOperatorUnknown: {
      _hx_name: "ABTFilterOperatorUnknown",
      _hx_index: 0,
      __enum__: "apptimize.filter.ABTFilterOperator",
      toString: n
    },
    ABTFilterOperatorEquals: {
      _hx_name: "ABTFilterOperatorEquals",
      _hx_index: 1,
      __enum__: "apptimize.filter.ABTFilterOperator",
      toString: n
    },
    ABTFilterOperatorNotEquals: {
      _hx_name: "ABTFilterOperatorNotEquals",
      _hx_index: 2,
      __enum__: "apptimize.filter.ABTFilterOperator",
      toString: n
    },
    ABTFilterOperatorRegex: {
      _hx_name: "ABTFilterOperatorRegex",
      _hx_index: 3,
      __enum__: "apptimize.filter.ABTFilterOperator",
      toString: n
    },
    ABTFilterOperatorNotRegex: {
      _hx_name: "ABTFilterOperatorNotRegex",
      _hx_index: 4,
      __enum__: "apptimize.filter.ABTFilterOperator",
      toString: n
    },
    ABTFilterOperatorGreaterThan: {
      _hx_name: "ABTFilterOperatorGreaterThan",
      _hx_index: 5,
      __enum__: "apptimize.filter.ABTFilterOperator",
      toString: n
    },
    ABTFilterOperatorGreaterThanOrEqual: {
      _hx_name: "ABTFilterOperatorGreaterThanOrEqual",
      _hx_index: 6,
      __enum__: "apptimize.filter.ABTFilterOperator",
      toString: n
    },
    ABTFilterOperatorLessThan: {
      _hx_name: "ABTFilterOperatorLessThan",
      _hx_index: 7,
      __enum__: "apptimize.filter.ABTFilterOperator",
      toString: n
    },
    ABTFilterOperatorLessThanOrEqual: {
      _hx_name: "ABTFilterOperatorLessThanOrEqual",
      _hx_index: 8,
      __enum__: "apptimize.filter.ABTFilterOperator",
      toString: n
    },
    ABTFilterOperatorInList: {
      _hx_name: "ABTFilterOperatorInList",
      _hx_index: 9,
      __enum__: "apptimize.filter.ABTFilterOperator",
      toString: n
    },
    ABTFilterOperatorNotInList: {
      _hx_name: "ABTFilterOperatorNotInList",
      _hx_index: 10,
      __enum__: "apptimize.filter.ABTFilterOperator",
      toString: n
    },
    ABTFilterOperatorIntersection: {
      _hx_name: "ABTFilterOperatorIntersection",
      _hx_index: 11,
      __enum__: "apptimize.filter.ABTFilterOperator",
      toString: n
    },
    ABTFilterOperatorCompoundOr: {
      _hx_name: "ABTFilterOperatorCompoundOr",
      _hx_index: 12,
      __enum__: "apptimize.filter.ABTFilterOperator",
      toString: n
    },
    ABTFilterOperatorCompoundAnd: {
      _hx_name: "ABTFilterOperatorCompoundAnd",
      _hx_index: 13,
      __enum__: "apptimize.filter.ABTFilterOperator",
      toString: n
    },
    ABTFilterOperatorCompoundSingleNot: {
      _hx_name: "ABTFilterOperatorCompoundSingleNot",
      _hx_index: 14,
      __enum__: "apptimize.filter.ABTFilterOperator",
      toString: n
    },
    ABTFilterOperatorCompoundSingleIsNull: {
      _hx_name: "ABTFilterOperatorCompoundSingleIsNull",
      _hx_index: 15,
      __enum__: "apptimize.filter.ABTFilterOperator",
      toString: n
    },
    ABTFilterOperatorCompoundSingleIsNotNull: {
      _hx_name: "ABTFilterOperatorCompoundSingleIsNotNull",
      _hx_index: 16,
      __enum__: "apptimize.filter.ABTFilterOperator",
      toString: n
    },
    ABTFilterOperatorPropertyIsNull: {
      _hx_name: "ABTFilterOperatorPropertyIsNull",
      _hx_index: 17,
      __enum__: "apptimize.filter.ABTFilterOperator",
      toString: n
    },
    ABTFilterOperatorPropertyIsNotNull: {
      _hx_name: "ABTFilterOperatorPropertyIsNotNull",
      _hx_index: 18,
      __enum__: "apptimize.filter.ABTFilterOperator",
      toString: n
    },
    ABTFilterOperatorPropertyIsRecognized: {
      _hx_name: "ABTFilterOperatorPropertyIsRecognized",
      _hx_index: 19,
      __enum__: "apptimize.filter.ABTFilterOperator",
      toString: n
    },
    ABTFilterOperatorPropertyIsNotRecognized: {
      _hx_name: "ABTFilterOperatorPropertyIsNotRecognized",
      _hx_index: 20,
      __enum__: "apptimize.filter.ABTFilterOperator",
      toString: n
    },
    ABTFilterOperatorOperatorIsRecognized: {
      _hx_name: "ABTFilterOperatorOperatorIsRecognized",
      _hx_index: 21,
      __enum__: "apptimize.filter.ABTFilterOperator",
      toString: n
    },
    ABTFilterOperatorOperatorIsNotRecognized: {
      _hx_name: "ABTFilterOperatorOperatorIsNotRecognized",
      _hx_index: 22,
      __enum__: "apptimize.filter.ABTFilterOperator",
      toString: n
    },
    ABTFilterOperatorValueOf: {
      _hx_name: "ABTFilterOperatorValueOf",
      _hx_index: 23,
      __enum__: "apptimize.filter.ABTFilterOperator",
      toString: n
    }
  };
  Z.__constructs__ = [Z.ABTFilterOperatorUnknown, Z.ABTFilterOperatorEquals, Z.ABTFilterOperatorNotEquals, Z.ABTFilterOperatorRegex, Z.ABTFilterOperatorNotRegex, Z.ABTFilterOperatorGreaterThan, Z.ABTFilterOperatorGreaterThanOrEqual, Z.ABTFilterOperatorLessThan, Z.ABTFilterOperatorLessThanOrEqual, Z.ABTFilterOperatorInList, Z.ABTFilterOperatorNotInList, Z.ABTFilterOperatorIntersection, Z.ABTFilterOperatorCompoundOr, Z.ABTFilterOperatorCompoundAnd, Z.ABTFilterOperatorCompoundSingleNot, Z.ABTFilterOperatorCompoundSingleIsNull, Z.ABTFilterOperatorCompoundSingleIsNotNull, Z.ABTFilterOperatorPropertyIsNull, Z.ABTFilterOperatorPropertyIsNotNull, Z.ABTFilterOperatorPropertyIsRecognized, Z.ABTFilterOperatorPropertyIsNotRecognized, Z.ABTFilterOperatorOperatorIsRecognized, Z.ABTFilterOperatorOperatorIsNotRecognized, Z.ABTFilterOperatorValueOf];

  var Q = function Q() {};

  (r["apptimize.filter.ABTFilter"] = Q).__name__ = "apptimize.filter.ABTFilter", Q.filterFromJSON = function (e) {
    var t = Q.filterForTypeFromJSON(e),
        r = Q.classForType(t);
    if (null == r) return d.e("Unable to find filter type: " + O.string(t), {
      fileName: "src/apptimize/filter/ABTFilter.hx",
      lineNumber: 110,
      className: "apptimize.filter.ABTFilter",
      methodName: "filterFromJSON"
    }), null;
    var i = P.createInstance(r, []);
    return i.fromJSON(e), i;
  }, Q.classForType = function (e) {
    return e == X.ABTFilterTypeSimple ? $ : e == X.ABTFilterTypeCompound ? ee : e == X.ABTFilterTypeList ? te : e == X.ABTFilterTypeSet ? re : e == X.ABTFilterTypeNamed ? ae : ie;
  }, Q.filterForTypeFromJSON = function (e) {
    var t = Q.operatorFromString(k.field(e, Q.kABTFilterKeyOperator));
    return Q.typeFromOperator(t);
  }, Q.operatorFromString = function (e) {
    return "=" == e ? Z.ABTFilterOperatorEquals : "!=" == e ? Z.ABTFilterOperatorNotEquals : "regex" == e ? Z.ABTFilterOperatorRegex : "not_regex" == e ? Z.ABTFilterOperatorNotRegex : ">" == e ? Z.ABTFilterOperatorGreaterThan : ">=" == e ? Z.ABTFilterOperatorGreaterThanOrEqual : "<" == e ? Z.ABTFilterOperatorLessThan : "<=" == e ? Z.ABTFilterOperatorLessThanOrEqual : "in" == e ? Z.ABTFilterOperatorInList : "not_in" == e ? Z.ABTFilterOperatorNotInList : "intersection" == e ? Z.ABTFilterOperatorIntersection : "or" == e ? Z.ABTFilterOperatorCompoundOr : "and" == e ? Z.ABTFilterOperatorCompoundAnd : "not" == e ? Z.ABTFilterOperatorCompoundSingleNot : "is_null" == e ? Z.ABTFilterOperatorCompoundSingleIsNull : "is_not_null" == e ? Z.ABTFilterOperatorCompoundSingleIsNotNull : "is_property_null" == e ? Z.ABTFilterOperatorPropertyIsNull : "is_property_not_null" == e ? Z.ABTFilterOperatorPropertyIsNotNull : "is_recognized_property" == e ? Z.ABTFilterOperatorPropertyIsRecognized : "is_not_recognized_property" == e ? Z.ABTFilterOperatorPropertyIsNotRecognized : "is_recognized_operator" == e ? Z.ABTFilterOperatorOperatorIsRecognized : "is_not_recognized_operator" == e ? Z.ABTFilterOperatorOperatorIsNotRecognized : "value_of" == e ? Z.ABTFilterOperatorValueOf : Z.ABTFilterOperatorUnknown;
  }, Q.typeFromOperator = function (e) {
    switch (e._hx_index) {
      case 0:
        break;

      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
      case 8:
        return X.ABTFilterTypeSimple;

      case 9:
      case 10:
        return X.ABTFilterTypeList;

      case 11:
        return X.ABTFilterTypeSet;

      case 12:
      case 13:
      case 14:
      case 15:
      case 16:
        return X.ABTFilterTypeCompound;

      case 17:
      case 18:
      case 19:
      case 20:
      case 21:
      case 22:
        return X.ABTFilterTypePropertyless;

      case 23:
        return X.ABTFilterTypeNamed;
    }

    return d.e("Unknown filter type. Filter match is unknown.", {
      fileName: "src/apptimize/filter/ABTFilter.hx",
      lineNumber: 298,
      className: "apptimize.filter.ABTFilter",
      methodName: "typeFromOperator"
    }), X.ABTFilterTypeUnknown;
  }, Q.prototype = {
    property: null,
    propertySource: null,
    value: null,
    filterType: null,
    filterOperator: null,
    callServerURLKey: null,
    fromJSON: function fromJSON(e) {
      var t = k.field(e, Q.kABTFilterKeyProperty);
      null != t ? (this.property = t, this.propertySource = W.ABTFilterPropertySourceDevice) : null != (t = k.field(e, Q.kABTFilterKeyUserAttribute)) ? (this.property = t, this.propertySource = W.ABTFilterPropertySourceUser) : null != (t = k.field(e, Q.kABTFilterKeyPrefixedAttribute)) && (this.property = t, this.propertySource = W.ABTFilterPropertySourcePrefixed), this.filterOperator = Q.operatorFromString(k.field(e, Q.kABTFilterKeyOperator)), this.filterType = Q.filterForTypeFromJSON(e), this.filterType == X.ABTFilterTypeUnknown && (d.w("Unknown filter type: setting value without type checking.", {
        fileName: "src/apptimize/filter/ABTFilter.hx",
        lineNumber: 149,
        className: "apptimize.filter.ABTFilter",
        methodName: "fromJSON"
      }), this.value = k.field(e, Q.kABTFilterKeyValue)), this.callServerURLKey = k.field(e, Q.kABTFilterKeyCallURLKey);
    },
    isSupportedOperator: function isSupportedOperator(e) {
      return Q.operatorFromString(e) != Z.ABTFilterOperatorUnknown;
    },
    isSupportedProperty: function isSupportedProperty(e, t, r) {
      var i = null != e.valueForProperty(t, r);
      return i || d.d('Property "' + t + '" not found which is expected by a filter.', {
        fileName: "src/apptimize/filter/ABTFilter.hx",
        lineNumber: 166,
        className: "apptimize.filter.ABTFilter",
        methodName: "isSupportedProperty"
      }), i;
    },
    currentDeviceValue: function currentDeviceValue(e) {
      return e.valueForProperty(this.property, this.propertySource);
    },
    hasSupportedProperty: function hasSupportedProperty(e) {
      return this.isSupportedProperty(e, this.property, this.propertySource);
    },
    filterMatchesEnvironment: function filterMatchesEnvironment(e) {
      return d.e("Unknown filter type. Filter match is unknown.", {
        fileName: "src/apptimize/filter/ABTFilter.hx",
        lineNumber: 181,
        className: "apptimize.filter.ABTFilter",
        methodName: "filterMatchesEnvironment"
      }), J.ABTFilterResultUnknown;
    },
    getUrlKeys: function getUrlKeys() {
      return null == this.callServerURLKey ? [] : [this.callServerURLKey];
    },
    __class__: Q
  };

  var $ = function $() {
    Q.call(this);
  };

  (r["apptimize.filter.ABTSimpleFilter"] = $).__name__ = "apptimize.filter.ABTSimpleFilter", $.__super__ = Q, $.prototype = a(Q.prototype, {
    fromJSON: function fromJSON(e) {
      Q.prototype.fromJSON.call(this, e), this.value = k.field(e, Q.kABTFilterKeyValue);
    },
    filterMatchesEnvironment: function filterMatchesEnvironment(e) {
      if (!this.hasSupportedProperty(e)) return J.ABTFilterResultUnknown;
      var t = this.currentDeviceValue(e),
          r = this.value;
      return null == t || null == r ? (d.w("Filter has null value type. Filter match is unknown.", {
        fileName: "src/apptimize/filter/ABTFilter.hx",
        lineNumber: 329,
        className: "apptimize.filter.ABTSimpleFilter",
        methodName: "filterMatchesEnvironment"
      }), J.ABTFilterResultUnknown) : or.getClass(t) == String ? P.typeof(r) == p.TFloat || P.typeof(r) == p.TInt ? se.ABTEvaluateNumber(t, this.filterOperator, r) : or.getClass(r) != String ? (d.w("Filter value does not match property type of string. Filter match is unknown.", {
        fileName: "src/apptimize/filter/ABTFilter.hx",
        lineNumber: 340,
        className: "apptimize.filter.ABTSimpleFilter",
        methodName: "filterMatchesEnvironment"
      }), J.ABTFilterResultUnknown) : "apptimize_version" == this.property || "system_version" == this.property || "app_version" == this.property || "operating_system_version" == this.property ? se.ABTEvaluateVersionString(t, this.filterOperator, r) : se.ABTEvaluateString(t, this.filterOperator, r) : P.typeof(t) == p.TFloat || P.typeof(t) == p.TInt ? or.getClass(r) == String ? se.ABTEvaluateNumber(t, this.filterOperator, r) : P.typeof(r) != p.TFloat && P.typeof(r) != p.TInt ? (d.w("Filter value does not match property type of number. Filter match is unknown.", {
        fileName: "src/apptimize/filter/ABTFilter.hx",
        lineNumber: 358,
        className: "apptimize.filter.ABTSimpleFilter",
        methodName: "filterMatchesEnvironment"
      }), J.ABTFilterResultUnknown) : se.ABTEvaluateNumber(t, this.filterOperator, r) : P.typeof(t) == p.TBool ? (or.getClass(r) == String && ("true" == r.toLowerCase() ? r = !0 : "false" == r.toLowerCase() && (r = !1)), se.ABTEvaluateBool(t, this.filterOperator, r)) : (d.w("Simple filter match is unknown.", {
        fileName: "src/apptimize/filter/ABTFilter.hx",
        lineNumber: 378,
        className: "apptimize.filter.ABTSimpleFilter",
        methodName: "filterMatchesEnvironment"
      }), J.ABTFilterResultUnknown);
    },
    __class__: $
  });

  var ee = function ee() {
    Q.call(this);
  };

  (r["apptimize.filter.ABTCompoundFilter"] = ee).__name__ = "apptimize.filter.ABTCompoundFilter", ee.__super__ = Q, ee.prototype = a(Q.prototype, {
    fromJSON: function fromJSON(e) {
      Q.prototype.fromJSON.call(this, e);

      for (var t = [], r = e.value, i = 0; i < r.length;) {
        var n = r[i];
        ++i;
        var a = Q.filterFromJSON(n);
        t.push(a);
      }

      this.value = t;
    },
    filterMatchesEnvironment: function filterMatchesEnvironment(e) {
      var t = this.value;
      if (t.length < 1) return d.w('Compound filter "' + O.string(this) + '" has an empty compound set. Filter match is unknown.', {
        fileName: "src/apptimize/filter/ABTFilter.hx",
        lineNumber: 407,
        className: "apptimize.filter.ABTCompoundFilter",
        methodName: "filterMatchesEnvironment"
      }), J.ABTFilterResultUnknown;

      if (this.filterOperator == Z.ABTFilterOperatorCompoundAnd) {
        for (var r = J.ABTFilterResultTrue, i = 0; i < t.length;) {
          var n = t[i];
          ++i;
          var a = n.filterMatchesEnvironment(e);
          r = se.ABTFilterAnd(r, a);
        }

        return r;
      }

      if (this.filterOperator == Z.ABTFilterOperatorCompoundOr) {
        var r = J.ABTFilterResultFalse;

        for (i = 0; i < t.length;) {
          n = t[i];
          ++i;
          a = n.filterMatchesEnvironment(e);
          r = se.ABTFilterOr(r, a);
        }

        return r;
      }

      return this.filterOperator == Z.ABTFilterOperatorCompoundSingleNot && 1 == t.length ? ((r = t[0].filterMatchesEnvironment(e)) == J.ABTFilterResultFalse ? r = J.ABTFilterResultTrue : r == J.ABTFilterResultTrue && (r = J.ABTFilterResultFalse), r) : this.filterOperator == Z.ABTFilterOperatorCompoundSingleIsNull && 1 == t.length ? r = t[0].filterMatchesEnvironment(e) == J.ABTFilterResultUnknown ? J.ABTFilterResultTrue : J.ABTFilterResultFalse : this.filterOperator == Z.ABTFilterOperatorCompoundSingleIsNotNull && 1 == t.length ? t[0].filterMatchesEnvironment(e) != J.ABTFilterResultUnknown ? J.ABTFilterResultTrue : J.ABTFilterResultFalse : (d.w('Filter "' + O.string(this) + '" has an unsupported compound operator or children count. Filter match is unknown.', {
        fileName: "src/apptimize/filter/ABTFilter.hx",
        lineNumber: 463,
        className: "apptimize.filter.ABTCompoundFilter",
        methodName: "filterMatchesEnvironment"
      }), J.ABTFilterResultUnknown);
    },
    getUrlKeys: function getUrlKeys() {
      for (var e = [], t = 0, r = this.value; t < r.length;) {
        var i = r[t++];
        e.push(i.getUrlKeys());
      }

      for (var n = [], a = _r(e); a.hasNext();) {
        for (i = _r(a.next()); i.hasNext();) {
          var s = i.next();
          n.push(s);
        }
      }

      var l = F.array(n);
      return null == this.callServerURLKey ? l : [this.callServerURLKey].concat(l);
    },
    __class__: ee
  });

  var te = function te() {
    Q.call(this);
  };

  (r["apptimize.filter.ABTListFilter"] = te).__name__ = "apptimize.filter.ABTListFilter", te.__super__ = Q, te.prototype = a(Q.prototype, {
    fromJSON: function fromJSON(e) {
      Q.prototype.fromJSON.call(this, e), this.value = e.value;
    },
    filterMatchesEnvironment: function filterMatchesEnvironment(e) {
      if (!this.hasSupportedProperty(e)) return J.ABTFilterResultUnknown;
      var t = this.value,
          r = this.currentDeviceValue(e);
      if (null == r) return d.w('Filter "' + O.string(this) + '" is attempting to match against a null device property.', {
        fileName: "src/apptimize/filter/ABTFilter.hx",
        lineNumber: 502,
        className: "apptimize.filter.ABTListFilter",
        methodName: "filterMatchesEnvironment"
      }), -1 < t.indexOf(r) ? this.filterOperator == Z.ABTFilterOperatorInList ? J.ABTFilterResultTrue : J.ABTFilterResultFalse : this.filterOperator == Z.ABTFilterOperatorInList ? J.ABTFilterResultFalse : J.ABTFilterResultTrue;

      for (var i = !1, n = 0; n < t.length;) {
        var a = t[n];
        ++n, i = or.getClass(r) == String ? i || se.ABTEvaluateString(r, Z.ABTFilterOperatorEquals, a) == J.ABTFilterResultTrue : i || se.ABTEvaluateNumber(r, Z.ABTFilterOperatorEquals, a) == J.ABTFilterResultTrue;
      }

      return this.filterOperator == Z.ABTFilterOperatorNotInList ? i ? J.ABTFilterResultFalse : J.ABTFilterResultTrue : i ? J.ABTFilterResultTrue : J.ABTFilterResultFalse;
    },
    __class__: te
  });

  var re = function re() {
    Q.call(this);
  };

  (r["apptimize.filter.ABTSetFilter"] = re).__name__ = "apptimize.filter.ABTSetFilter", re.__super__ = Q, re.prototype = a(Q.prototype, {
    fromJSON: function fromJSON(e) {
      Q.prototype.fromJSON.call(this, e);

      for (var t = [], r = e.value, i = 0; i < r.length;) {
        var n = r[i];
        ++i, t.push(n);
      }

      this.value = t;
    },
    filterMatchesEnvironment: function filterMatchesEnvironment(e) {
      if (this.filterOperator != Z.ABTFilterOperatorIntersection) return d.v("Set filter with unsupported operator " + O.string(this.filterOperator), {
        fileName: "src/apptimize/filter/ABTFilter.hx",
        lineNumber: 554,
        className: "apptimize.filter.ABTSetFilter",
        methodName: "filterMatchesEnvironment"
      }), J.ABTFilterResultUnknown;
      var t = e.secondaryUrlForKey(this.callServerURLKey);
      if (null == t) return J.ABTFilterResultUnknown;
      var r = e.getSecondaryValuesForUrl(t);
      if (null == r) return J.ABTFilterResultUnknown;
      var i = this.value;
      if (null == i) return d.v("Set filter with a non-list value", {
        fileName: "src/apptimize/filter/ABTFilter.hx",
        lineNumber: 573,
        className: "apptimize.filter.ABTSetFilter",
        methodName: "filterMatchesEnvironment"
      }), J.ABTFilterResultUnknown;

      for (var n = [], a = 0, s = r; a < s.length;) {
        var l = s[a];
        ++a, 0 <= i.indexOf(l) && n.push(l);
      }

      return 0 == n.length ? J.ABTFilterResultFalse : J.ABTFilterResultTrue;
    },
    __class__: re
  });

  var ie = function ie() {
    Q.call(this);
  };

  (r["apptimize.filter.ABTUnknownFilter"] = ie).__name__ = "apptimize.filter.ABTUnknownFilter", ie.__super__ = Q, ie.prototype = a(Q.prototype, {
    fromJSON: function fromJSON(e) {
      Q.prototype.fromJSON.call(this, e);
    },
    filterMatchesEnvironment: function filterMatchesEnvironment(e) {
      return d.e("Unknown filter requested. Filter match is unknown.", {
        fileName: "src/apptimize/filter/ABTFilter.hx",
        lineNumber: 599,
        className: "apptimize.filter.ABTUnknownFilter",
        methodName: "filterMatchesEnvironment"
      }), J.ABTFilterResultUnknown;
    },
    __class__: ie
  });

  var ne = function ne() {
    Q.call(this);
  };

  (r["apptimize.filter.ABTPropertylessFilter"] = ne).__name__ = "apptimize.filter.ABTPropertylessFilter", ne.__super__ = Q, ne.prototype = a(Q.prototype, {
    fromJSON: function fromJSON(e) {
      Q.prototype.fromJSON.call(this, e), this.value = k.field(e, Q.kABTFilterKeyValue);
    },
    filterMatchesEnvironment: function filterMatchesEnvironment(e) {
      var t = this.value;
      if (null == t || or.getClass(t) != String) return d.w("Property-less filter requires a string value. Filter match is unknown.", {
        fileName: "src/apptimize/filter/ABTFilter.hx",
        lineNumber: 619,
        className: "apptimize.filter.ABTPropertylessFilter",
        methodName: "filterMatchesEnvironment"
      }), J.ABTFilterResultUnknown;
      var r = t;
      return this.filterOperator == Z.ABTFilterOperatorPropertyIsNull ? null == e.valueForProperty(r, W.ABTFilterPropertySourceDevice) ? J.ABTFilterResultTrue : J.ABTFilterResultFalse : this.filterOperator == Z.ABTFilterOperatorPropertyIsNotNull ? null != e.valueForProperty(r, W.ABTFilterPropertySourceDevice) ? J.ABTFilterResultTrue : J.ABTFilterResultFalse : this.filterOperator == Z.ABTFilterOperatorPropertyIsRecognized ? 1 == this.isSupportedProperty(e, r, W.ABTFilterPropertySourceDevice) ? J.ABTFilterResultTrue : J.ABTFilterResultFalse : this.filterOperator == Z.ABTFilterOperatorPropertyIsNotRecognized ? 0 == this.isSupportedProperty(e, r, W.ABTFilterPropertySourceDevice) ? J.ABTFilterResultTrue : J.ABTFilterResultFalse : this.filterOperator == Z.ABTFilterOperatorOperatorIsRecognized ? 1 == this.isSupportedOperator(r) ? J.ABTFilterResultTrue : J.ABTFilterResultFalse : this.filterOperator == Z.ABTFilterOperatorOperatorIsNotRecognized ? 0 == this.isSupportedOperator(r) ? J.ABTFilterResultTrue : J.ABTFilterResultFalse : (d.w("Property-less filter attempted with an invalid operator. Filter match is unknown.", {
        fileName: "src/apptimize/filter/ABTFilter.hx",
        lineNumber: 651,
        className: "apptimize.filter.ABTPropertylessFilter",
        methodName: "filterMatchesEnvironment"
      }), J.ABTFilterResultUnknown);
    },
    __class__: ne
  });

  var ae = function ae() {
    Q.call(this);
  };

  (r["apptimize.filter.ABTNamedFilterProxy"] = ae).__name__ = "apptimize.filter.ABTNamedFilterProxy", ae.__super__ = Q, ae.prototype = a(Q.prototype, {
    namedFilter: null,
    fromJSON: function fromJSON(e) {
      Q.prototype.fromJSON.call(this, e), this.namedFilter = k.field(e, Q.kABTFilterKeyNamedFilter);
    },
    filterMatchesEnvironment: function filterMatchesEnvironment(e) {
      return e.namedFilterResult(this.namedFilter);
    },
    __class__: ae
  });

  var se = function se() {};

  (r["apptimize.filter.ABTFilterUtils"] = se).__name__ = "apptimize.filter.ABTFilterUtils", se.ABTFilterAnd = function (e, t) {
    return e == J.ABTFilterResultTrue && t == J.ABTFilterResultUnknown ? J.ABTFilterResultUnknown : e == J.ABTFilterResultTrue && t == J.ABTFilterResultFalse ? J.ABTFilterResultFalse : e == J.ABTFilterResultUnknown && t == J.ABTFilterResultFalse ? J.ABTFilterResultFalse : e;
  }, se.ABTFilterOr = function (e, t) {
    return e == J.ABTFilterResultUnknown && t == J.ABTFilterResultFalse ? J.ABTFilterResultUnknown : e == J.ABTFilterResultTrue && t == J.ABTFilterResultFalse ? J.ABTFilterResultTrue : e == J.ABTFilterResultTrue && t == J.ABTFilterResultUnknown ? J.ABTFilterResultTrue : t;
  }, se.ABTEvaluateString = function (e, t, r) {
    var i = "",
        n = "";
    return null == e || null == r ? (d.w("String comparison attempted with null string. Filter match is unknown.", {
      fileName: "src/apptimize/filter/ABTFilter.hx",
      lineNumber: 703,
      className: "apptimize.filter.ABTFilterUtils",
      methodName: "ABTEvaluateString"
    }), J.ABTFilterResultUnknown) : (or.getClass(e) == String && (i = e), or.getClass(r) == String && (n = r), i = i.toLowerCase(), n = n.toLowerCase(), t == Z.ABTFilterOperatorEquals ? i == n ? J.ABTFilterResultTrue : J.ABTFilterResultFalse : t == Z.ABTFilterOperatorNotEquals ? i != n ? J.ABTFilterResultTrue : J.ABTFilterResultFalse : (d.w("String comparison attempted with an invalid operator. Filter match is unknown.", {
      fileName: "src/apptimize/filter/ABTFilter.hx",
      lineNumber: 723,
      className: "apptimize.filter.ABTFilterUtils",
      methodName: "ABTEvaluateString"
    }), J.ABTFilterResultUnknown));
  }, se.ABTEvaluateBool = function (e, t, r) {
    return t == Z.ABTFilterOperatorEquals ? e == r ? J.ABTFilterResultTrue : J.ABTFilterResultFalse : t == Z.ABTFilterOperatorNotEquals ? e != r ? J.ABTFilterResultTrue : J.ABTFilterResultFalse : (d.w("Bool comparison attempted with an invalid operator. Filter match is unknown.", {
      fileName: "src/apptimize/filter/ABTFilter.hx",
      lineNumber: 732,
      className: "apptimize.filter.ABTFilterUtils",
      methodName: "ABTEvaluateBool"
    }), J.ABTFilterResultUnknown);
  }, se.ABTEvaluateNumber = function (e, t, r) {
    var i, n;
    return null == e || null == r ? J.ABTFilterResultUnknown : (i = or.getClass(e) == String ? parseFloat(e) : e, n = or.getClass(r) == String ? parseFloat(r) : r, t == Z.ABTFilterOperatorEquals ? i == n ? J.ABTFilterResultTrue : J.ABTFilterResultFalse : t == Z.ABTFilterOperatorNotEquals ? i != n ? J.ABTFilterResultTrue : J.ABTFilterResultFalse : t == Z.ABTFilterOperatorGreaterThan ? n < i ? J.ABTFilterResultTrue : J.ABTFilterResultFalse : t == Z.ABTFilterOperatorGreaterThanOrEqual ? n <= i ? J.ABTFilterResultTrue : J.ABTFilterResultFalse : t == Z.ABTFilterOperatorLessThan ? i < n ? J.ABTFilterResultTrue : J.ABTFilterResultFalse : t == Z.ABTFilterOperatorLessThanOrEqual ? i <= n ? J.ABTFilterResultTrue : J.ABTFilterResultFalse : (d.w("Number comparison attempted with an invalid operator. Filter match is unknown.", {
      fileName: "src/apptimize/filter/ABTFilter.hx",
      lineNumber: 764,
      className: "apptimize.filter.ABTFilterUtils",
      methodName: "ABTEvaluateNumber"
    }), J.ABTFilterResultUnknown));
  }, se.ABTEvaluateVersionString = function (e, t, r) {
    if (null != e && "" != e || (e = "0"), null != r && "" != r || (r = "0"), or.getClass(e) != String || or.getClass(r) != String) return d.w("Unable to compare versions as values are not strings. Filter match is unknown.", {
      fileName: "src/apptimize/filter/ABTFilter.hx",
      lineNumber: 782,
      className: "apptimize.filter.ABTFilterUtils",
      methodName: "ABTEvaluateVersionString"
    }), J.ABTFilterResultUnknown;
    var i = e,
        n = r,
        a = i.split("."),
        s = n.split("."),
        l = a.length;
    if (l < 3) for (var o = l, u = 3; o < u;) {
      o++;
      a.push("0");
    }
    var p,
        c,
        h = s.length;
    if (h < 3) for (o = h, u = 3; o < u;) {
      o++;
      s.push("0");
    }
    i = a.join("."), n = s.join(".");

    try {
      p = cr.stringToVersion(i);
    } catch (o) {
      return gt.lastError = o, d.w("Unable to validate left (current) version: " + i + ". Filter match is unknown.", {
        fileName: "src/apptimize/filter/ABTFilter.hx",
        lineNumber: 822,
        className: "apptimize.filter.ABTFilterUtils",
        methodName: "ABTEvaluateVersionString"
      }), J.ABTFilterResultUnknown;
    }

    try {
      c = cr.stringToVersion(n);
    } catch (o) {
      return gt.lastError = o, d.w("Unable to validate right (filter) version: " + n + ". Filter match is unknown.", {
        fileName: "src/apptimize/filter/ABTFilter.hx",
        lineNumber: 828,
        className: "apptimize.filter.ABTFilterUtils",
        methodName: "ABTEvaluateVersionString"
      }), J.ABTFilterResultUnknown;
    }

    return t == Z.ABTFilterOperatorEquals ? cr.equals(p, c) ? J.ABTFilterResultTrue : J.ABTFilterResultFalse : t == Z.ABTFilterOperatorNotEquals ? cr.equals(p, c) ? J.ABTFilterResultFalse : J.ABTFilterResultTrue : t == Z.ABTFilterOperatorGreaterThan ? cr.greaterThan(p, c) ? J.ABTFilterResultTrue : J.ABTFilterResultFalse : t == Z.ABTFilterOperatorGreaterThanOrEqual ? cr.greaterThanOrEqual(p, c) ? J.ABTFilterResultTrue : J.ABTFilterResultFalse : t == Z.ABTFilterOperatorLessThan ? cr.lessThan(p, c) ? J.ABTFilterResultTrue : J.ABTFilterResultFalse : t == Z.ABTFilterOperatorLessThanOrEqual ? cr.lessThanOrEqual(p, c) ? J.ABTFilterResultTrue : J.ABTFilterResultFalse : (d.w("Version comparison attempted with an invalid operator. Filter match is unknown.", {
      fileName: "src/apptimize/filter/ABTFilter.hx",
      lineNumber: 840,
      className: "apptimize.filter.ABTFilterUtils",
      methodName: "ABTEvaluateVersionString"
    }), J.ABTFilterResultUnknown);
  };

  var le = function le(e, t, r, i, n, a) {
    this.userID = e, this.anonID = t, this.internalProps = a, this.customAttrs = r, this.appkey = i, this.appProps = n;
  };

  (r["apptimize.filter.ABTFilterEnvParams"] = le).__name__ = "apptimize.filter.ABTFilterEnvParams", le.prototype = {
    userID: null,
    anonID: null,
    customAttrs: null,
    appProps: null,
    appkey: null,
    internalProps: null,
    __class__: le
  };

  var oe = function oe(e, t, r, i, n, a) {
    this.userID = e.userID, this.anonID = e.anonID, this.customProperties = new We(), this.secondaryValueUrlTemplates = t, this.secondaryValueLists = r, this.applicationProperties = e.appProps, this.internalProperties = e.internalProps, this.appkey = e.appkey, this.sequenceNumber = i, null != e.customAttrs && this.customProperties.setProperties(e.customAttrs), this.customProperties.setPropertyForNamespace("app_key", e.appkey, Je.ApptimizeLocal), this.namedFilters = n, null == this.namedFilters && (this.namedFilters = []);

    for (var s = new D(), l = 0, o = this.namedFilters; l < o.length;) {
      var u = o[l];
      ++l, s.h[u.filterName] = u;
    }

    this.namedFilterCalculator = new ue(s, a, []);
  };

  (r["apptimize.filter.ABTFilterEnvironment"] = oe).__name__ = "apptimize.filter.ABTFilterEnvironment", oe.prototype = {
    userID: null,
    anonID: null,
    customProperties: null,
    applicationProperties: null,
    internalProperties: null,
    sequenceNumber: null,
    appkey: null,
    secondaryValueUrlTemplates: null,
    secondaryValueLists: null,
    namedFilters: null,
    namedFilterCalculator: null,
    hash: function hash() {
      var e = new $e(),
          t = [null == this.userID ? this.anonID : this.userID, this.customProperties.availableProperties, this.applicationProperties.availableProperties, this.internalProperties.availableProperties, this.secondaryValueLists, this.secondaryValueUrlTemplates, this.sequenceNumber];
      return e.push(bt.ofString(Pt.print(t, null, null))), e.hash().toHex();
    },
    getUniqueUserID: function getUniqueUserID() {
      return this.appkey + "_" + this.getUserOrAnonID();
    },
    getUserOrAnonID: function getUserOrAnonID() {
      return null != this.userID ? this.userID : this.anonID;
    },
    getUserID: function getUserID() {
      return this.userID;
    },
    getAnonID: function getAnonID() {
      return this.anonID;
    },
    getSecondaryValuesForUrl: function getSecondaryValuesForUrl(e) {
      return this.secondaryValueLists.h[e];
    },
    valueForProperty: function valueForProperty(e, t) {
      if (t == W.ABTFilterPropertySourceDevice) return this.applicationProperties.valueForProperty(e);
      if (t == W.ABTFilterPropertySourceUser) return this.customProperties.valueForNamespacedProperty(e, Je.UserAttribute);

      if (t == W.ABTFilterPropertySourcePrefixed) {
        var r = this.customProperties.valueForProperty(e);
        return null == r && (r = this.internalProperties.valueForProperty(e)), r;
      }

      return null;
    },
    namedFilterResult: function namedFilterResult(e) {
      return this.namedFilterCalculator.resolve(e, this);
    },
    secondaryUrlForKey: function secondaryUrlForKey(e) {
      if (null == e || "" == e) return null;
      var t = this.secondaryValueUrlTemplates.h[e];
      if (null == t) return d.e("unknown secondary url key " + e, {
        fileName: "src/apptimize/filter/ABTFilterEnvironment.hx",
        lineNumber: 160,
        className: "apptimize.filter.ABTFilterEnvironment",
        methodName: "secondaryUrlForKey"
      }), null;
      var r = this.injectPropsInUrlTemplate(t);
      if (null == r) return null;
      var i = "&";
      return -1 == r.indexOf("?") && (i = "?"), "" + r + i + "metadataSequenceNumber=" + this.sequenceNumber;
    },
    injectPropsInUrlTemplate: function injectPropsInUrlTemplate(e) {
      var i = this,
          t = new o("\\{([^}]+)}", "g"),
          n = !1,
          r = t.map(e, function (e) {
        var t = e.matched(1),
            r = i.valueForProperty(t, W.ABTFilterPropertySourcePrefixed);
        return null == r ? (n = !0, "<MISSING:" + t + "}>") : encodeURIComponent(r);
      });
      return n ? null : r;
    },
    __class__: oe
  };

  var ue = function ue(e, t, r) {
    this.allNamedFilters = e, this.evaluations = t, this.evaluationStack = r;
  };

  (r["apptimize.filter.ABTNamedFilterCalculator"] = ue).__name__ = "apptimize.filter.ABTNamedFilterCalculator", ue.prototype = {
    allNamedFilters: null,
    evaluations: null,
    evaluationStack: null,
    resolve: function resolve(e, t) {
      var r = this.allNamedFilters.h[e];
      if (null == r) return d.e("Failed to resolve filter " + e, {
        fileName: "src/apptimize/filter/ABTFilterEnvironment.hx",
        lineNumber: 230,
        className: "apptimize.filter.ABTNamedFilterCalculator",
        methodName: "resolve"
      }), J.ABTFilterResultUnknown;
      var i = this.getExistingResult(r);
      if (null != i) return i;
      if (-1 != this.evaluationStack.indexOf(e)) return d.e("Found a circular reference on resolving " + e, {
        fileName: "src/apptimize/filter/ABTFilterEnvironment.hx",
        lineNumber: 241,
        className: "apptimize.filter.ABTNamedFilterCalculator",
        methodName: "resolve"
      }), J.ABTFilterResultUnknown;
      this.evaluationStack.push(e);
      var n = r.performFilterMatchingWithEnvironment(t).result;
      return this.evaluations.h[e] = n, Y.remove(this.evaluationStack, e), n;
    },
    getExistingResult: function getExistingResult(e) {
      if (!Object.prototype.hasOwnProperty.call(this.evaluations.h, e.filterName)) return null;
      var t = this.evaluations.h[e.filterName];
      return t == J.ABTFilterResultTrue && e.trueIsSticky || t == J.ABTFilterResultFalse && e.falseIsSticky || t == J.ABTFilterResultUnknown && e.nullIsSticky ? t : null;
    },
    __class__: ue
  };

  var pe = function pe() {
    this.initialize();
  };

  (r["apptimize.filter.ABTFilterableObject"] = pe).__name__ = "apptimize.filter.ABTFilterableObject", pe.prototype = {
    filters: null,
    filters2: null,
    overridingInclusiveFilters: null,
    matchingFilters: null,
    nonMatchingFilters: null,
    initialize: function initialize() {
      this.filters = [], this.filters2 = [], this.matchingFilters = [], this.nonMatchingFilters = [], this.overridingInclusiveFilters = [];
    },
    performFilterMatchingWithEnvironment: function performFilterMatchingWithEnvironment(e) {
      for (var t = {
        result: J.ABTFilterResultTrue,
        overriding: !1
      }, r = 0, i = this.filters; r < i.length;) {
        var n = i[r];
        ++r;
        var a = n.filterMatchesEnvironment(e);
        t.result = se.ABTFilterAnd(t.result, a);
      }

      for (r = 0, i = this.overridingInclusiveFilters; r < i.length;) {
        n = i[r];
        ++r, (a = n.filterMatchesEnvironment(e)) == J.ABTFilterResultTrue && (t.result = J.ABTFilterResultTrue, t.overriding = !0);
      }

      return t;
    },
    computeNewOverrideState: function computeNewOverrideState(e, t) {
      if (e) {
        if (t.overriding) return !1;
      } else if (t.result != J.ABTFilterResultTrue) return !0;

      return e;
    },
    fromJSON: function fromJSON(e) {
      this.filters = this.jsonToFilterArray(e.filters), this.filters2 = this.jsonToFilterArray(e.filters2), this.overridingInclusiveFilters = this.jsonToFilterArray(e.overridingInclusiveFilters), 0 < this.filters2.length && (this.filters = this.filters.concat(this.filters2));
    },
    jsonToFilterArray: function jsonToFilterArray(e) {
      for (var t = null == e ? [] : e, r = new Array(t.length), i = 0, n = t.length; i < n;) {
        var a = i++;
        r[a] = Q.filterFromJSON(t[a]);
      }

      return r;
    },
    getUrlKeys: function getUrlKeys() {
      return this.getLocalUrlKeys().concat(this.getUrlKeysFrom(this.getUrlKeyProviders()));
    },
    getUrlKeyProviders: function getUrlKeyProviders() {
      return [];
    },
    getUrlKeysFrom: function getUrlKeysFrom(e) {
      for (var t = [], r = 0, i = e; r < i.length;) {
        var n = i[r++];
        t.push(n.getUrlKeys());
      }

      for (var a = [], s = _r(t); s.hasNext();) {
        for (n = _r(s.next()); n.hasNext();) {
          var l = n.next();
          a.push(l);
        }
      }

      return F.array(a);
    },
    getLocalUrlKeys: function getLocalUrlKeys() {
      return this.getUrlKeysFrom(this.filters).concat(this.getUrlKeysFrom(this.overridingInclusiveFilters));
    },
    asUrlProviders: function asUrlProviders(e) {
      for (var t = new Array(e.length), r = 0, i = e.length; r < i;) {
        var n = r++;
        t[n] = e[n];
      }

      return t;
    },
    __class__: pe
  };

  var ce = function ce(e) {
    pe.call(this), this.fromJSON(e);
  };

  (r["apptimize.filter.ABTNamedFilter"] = ce).__name__ = "apptimize.filter.ABTNamedFilter", ce.__super__ = pe, ce.prototype = a(pe.prototype, {
    filterName: null,
    trueIsSticky: null,
    falseIsSticky: null,
    nullIsSticky: null,
    fromJSON: function fromJSON(e) {
      pe.prototype.fromJSON.call(this, e), this.filterName = k.field(e, ce.kABTNamedFilterKeyFilterName), this.trueIsSticky = k.field(e, ce.kABTNamedFilterKeyTrueIsSticky), this.falseIsSticky = k.field(e, ce.kABTNamedFilterKeyFalseIsSticky), this.nullIsSticky = k.field(e, ce.kABTNamedFilterKeyNullIsSticky);
    },
    __class__: ce
  });

  var he = function he() {
    this.responseCode = -1, this.text = "", this.bytes = null;
  };

  (r["apptimize.http.ABTHttpResponse"] = he).__name__ = "apptimize.http.ABTHttpResponse", he.prototype = {
    bytes: null,
    text: null,
    responseCode: null,
    etag: null,
    isSuccess: function isSuccess() {
      return 200 == this.responseCode || 304 == this.responseCode;
    },
    __class__: he
  };

  var _e = function _e() {};

  (r["apptimize.http.ABTHttpRequestInterface"] = _e).__name__ = "apptimize.http.ABTHttpRequestInterface", _e.__isInterface__ = !0, _e.prototype = {
    get: null,
    post: null,
    __class__: _e
  };

  var me = function me() {};

  (r["apptimize.http.ABTHttpRequest"] = me).__name__ = "apptimize.http.ABTHttpRequest", me.getRequestInterface = function () {
    return me.getRealRequestInterface();
  }, me.getRealRequestInterface = function () {
    return new fe();
  }, me.get = function (e, t, r, i) {
    me.getRequestInterface().get(e, t, r, i);
  }, me.post = function (e, t, r, i, n) {
    me.getRequestInterface().post(e, t, r, i, n);
  };

  var fe = function fe() {};

  (r["apptimize.http.ABTHttpRequestJS"] = fe).__name__ = "apptimize.http.ABTHttpRequestJS", fe.__interfaces__ = [_e], fe.prototype = {
    _sentDate: null,
    get: function get(n, e, a, s) {
      var l = this,
          o = new XMLHttpRequest();
      if (this._sentDate = new Date(), o.open("GET", n, !0), null != e) for (var t = e.h, r = Object.keys(t), i = r.length, u = 0; u < i;) {
        var p = r[u++];
        o.setRequestHeader(p, e.h[p]);
      }
      this._logRequest("GET", n, e), o.responseType = "arraybuffer", o.onerror = function (e) {
        var t = new he();
        o.response;
        t.responseCode = o.status, l._logResponse(n, o), s(t);
      }, o.onload = function (e) {
        var t = new he(),
            r = o.response;
        if (null == r) return r = o.responseText, t.text = "Unable to parse response on this browser.", t.responseCode = o.status, l._logResponse(n, o, bt.ofString(t.text)), void s(t);

        var i = l._getDataForResponse(r);

        l._logResponse(n, o, i), t.bytes = i.b.bufferValue, t.responseCode = o.status, t.etag = o.getResponseHeader("etag"), t.isSuccess() ? a(t) : s(t);
      }, o.send();
    },
    post: function post(n, e, t, a, s) {
      var l = this,
          o = new XMLHttpRequest();
      this._sentDate = new Date(), o.open("POST", n, !0);
      var r = new D();
      r.h["X-App-Key"] = t, r.h["Content-Type"] = "application/json; charset=UTF-8";

      for (var i = r, u = i.h, p = Object.keys(u), c = p.length, h = 0; h < c;) {
        var _ = p[h++];
        o.setRequestHeader(_, i.h[_]);
      }

      this._logRequest("POST", n, i, e), o.onerror = function (e) {
        var t = new he();
        o.response;
        t.responseCode = o.status, l._logResponse(n, o), s(t);
      }, o.onload = function (e) {
        var t = new he(),
            r = o.response;
        if (null == r) return r = o.responseText, t.text = "Unable to parse response on this browser.", t.responseCode = o.status, l._logResponse(n, o, bt.ofString(t.text)), void s(t);

        var i = l._getDataForResponse(r);

        l._logResponse(n, o, i), t.bytes = i.b.bufferValue, t.responseCode = o.status, t.isSuccess() ? a(t) : s(t);
      }, o.send(e.b.bufferValue);
    },
    _logRequest: function _logRequest(e, t, r, i) {
      if (de.shouldLog()) {
        var n = null == r ? "[]" : D.stringify(r.h),
            a = null == i ? "" : i.toString();
        de.logRequest(e, t, n, a);
      }
    },
    _logResponse: function _logResponse(e, t, r) {
      if (de.shouldLog()) {
        var i = new Date().getTime() - this._sentDate.getTime(),
            n = null == r ? "" : r.toString();

        de.logResponse(e, i, t.getAllResponseHeaders().toString(), n);
      }
    },
    _getDataForResponse: function _getDataForResponse(e) {
      if ("string" == typeof e) return bt.ofString(e);

      for (var t = new Uint8Array(e), r = new bt(new ArrayBuffer(t.length)), i = 0, n = t.length; i < n;) {
        var a = i++;
        r.b[a] = t[a];
      }

      return r;
    },
    __class__: fe
  };

  var de = function de() {};

  (r["apptimize.http.ABTNetworkLogger"] = de).__name__ = "apptimize.http.ABTNetworkLogger", de.shouldLog = function () {
    return d.logLevel == d.LOG_LEVEL_VERBOSE;
  }, de.logRequest = function (e, t, r, i) {
    d.v("URL Request " + e + " " + t + "\nHeaders: " + O.string(r) + "\nBody: " + i, {
      fileName: "src/apptimize/http/ABTNetworkLogger.hx",
      lineNumber: 9,
      className: "apptimize.http.ABTNetworkLogger",
      methodName: "logRequest"
    });
  }, de.logResponse = function (e, t, r, i) {
    d.v("URL Response " + e + "\nHeaders: " + O.string(r) + "\nBody: " + i + "\nResponse Time(ms): " + t, {
      fileName: "src/apptimize/http/ABTNetworkLogger.hx",
      lineNumber: 13,
      className: "apptimize.http.ABTNetworkLogger",
      methodName: "logResponse"
    });
  };

  var ge = function ge() {
    pe.call(this);
  };

  (r["apptimize.models.ABTAlteration"] = ge).__name__ = "apptimize.models.ABTAlteration", ge.alterationFromJSON = function (e, t) {
    var r = ge.classForType(e.type),
        i = P.createInstance(r, []);
    return i.initialize(), i.fromJSON(e), i._variant = t, i;
  }, ge.classForType = function (e) {
    return "block" == e ? ve : Ae;
  }, ge.__super__ = pe, ge.prototype = a(pe.prototype, {
    _variant: null,
    _key: null,
    fromJSON: function fromJSON(e) {
      pe.prototype.fromJSON.call(this, e);
    },
    selectAlterationsIntoArray: function selectAlterationsIntoArray(e, t, r) {
      var i = this.performFilterMatchingWithEnvironment(e);
      (i.overriding || !r) && i.result == J.ABTFilterResultTrue && (d.v('Selecting alteration "' + this.getKey() + '" for variant "' + this.getVariant().getVariantName() + '" for user ' + e.getUserOrAnonID() + ".", {
        fileName: "src/apptimize/models/ABTAlteration.hx",
        lineNumber: 50,
        className: "apptimize.models.ABTAlteration",
        methodName: "selectAlterationsIntoArray"
      }), t.push(this));
    },
    getKey: function getKey() {
      return this._key;
    },
    getVariant: function getVariant() {
      return this._variant;
    },
    __class__: ge
  });

  var ve = function ve() {
    ge.call(this);
  };

  (r["apptimize.models.ABTBlockAlteration"] = ve).__name__ = "apptimize.models.ABTBlockAlteration", ve.__super__ = ge, ve.prototype = a(ge.prototype, {
    methodName: null,
    fromJSON: function fromJSON(e) {
      ge.prototype.fromJSON.call(this, e), this._key = e.key, this.methodName = e.methodName;
    },
    __class__: ve
  });

  var Ae = function Ae() {
    ge.call(this);
  };

  (r["apptimize.models.ABTValueAlteration"] = Ae).__name__ = "apptimize.models.ABTValueAlteration", Ae.__super__ = ge, Ae.prototype = a(ge.prototype, {
    _value: null,
    _type: null,
    _nestedType: null,
    _useDefaultValue: null,
    fromJSON: function fromJSON(e) {
      ge.prototype.fromJSON.call(this, e), this._key = e.key, this._value = e.value, this._type = e.type, this._nestedType = e.nestedType, this._useDefaultValue = e.useDefaultValue, null != this._value && "dictionary" == this._type && (this._value = lt.dynamicToNativeDictionary(this._value));
    },
    useDefaultValue: function useDefaultValue() {
      return this._useDefaultValue;
    },
    getValue: function getValue() {
      return this._value;
    },
    getType: function getType() {
      return this._type;
    },
    getNestedType: function getNestedType() {
      return this._nestedType;
    },
    __class__: Ae
  });

  var Te = function Te() {};

  (r["apptimize.models.ABTJSONObject"] = Te).__name__ = "apptimize.models.ABTJSONObject";

  var ye = function ye() {
    this._alterationCache = new rt(He.sharedInstance().valueForProperty(He.ALTERATION_CACHE_SIZE_KEY)), this._namedFiltersEvaluations = new D();
  };

  (r["apptimize.models.ABTMetadata"] = ye).__name__ = "apptimize.models.ABTMetadata", ye.loadFromString = function (e) {
    var t = new ye();
    return t._load_data(e), t;
  }, ye.prototype = {
    _jsonData: null,
    _seedGroups: null,
    _hotfixes: null,
    _alterationCache: null,
    _namedFilters: null,
    _namedFiltersEvaluations: null,
    _etag: null,
    _secondaryValues: null,
    resetFilterEvaluations: function resetFilterEvaluations() {
      this._namedFiltersEvaluations.h = Object.create(null);
    },
    copyPersistentValues: function copyPersistentValues(e) {
      null != e && null != e._namedFiltersEvaluations && (this._namedFiltersEvaluations = D.createCopy(e._namedFiltersEvaluations.h));
    },
    makeEnvironment: function makeEnvironment(e, t) {
      var r = this._secondaryValues,
          i = new D(),
          n = this.getGroupsUrlTemplate("lpilot_targeting_id");
      i.h.groupsApiUrl = n;
      n = this.getGroupsUrlTemplate("m_cohort_id");
      i.h.cohortsApiUrl = n;
      var a = i;
      return null != t && null != t.callServerUrls && (a = t.callServerUrls), new oe(e, a, r, this.getSequenceNumber(), this._namedFilters, this._namedFiltersEvaluations);
    },
    getGroupsUrlTemplate: function getGroupsUrlTemplate(e) {
      return He.sharedInstance().valueForProperty(He.GROUPS_BASE_URL_KEY) + "/api/pilot-groups/?appKey={lapp_key}&pilotTargetingId={" + e + "}";
    },
    _load_data: function _load_data(e) {
      this._alterationCache = new rt(He.sharedInstance().valueForProperty(He.ALTERATION_CACHE_SIZE_KEY)), this._jsonData = new Ot(e).doParse(), this.reprocessJson();
    },
    reprocessJson: function reprocessJson() {
      if (null == this._jsonData) throw ct.thrown("Unable to process metadata");
      if (this._seedGroups = [], null != this._jsonData.seedGroups) for (var e = 0, t = this._jsonData.seedGroups; e < t.length;) {
        var r = t[e];
        ++e, this._seedGroups.push(new Ee(r));
      }
      if (this._hotfixes = [], null != this._jsonData.hotfixes) for (e = 0, t = this._jsonData.hotfixes; e < t.length;) {
        var i = t[e];
        ++e, this._hotfixes.push(new we(i));
      }
      if (d.i("JSONNamedFilters: " + O.string(this._jsonData.namedFilters), {
        fileName: "src/apptimize/models/ABTMetadata.hx",
        lineNumber: 199,
        className: "apptimize.models.ABTMetadata",
        methodName: "reprocessJson"
      }), this._namedFilters = [], null != this._jsonData.namedFilters) for (e = 0, t = this._jsonData.namedFilters; e < t.length;) {
        var n = t[e];
        ++e, this._namedFilters.push(new ce(n));
      }
    },
    getAllVariants: function getAllVariants() {
      for (var e = [], t = 0, r = this._seedGroups; t < r.length;) {
        var i = r[t];
        ++t, i.addAllVariantsIntoArray(e);
      }

      return e;
    },
    clone: function clone() {
      var e = new ye();
      return e.setEtag(this.getEtag()), e._jsonData = this._jsonData, e.copyPersistentValues(this), e.reprocessJson(), e;
    },
    uncachedSelectAlterationsIntoArray: function uncachedSelectAlterationsIntoArray(e, t) {
      null == t && (t = !0);
      var r = e.hash();

      if (t) {
        var i = this.getAlterationCacheValue(r);
        if (null != i) return i;
      }

      for (var n = [], a = 0, s = this._seedGroups; a < s.length;) {
        var l = s[a];
        ++a, l.selectAlterationsIntoArray(e, n, !1);
      }

      for (a = 0, s = this._hotfixes; a < s.length;) {
        var o = s[a];
        ++a, o.selectAlterationsIntoArray(e, n, !1);
      }

      return n;
    },
    selectAlterationsIntoArray: function selectAlterationsIntoArray(e) {
      var t = e.hash(),
          r = this.getAlterationCacheValue(t);
      if (null != r) return r;
      var i = this.uncachedSelectAlterationsIntoArray(e, !1);
      return this._alterationCache.insert(t, i), this.metadataProcessed(e, i), i;
    },
    getAlterationCacheValue: function getAlterationCacheValue(e) {
      return this._alterationCache.getValue(e);
    },
    extractNeededSecondaryUrls: function extractNeededSecondaryUrls(e) {
      for (var t = [], r = 0, i = this._seedGroups; r < i.length;) {
        var n = i[r];
        ++r, t = t.concat(n.getUrlKeys());
      }

      for (r = 0, i = this._hotfixes; r < i.length;) {
        var a = i[r];
        ++r, t = t.concat(a.getUrlKeys());
      }

      var s = [],
          l = Object.create(null);

      for (r = 0; r < t.length;) {
        var o = t[r];

        if (++r, !Object.prototype.hasOwnProperty.call(l, o)) {
          var u = e.secondaryUrlForKey(o);
          null != (l[o] = u) && s.push(u);
        }
      }

      return s;
    },
    extractSdkParameters: function extractSdkParameters(e) {
      var t = new Se(null);
      if (null != this._seedGroups) for (var r = 0, i = this._seedGroups; r < i.length;) {
        var n = i[r];
        ++r, n.applySdkParameters(t, e);
      }
      return t;
    },
    metadataProcessed: function metadataProcessed(e, t) {
      var r = new ke(e, this.getSequenceNumber(), this.getVariantsCyclesPhases(t));
      C.sharedInstance().addResultLogEntry(e, r);
    },
    getVariantsCyclesPhases: function getVariantsCyclesPhases(e) {
      for (var t = new wt(), r = 0; r < e.length;) {
        var i = e[r];
        ++r;
        var n,
            a = i.getVariant(),
            s = a.getPhase(),
            l = "v" + a.getVariantID() + "_" + a.getCycle();

        if (Xe.sharedInstance().isNamespacedPropertyAvailable(l, Je.ApptimizeInternal) && (s = Xe.sharedInstance().valueForNamespacedProperty(l, Je.ApptimizeInternal)), or.getClass(a) != we) {
          var o = a.getVariantID();
          n = !t.h.hasOwnProperty(o);
        } else n = !1;

        if (n) {
          var u = a.getVariantID(),
              p = {
            v: a.getVariantID(),
            c: a.getCycle(),
            p: s
          };
          t.h[u] = p;
        }
      }

      return F.array(t);
    },
    clearAlterationCache: function clearAlterationCache() {
      this._alterationCache.clear();
    },
    getMetaData: function getMetaData() {
      return this._jsonData;
    },
    getSequenceNumber: function getSequenceNumber() {
      return this._jsonData.sequenceNumber;
    },
    getCheckinUrls: function getCheckinUrls() {
      return this._jsonData.checkinUrls;
    },
    getAppKey: function getAppKey() {
      return this._jsonData.appKey;
    },
    getEtag: function getEtag() {
      return this._etag;
    },
    setEtag: function setEtag(e) {
      this._etag = e;
    },
    setSecondaryValues: function setSecondaryValues(e) {
      this._secondaryValues = e;
    },
    getSecondaryValues: function getSecondaryValues() {
      return this._secondaryValues;
    },
    getDisabledVersions: function getDisabledVersions() {
      var e = k.field(this._jsonData, "disableAllVersions"),
          t = k.field(this._jsonData, "disabledCrossPlatformVersions"),
          r = [];
      return e && r.push(z.getApptimizeSDKVersion()), null != t && (r = r.concat(this._jsonData.disabledCrossPlatformVersions)), r;
    },
    hxSerialize: function hxSerialize(e) {
      this.serializeV1(e), e.serialize(this._secondaryValues), e.serialize(this._namedFiltersEvaluations);
    },
    serializeV1: function serializeV1(e) {
      e.serialize(Pt.print(this._jsonData, null, null)), e.serialize(this._etag);
    },
    hxUnserialize: function hxUnserialize(e) {
      this._load_data(e.unserialize()), this._etag = e.unserialize();

      try {
        this._secondaryValues = e.unserialize();
      } catch (e) {
        gt.lastError = e, this._secondaryValues = null;
      }

      try {
        this._namedFiltersEvaluations = e.unserialize();
      } catch (e) {
        gt.lastError = e, this._namedFiltersEvaluations = new D();
      }
    },
    __class__: ye
  };

  var Ne = function Ne(e) {
    this.fromJSON(e);
  };

  (r["apptimize.models.ABTRange"] = Ne).__name__ = "apptimize.models.ABTRange", Ne.prototype = {
    start: null,
    end: null,
    fromJSON: function fromJSON(e) {
      this.start = e[0], this.end = e[1];
    },
    __class__: Ne
  };

  var be = function be(e) {
    pe.call(this), this.fromJSON(e);
  };

  (r["apptimize.models.ABTRangeGroup"] = be).__name__ = "apptimize.models.ABTRangeGroup", be.__super__ = pe, be.prototype = a(pe.prototype, {
    ranges: null,
    sdkParameters: null,
    seedGroups: null,
    variants: null,
    fromJSON: function fromJSON(e) {
      pe.prototype.fromJSON.call(this, e);
      var t = e;
      if (this.ranges = [], null != t.ranges) for (var r = 0, i = t.ranges; r < i.length;) {
        var n = i[r];
        ++r, this.ranges.push(new Ne(n));
      }
      if (this.seedGroups = [], null != t.seedGroups) for (r = 0, i = t.seedGroups; r < i.length;) {
        var a = i[r];
        ++r, this.seedGroups.push(new Ee(a));
      }
      if (this.variants = [], null != t.variants) for (r = 0, i = t.variants; r < i.length;) {
        var s = i[r];
        ++r, this.variants.push(new Ie(s));
      }
      Object.prototype.hasOwnProperty.call(e, "sdkParameters") && (this.sdkParameters = new Se(e.sdkParameters));
    },
    addAllVariantsIntoArray: function addAllVariantsIntoArray(e) {
      for (var t = 0, r = this.variants; t < r.length;) {
        var i = r[t];
        ++t, e.push(i);
      }

      for (t = 0, r = this.seedGroups; t < r.length;) {
        var n = r[t];
        ++t, n.addAllVariantsIntoArray(e);
      }
    },
    selectAlterationsIntoArray: function selectAlterationsIntoArray(e, t, r) {
      for (var i = this.performFilterMatchingWithEnvironment(e), n = this.computeNewOverrideState(r, i), a = 0, s = this.variants; a < s.length;) {
        var l = s[a];
        ++a, l.selectAlterationsIntoArray(e, t, n);
      }

      for (a = 0, s = this.seedGroups; a < s.length;) {
        var o = s[a];
        ++a, o.selectAlterationsIntoArray(e, t, n);
      }
    },
    isSelectedBySeed: function isSelectedBySeed(e) {
      for (var t = 0, r = this.ranges; t < r.length;) {
        var i = r[t];
        if (++t, e >= i.start && e < i.end) return !0;
      }

      return !1;
    },
    getUrlKeyProviders: function getUrlKeyProviders() {
      return this.asUrlProviders(this.seedGroups).concat(this.asUrlProviders(this.variants));
    },
    applySdkParameters: function applySdkParameters(e, t) {
      null != this.sdkParameters && e.mergeOther(this.sdkParameters);

      for (var r = 0, i = this.seedGroups; r < i.length;) {
        var n = i[r];
        ++r, n.applySdkParameters(e, t);
      }
    },
    __class__: be
  });

  var Se = function Se(e) {
    this.minPostFrequencyMs = null, (this.callServerUrls = null) != e && this.fromJSON(e);
  };

  (r["apptimize.models.ABTSdkParameters"] = Se).__name__ = "apptimize.models.ABTSdkParameters", Se.prototype = {
    minPostFrequencyMs: null,
    callServerUrls: null,
    fromJSON: function fromJSON(e) {
      var t = k.field(e, "minPostFrequencyMs");
      null != t && (this.minPostFrequencyMs = t), null != (t = k.field(e, "callServerUrls")) && (this.callServerUrls = lt.dynamicObjectToStringMap(t));
    },
    mergeOther: function mergeOther(e) {
      null != e.minPostFrequencyMs && (this.minPostFrequencyMs = e.minPostFrequencyMs), null != e.callServerUrls && (this.callServerUrls = e.callServerUrls);
    },
    __class__: Se
  };

  var xe = function xe(e) {
    this.fromDef(e);
  };

  (r["apptimize.models.ABTSeed"] = xe).__name__ = "apptimize.models.ABTSeed", xe.prototype = {
    type: null,
    value: null,
    fromDef: function fromDef(e) {
      this.type = e.type, this.value = e.value;
    },
    computedSeedMaterial: function computedSeedMaterial(e, t) {
      if ("guid" == this.type) {
        if (null != e.getUserID() && 0 == t) return $e.Sha1(bt.ofString(e.getUserID()));
        var r = bt.ofString("0123456789abcdef"),
            i = null == e.getUserID() ? e.getAnonID() : e.getUserID(),
            n = j.replace(i, "-", "").toLowerCase();

        try {
          if (32 == n.length) return $e.Sha1(new Et(r).decodeBytes(bt.ofString(n)));
        } catch (e) {
          if (gt.lastError = e, "string" != typeof ct.caught(e).unwrap()) throw e;
          d.w("Invalid GUID supplied - treating as string ID:" + n, {
            fileName: "src/apptimize/models/ABTSeed.hx",
            lineNumber: 38,
            className: "apptimize.models.ABTSeed",
            methodName: "computedSeedMaterial"
          });
        }

        return $e.Sha1(bt.ofString(i));
      }

      return null != this.value ? $e.Sha1(bt.ofString(this.value)) : (d.e("Unable to calculate seed for supplied user ID of type: " + this.type + ".", {
        fileName: "src/apptimize/models/ABTSeed.hx",
        lineNumber: 46,
        className: "apptimize.models.ABTSeed",
        methodName: "computedSeedMaterial"
      }), null);
    },
    __class__: xe
  };

  var Ee = function Ee(e) {
    pe.call(this), this.fromJSON(e);
  };

  (r["apptimize.models.ABTSeedGroup"] = Ee).__name__ = "apptimize.models.ABTSeedGroup", Ee.__super__ = pe, Ee.prototype = a(pe.prototype, {
    rangeGroups: null,
    seeds: null,
    fromJSON: function fromJSON(e) {
      pe.prototype.fromJSON.call(this, e);
      var t = e;
      if (this.rangeGroups = [], null != t.rangeGroups) for (var r = 0, i = t.rangeGroups; r < i.length;) {
        var n = i[r];
        ++r, this.rangeGroups.push(new be(n));
      }
      if (this.seeds = [], null != t.seeds) for (r = 0, i = t.seeds; r < i.length;) {
        var a = i[r];
        ++r, this.seeds.push(new xe(a));
      }
    },
    computedSeedMaterial: function computedSeedMaterial(e, t) {
      for (var r = new Ct(), i = 0, n = this.seeds; i < n.length;) {
        var a = n[i];
        ++i;
        var s = a.computedSeedMaterial(e, t);
        r.addBytes(s, 0, s.length);
      }

      return $e.Sha1(r.getBytes());
    },
    seed: function seed(e) {
      var t = this.shouldForceLegacyEncoding(e),
          r = this.computedSeedMaterial(e, t),
          i = r.length;
      if (i < 4) return d.e("User ID length too short for seed: " + i + ".", {
        fileName: "src/apptimize/models/ABTSeedGroup.hx",
        lineNumber: 65,
        className: "apptimize.models.ABTSeedGroup",
        methodName: "seed"
      }), 0;
      var n = i - 4,
          a = r.b[n + 3] | r.b[n + 2] << 8 | r.b[n + 1] << 16 | r.b[n] << 24;
      return a &= 1073741823, t ? d.v("Using Legacy seed for user: " + e.getAnonID() + ":" + e.getUserID() + ": " + a + ".", {
        fileName: "src/apptimize/models/ABTSeedGroup.hx",
        lineNumber: 78,
        className: "apptimize.models.ABTSeedGroup",
        methodName: "seed"
      }) : d.v("Got seed for user: " + e.getAnonID() + ":" + e.getUserID() + ": " + a + ".", {
        fileName: "src/apptimize/models/ABTSeedGroup.hx",
        lineNumber: 80,
        className: "apptimize.models.ABTSeedGroup",
        methodName: "seed"
      }), a;
    },
    selectAlterationsIntoArray: function selectAlterationsIntoArray(e, t, r) {
      var i = this.performFilterMatchingWithEnvironment(e),
          n = this.computeNewOverrideState(r, i),
          a = this.seed(e);
      d.v("Calculated seed for user " + e.getAnonID() + ":" + e.getUserID() + ": " + a + ".", {
        fileName: "src/apptimize/models/ABTSeedGroup.hx",
        lineNumber: 97,
        className: "apptimize.models.ABTSeedGroup",
        methodName: "selectAlterationsIntoArray"
      });

      for (var s = 0, l = this.rangeGroups; s < l.length;) {
        var o = l[s];
        ++s, o.isSelectedBySeed(a) ? o.selectAlterationsIntoArray(e, t, n) : o.selectAlterationsIntoArray(e, t, !0);
      }
    },
    addAllVariantsIntoArray: function addAllVariantsIntoArray(e) {
      for (var t = 0, r = this.rangeGroups; t < r.length;) {
        var i = r[t];
        ++t, i.addAllVariantsIntoArray(e);
      }
    },
    getUrlKeyProviders: function getUrlKeyProviders() {
      return this.asUrlProviders(this.rangeGroups);
    },
    applySdkParameters: function applySdkParameters(e, t) {
      if (this.performFilterMatchingWithEnvironment(t).result == J.ABTFilterResultTrue) for (var r = this.seed(t), i = 0, n = this.rangeGroups; i < n.length;) {
        var a = n[i];
        ++i, a.isSelectedBySeed(r) && a.applySdkParameters(e, t);
      }
    },
    shouldForceLegacyEncoding: function shouldForceLegacyEncoding(e) {
      for (var t = !1, r = !1, i = 0, n = 0, a = this.seeds; n < a.length;) {
        var s = a[n];

        if (++n, "constant" != s.type || "experiment" != s.value && "feature flag" != s.value && "feature config" != s.value) {
          if (r && 0 == i) {
            var l = O.parseInt(s.value);
            null != l && (i = l);
          }
        } else r = !0;
      }

      var o = He.sharedInstance().valueForProperty(He.APPTIMIZE_MAXEXP_SEED_KEY);
      return r && i < o && (t = !0), t;
    },
    __class__: Ee
  });

  var Ie = function Ie(e) {
    pe.call(this), this.fromJSON(e);
  };

  (r["apptimize.models.ABTVariant"] = Ie).__name__ = "apptimize.models.ABTVariant", Ie.__super__ = pe, Ie.prototype = a(pe.prototype, {
    alterations: null,
    alterations2: null,
    codeBlockName: null,
    experimentId: null,
    experimentName: null,
    experimentType: null,
    startTime: null,
    variantId: null,
    variantName: null,
    cycle: null,
    phase: null,
    fromJSON: function fromJSON(e) {
      pe.prototype.fromJSON.call(this, e);
      var t = e;
      this.alterations = [], this.alterations2 = [];

      for (var r = 0, i = t.alterations; r < i.length;) {
        var n = i[r];
        ++r, this.alterations.push(ge.alterationFromJSON(n, this));
      }

      if (this.codeBlockName = t.codeBlockName, this.variantId = t.variantId, this.experimentId = t.experimentId, or.getClass(this) != we && (this.experimentName = t.experimentName, this.experimentType = t.experimentType, this.startTime = t.startTime, this.variantName = t.variantName, this.cycle = t.cycle, this.phase = t.phase), Object.prototype.hasOwnProperty.call(t, "alterations2") && null != t.alterations2) {
        for (r = 0, i = t.alterations2; r < i.length;) {
          n = i[r];
          ++r, this.alterations2.push(ge.alterationFromJSON(n, this));
        }

        this.alterations = this.alterations.concat(this.alterations2);
      }
    },
    selectAlterationsIntoArray: function selectAlterationsIntoArray(e, t, r) {
      for (var i = this.performFilterMatchingWithEnvironment(e), n = this.computeNewOverrideState(r, i), a = 0, s = this.alterations; a < s.length;) {
        var l = s[a];
        ++a, l.selectAlterationsIntoArray(e, t, n);
      }
    },
    getVariantID: function getVariantID() {
      return this.variantId;
    },
    getVariantName: function getVariantName() {
      return this.variantName;
    },
    getExperimentID: function getExperimentID() {
      return this.experimentId;
    },
    getExperimentName: function getExperimentName() {
      return this.experimentName;
    },
    getExperimentType: function getExperimentType() {
      return this.experimentType;
    },
    getCodeBlockName: function getCodeBlockName() {
      return this.codeBlockName;
    },
    getPhase: function getPhase() {
      return this.phase;
    },
    getCycle: function getCycle() {
      return this.cycle;
    },
    getUrlKeyProviders: function getUrlKeyProviders() {
      return this.asUrlProviders(this.alterations);
    },
    __class__: Ie
  });

  var we = function we(e) {
    Ie.call(this, e);
  };

  (r["apptimize.models.ABTHotfixVariant"] = we).__name__ = "apptimize.models.ABTHotfixVariant", we.__super__ = Ie, we.prototype = a(Ie.prototype, {
    hotfixName: null,
    fromJSON: function fromJSON(e) {
      Ie.prototype.fromJSON.call(this, e);
      var t = e;
      this.hotfixName = t.hotfixName;
    },
    getHotfixName: function getHotfixName() {
      return this.hotfixName;
    },
    __class__: we
  });

  var ze = function ze(e) {
    ze.RESULT_ENTRY_CREATION_LOCK.acquire();

    try {
      this._id = this._getNextSequenceNumber(), this._deviceTimestamp = ft.fromFloat(new Date().getTime()), this._monotonicTimestamp = this._getMonotonicTimestamp(this._deviceTimestamp);
    } catch (e) {
      gt.lastError = e;
      var t = ct.caught(e).unwrap();
      throw ze.RESULT_ENTRY_CREATION_LOCK.release(), ct.thrown(t);
    }

    ze.RESULT_ENTRY_CREATION_LOCK.release(), this._prefixedAttributes = new D(), null != e && null != e.customProperties.availableProperties && e.customProperties.addJSONProperties(this._prefixedAttributes), Xe.sharedInstance().addJSONProperties(this._prefixedAttributes), e.applicationProperties.addJSONProperties(this._prefixedAttributes);
  };

  (r["apptimize.models.results.ABTResultEntry"] = ze).__name__ = "apptimize.models.results.ABTResultEntry", ze.__super__ = Te, ze.prototype = a(Te.prototype, {
    _id: null,
    _monotonicTimestamp: null,
    _deviceTimestamp: null,
    _userAttributes: null,
    _prefixedAttributes: null,
    _getNextSequenceNumber: function _getNextSequenceNumber() {
      var e = Ge.loadString(Ge.kResultEntrySequenceKey),
          t = new mt(0, 0);
      null != e && (t = ft.parseString(e));
      (t = new mt(t.high, t.low)).low++;

      if (t.low = 0 | t.low, 0 == t.low) {
        t.high++;
        t.high = 0 | t.high;
      }

      return Ge.saveString(Ge.kResultEntrySequenceKey, _t.toString(t)), t;
    },
    _getMonotonicTimestamp: function _getMonotonicTimestamp(e) {
      var t = e,
          r = new mt(0, 0),
          i = Ge.loadString(Ge.kResultEntryTimestampKey);
      null != i && (r = ft.parseString(i));
      var n = r.high - e.high | 0;

      if (0 == n && (n = ht.ucompare(r.low, e.low)), 0 <= (r.high < 0 ? e.high < 0 ? n : -1 : 0 <= e.high ? n : 1)) {
        var a = r.high + 0 | 0,
            s = r.low + 1 | 0;

        if (ht.ucompare(s, r.low) < 0) {
          a++;
          a |= 0;
        }

        t = new mt(a, s);
      }

      return Ge.saveString(Ge.kResultEntryTimestampKey, _t.toString(t)), t;
    },
    JSONRepresentation: function JSONRepresentation() {
      var e = new D(),
          t = et.toPreprocessedString(this._id);
      e.h.ei = t;
      t = et.toPreprocessedString(this._monotonicTimestamp);
      e.h.mt = t;
      t = et.toPreprocessedString(this._deviceTimestamp);
      e.h.dt = t;
      t = lt.filterNullValues(this._prefixedAttributes);
      e.h.pa = t;
      var r = e;

      if (null != this._userAttributes) {
        var i = lt.filterNullValues(this._userAttributes);
        r.h.ua = i;
      }

      return r;
    },
    hxSerialize: function hxSerialize(e) {
      et._serializeInt64(this._id, e), et._serializeInt64(this._monotonicTimestamp, e), et._serializeInt64(this._deviceTimestamp, e), e.serialize(this._userAttributes), e.serialize(this._prefixedAttributes);
    },
    hxUnserialize: function hxUnserialize(e) {
      this._id = et._deserializeInt64(e), this._monotonicTimestamp = et._deserializeInt64(e), this._deviceTimestamp = et._deserializeInt64(e), this._userAttributes = e.unserialize(), this._prefixedAttributes = e.unserialize();
    },
    __class__: ze
  });

  var Be = function Be(e, t, r, i) {
    this._type = "v", ze.call(this, e), this._variantID = t, this._cycle = r, this._phase = i;
  };

  (r["apptimize.models.results.ABTResultEntryVariantShown"] = Be).__name__ = "apptimize.models.results.ABTResultEntryVariantShown", Be.__super__ = ze, Be.prototype = a(ze.prototype, {
    _type: null,
    _variantID: null,
    _cycle: null,
    _phase: null,
    JSONRepresentation: function JSONRepresentation() {
      var e = ze.prototype.JSONRepresentation.call(this),
          t = this._type;
      e.h.ty = t;
      t = this._variantID;
      e.h.v = t;
      var r = new D();
      r.h.v = this._variantID, r.h.c = this._cycle, r.h.p = this._phase;
      t = r;
      return e.h.vp = t, e;
    },
    hxSerialize: function hxSerialize(e) {
      ze.prototype.hxSerialize.call(this, e), e.serialize(this._type), e.serialize(this._variantID), e.serialize(this._cycle), e.serialize(this._phase);
    },
    hxUnserialize: function hxUnserialize(e) {
      ze.prototype.hxUnserialize.call(this, e), this._type = e.unserialize(), this._variantID = e.unserialize(), this._cycle = e.unserialize(), this._phase = e.unserialize();
    },
    __class__: Be
  });

  var Fe = function Fe(e, t, r, i) {
    this._type = "ee", ze.call(this, e), this._name = t, this._source = r, this._attributes = i;
  };

  (r["apptimize.models.results.ABTResultEntryEvent"] = Fe).__name__ = "apptimize.models.results.ABTResultEntryEvent", Fe.__super__ = ze, Fe.prototype = a(ze.prototype, {
    _type: null,
    _name: null,
    _source: null,
    _attributes: null,
    JSONRepresentation: function JSONRepresentation() {
      var e = ze.prototype.JSONRepresentation.call(this),
          t = this._type;
      e.h.ty = t;
      t = this._name;
      e.h.n = t;
      t = this._source;
      e.h.s = t;
      t = this._attributes;
      return e.h.a = t, e;
    },
    hxSerialize: function hxSerialize(e) {
      ze.prototype.hxSerialize.call(this, e), e.serialize(this._type), e.serialize(this._name), e.serialize(this._source), e.serialize(this._attributes);
    },
    hxUnserialize: function hxUnserialize(e) {
      ze.prototype.hxUnserialize.call(this, e), this._type = e.unserialize(), this._name = e.unserialize(), this._source = e.unserialize(), this._attributes = e.unserialize();
    },
    __class__: Fe
  });

  var ke = function ke(e, t, r) {
    this._type = "md", ze.call(this, e), this._metadataSequenceNumber = t, this._enrolledVariantsCyclesPhases = r, this._enrolledVariantIDs = [];

    for (var i = 0, n = this._enrolledVariantsCyclesPhases; i < n.length;) {
      var a = n[i];
      ++i, this._enrolledVariantIDs.push(a.v);
    }
  };

  (r["apptimize.models.results.ABTResultEntryMetadataProcessed"] = ke).__name__ = "apptimize.models.results.ABTResultEntryMetadataProcessed", ke.__super__ = ze, ke.prototype = a(ze.prototype, {
    _type: null,
    _metadataSequenceNumber: null,
    _enrolledVariantsCyclesPhases: null,
    _enrolledVariantIDs: null,
    JSONRepresentation: function JSONRepresentation() {
      var e = ze.prototype.JSONRepresentation.call(this);

      if (0 < this._enrolledVariantsCyclesPhases.length) {
        var t = this._enrolledVariantsCyclesPhases;
        e.h.vp = t;
      }

      t = this._enrolledVariantIDs;
      e.h.v = t;
      t = this._metadataSequenceNumber;
      e.h.s = t;
      t = this._type;
      return e.h.ty = t, e;
    },
    hxSerialize: function hxSerialize(e) {
      ze.prototype.hxSerialize.call(this, e), e.serialize(this._type), e.serialize(this._metadataSequenceNumber), e.serialize(this._enrolledVariantIDs), e.serialize(this._enrolledVariantsCyclesPhases);
    },
    hxUnserialize: function hxUnserialize(e) {
      ze.prototype.hxUnserialize.call(this, e), this._type = e.unserialize(), this._metadataSequenceNumber = e.unserialize(), this._enrolledVariantIDs = e.unserialize(), this._enrolledVariantsCyclesPhases = e.unserialize();
    },
    __class__: ke
  });

  var Oe = function Oe(e, t) {
    this._type = "ac", ze.call(this, e), this._enrolledVariantsCyclesPhases = t, this._enrolledVariantIDs = [];

    for (var r = 0, i = this._enrolledVariantsCyclesPhases; r < i.length;) {
      var n = i[r];
      ++r, this._enrolledVariantIDs.push(n.v);
    }
  };

  (r["apptimize.models.results.ABTResultEntryAttributesChanged"] = Oe).__name__ = "apptimize.models.results.ABTResultEntryAttributesChanged", Oe.__super__ = ze, Oe.prototype = a(ze.prototype, {
    _type: null,
    _enrolledVariantsCyclesPhases: null,
    _enrolledVariantIDs: null,
    JSONRepresentation: function JSONRepresentation() {
      var e = ze.prototype.JSONRepresentation.call(this),
          t = this._type;
      e.h.ty = t;
      t = this._enrolledVariantIDs;

      if (e.h.v = t, 0 < this._enrolledVariantsCyclesPhases.length) {
        t = this._enrolledVariantsCyclesPhases;
        e.h.vp = t;
      }

      return e;
    },
    hxSerialize: function hxSerialize(e) {
      ze.prototype.hxSerialize.call(this, e), e.serialize(this._type), e.serialize(this._enrolledVariantIDs), e.serialize(this._enrolledVariantsCyclesPhases);
    },
    hxUnserialize: function hxUnserialize(e) {
      ze.prototype.hxUnserialize.call(this, e), this._type = e.unserialize(), this._enrolledVariantIDs = e.unserialize(), this._enrolledVariantsCyclesPhases = e.unserialize();
    },
    __class__: Oe
  });

  var Pe = function Pe(e, t) {
    this._type = "ue", ze.call(this, e), this._nextUserID = t;
  };

  (r["apptimize.models.results.ABTResultEntryUserEnd"] = Pe).__name__ = "apptimize.models.results.ABTResultEntryUserEnd", Pe.__super__ = ze, Pe.prototype = a(ze.prototype, {
    _type: null,
    _nextUserID: null,
    JSONRepresentation: function JSONRepresentation() {
      var e = ze.prototype.JSONRepresentation.call(this),
          t = this._type;
      e.h.ty = t;
      t = this._nextUserID;
      return e.h.n = t, e;
    },
    hxSerialize: function hxSerialize(e) {
      ze.prototype.hxSerialize.call(this, e), e.serialize(this._type), e.serialize(this._nextUserID);
    },
    hxUnserialize: function hxUnserialize(e) {
      ze.prototype.hxUnserialize.call(this, e), this._type = e.unserialize(), this._nextUserID = e.unserialize();
    },
    __class__: Pe
  });

  var Ce = function Ce(e, t) {
    this._type = "us", ze.call(this, e), this._previousUserID = t;
  };

  (r["apptimize.models.results.ABTResultEntryUserStart"] = Ce).__name__ = "apptimize.models.results.ABTResultEntryUserStart", Ce.__super__ = ze, Ce.prototype = a(ze.prototype, {
    _type: null,
    _previousUserID: null,
    JSONRepresentation: function JSONRepresentation() {
      var e = ze.prototype.JSONRepresentation.call(this),
          t = this._type;
      e.h.ty = t;
      t = this._previousUserID;
      return e.h.p = t, e;
    },
    hxSerialize: function hxSerialize(e) {
      ze.prototype.hxSerialize.call(this, e), e.serialize(this._type), e.serialize(this._previousUserID);
    },
    hxUnserialize: function hxUnserialize(e) {
      ze.prototype.hxUnserialize.call(this, e), this._type = e.unserialize(), this._previousUserID = e.unserialize();
    },
    __class__: Ce
  });

  var De = function De(e, t, r) {
    var i = new mt(0, 0);
    this._lastEntryID = i;
    i = new mt(0, 0);
    this._firstEntryID = i;
    i = new mt(0, 0);
    this._timestampFromServer = i, this._type = "sp", ze.call(this, null), this._timestampFromServer = e, this._firstEntryID = t, this._lastEntryID = r;
  };

  (r["apptimize.models.results.ABTResultEntrySuccessfullyPosted"] = De).__name__ = "apptimize.models.results.ABTResultEntrySuccessfullyPosted", De.__super__ = ze, De.prototype = a(ze.prototype, {
    _type: null,
    _timestampFromServer: null,
    _firstEntryID: null,
    _lastEntryID: null,
    JSONRepresentation: function JSONRepresentation() {
      var e = ze.prototype.JSONRepresentation.call(this),
          t = this._type;
      e.h.ty = t;
      t = et.toPreprocessedString(this._timestampFromServer);
      e.h.t = t;
      t = et.toPreprocessedString(this._firstEntryID);
      e.h.f = t;
      t = et.toPreprocessedString(this._lastEntryID);
      return e.h.l = t, e;
    },
    hxSerialize: function hxSerialize(e) {
      ze.prototype.hxSerialize.call(this, e), e.serialize(this._type), et._serializeInt64(this._timestampFromServer, e), et._serializeInt64(this._firstEntryID, e), et._serializeInt64(this._lastEntryID, e);
    },
    hxUnserialize: function hxUnserialize(e) {
      ze.prototype.hxUnserialize.call(this, e), this._type = e.unserialize(), this._timestampFromServer = et._deserializeInt64(e), this._firstEntryID = et._deserializeInt64(e), this._lastEntryID = et._deserializeInt64(e);
    },
    __class__: De
  });

  var Re = function Re(e) {
    var t = new mt(0, 0);
    this._currentEntryCount = t, this._type = "dl", ze.call(this, null), this._currentEntryCount = e;
  };

  (r["apptimize.models.results.ABTResultEntryDataTypeLimitReached"] = Re).__name__ = "apptimize.models.results.ABTResultEntryDataTypeLimitReached", Re.__super__ = ze, Re.prototype = a(ze.prototype, {
    _type: null,
    _currentEntryCount: null,
    JSONRepresentation: function JSONRepresentation() {
      var e = ze.prototype.JSONRepresentation.call(this),
          t = this._type;
      e.h.ty = t;
      t = et.toPreprocessedString(this._currentEntryCount);
      return e.h.c = t, e;
    },
    hxSerialize: function hxSerialize(e) {
      ze.prototype.hxSerialize.call(this, e), e.serialize(this._type), et._serializeInt64(this._currentEntryCount, e);
    },
    hxUnserialize: function hxUnserialize(e) {
      ze.prototype.hxUnserialize.call(this, e), this._type = e.unserialize(), this._currentEntryCount = et._deserializeInt64(e);
    },
    __class__: Re
  });

  var Le = function Le(e) {
    null != e && (this.userID = e.userID, this.anonID = e.anonID, this.appkey = e.appkey, this.uniqueID = e.getUniqueUserID()), this.entries = [];
  };

  (r["apptimize.models.results.ABTResultLog"] = Le).__name__ = "apptimize.models.results.ABTResultLog", Le.prototype = {
    entries: null,
    userID: null,
    anonID: null,
    appkey: null,
    uniqueID: null,
    logEntry: function logEntry(e) {
      this.entries.push(e);
    },
    entryCount: function entryCount() {
      return this.entries.length;
    },
    getAppKey: function getAppKey() {
      return this.appkey;
    },
    getUniqueUserKey: function getUniqueUserKey() {
      return this.uniqueID;
    },
    toJSON: function toJSON() {
      for (var e = new D(), t = [], r = 0, i = this.entries; r < i.length;) {
        var n = i[r];
        ++r, t.push(n.JSONRepresentation());
      }

      var a = "v4";
      e.h.type = a;
      a = this.getAppKey();

      if (e.h.a = a, null != this.anonID) {
        a = this.anonID;
        e.h.g = a;
      }

      new Date();
      var s = ft.fromFloat(new Date().getTime());
      a = et.toPreprocessedString(s);
      e.h.c = a;
      a = t;
      e.h.e = a;
      a = "Cross Platform " + z.getApptimizeSDKVersion();

      if (e.h.v = a, null != this.userID) {
        a = this.userID;
        e.h.u = a;
      }

      return tt.stringify(e);
    },
    __class__: Le
  };

  var Ue = require("pako"),
      Me = function Me() {};

  (r["apptimize.support.initialize.ABTPlatformInitialize"] = Me).__name__ = "apptimize.support.initialize.ABTPlatformInitialize", Me.initialize = function () {
    Ge.saveString(Ge.kApptimizeVersionKey, z.getApptimizeSDKVersion()), Me._isThreadingEnabled = He.sharedInstance().valueForProperty(He.THREADING_ENABLED_KEY);
    var e = window;
    e.onblur = Me.onBlur, e.onfocus = Me.onFocus, e.onunload = z.flushTracking, U.startPolling(), Me.hookShutdown(Me._isThreadingEnabled);
  }, Me.hookShutdown = function (e) {
    He.sharedInstance().valueForProperty(He.AUTOMATIC_SHUTDOWN_HOOK) || d.v("Process exits will not be handled to persist Apptimize library state across server restarts.", {
      fileName: "src/apptimize/support/initialize/ABTPlatformInitialize.hx",
      lineNumber: 119,
      className: "apptimize.support.initialize.ABTPlatformInitialize",
      methodName: "hookShutdown"
    });
  }, Me.shutdownPlatform = function () {
    U.stopPolling();
  }, Me.onBlur = function () {
    z.flushTracking(), U.startPolling(!1);
  }, Me.onFocus = function () {
    U.startPolling();
  };

  var Ve = function Ve() {};

  (r["apptimize.support.persistence.ABTPersistentInterface"] = Ve).__name__ = "apptimize.support.persistence.ABTPersistentInterface", Ve.prototype = {
    save: function save(e, t, r, i) {
      throw null == i && (i = !1), null == r && (r = 0), ct.thrown("ABTPersistentInterface.save not implemented");
    },
    load: function load(e, t, r) {
      throw null == t && (t = 0), ct.thrown("ABTPersistentInterface.load not implemented");
    },
    clear: function clear(e) {
      null == e && (e = 2);
    },
    saveObject: function saveObject(e, t, r, i) {
      null == i && (i = !1), null == r && (r = 0);
      var n = new vt();
      n.serialize(t), n.serialize(z.getApptimizeSDKVersion()), this.save(e, n.toString(), r, i);
    },
    loadObject: function loadObject(e, t, n) {
      null == t && (t = 0);

      var a = this,
          s = null,
          r = function r(t, e) {
        if (null != e) {
          try {
            var r = new yt(e);
            null != (s = r.unserialize()) && a.hasDidUnserialize(s) && s.didUnserialize();
          } catch (e) {
            gt.lastError = e;
            var i = ct.caught(e).unwrap();
            d.e('Error deserializing "' + t + '" from persistent storage. Error: ' + O.string(i), {
              fileName: "src/apptimize/support/persistence/ABTPersistence.hx",
              lineNumber: 50,
              className: "apptimize.support.persistence.ABTPersistentInterface",
              methodName: "loadObject"
            });
          }

          if (null != n) return n(t, s), s;
        }

        return null != n && n(t, null), s;
      };

      return null != n ? this.load(e, t, r) : r(e, this.load(e, t, n));
    },
    hasDidUnserialize: function hasDidUnserialize(e) {
      return null != e.didUnserialize;
    },
    __class__: Ve
  };

  var Ke = function Ke() {
    this.syncedKeys = [], this.sharedCache = window.document.defaultView.localStorage, this.localCache = window.document.defaultView.sessionStorage, window.onstorage = mr(this, this.onStorage);
  };

  (r["apptimize.support.persistence.ABTPIBrowserSyncedCache"] = Ke).__name__ = "apptimize.support.persistence.ABTPIBrowserSyncedCache", Ke.isSyncedCacheSupported = function () {
    try {
      return null != window.document.defaultView.localStorage && null != window.document.defaultView.sessionStorage && nt.getHumanReadableBrowserName(i.navigator.userAgent) != nt.kBrowserNameInternetExplorer;
    } catch (e) {
      gt.lastError = e;
      var t = ct.caught(e).unwrap();
      return d.e("Error checking local storage status: " + O.string(t), {
        fileName: "src/apptimize/support/persistence/ABTPIBrowserSyncedCache.hx",
        lineNumber: 39,
        className: "apptimize.support.persistence.ABTPIBrowserSyncedCache",
        methodName: "isSyncedCacheSupported"
      }), !1;
    }
  }, Ke.__super__ = Ve, Ke.prototype = a(Ve.prototype, {
    sharedCache: null,
    localCache: null,
    syncedKeys: null,
    _isKeySynced: function _isKeySynced(e, t) {
      null == t && (t = !1);
      var r = -1 != this.syncedKeys.indexOf(e);
      return t && !r && this._syncKey(e), r;
    },
    _syncKey: function _syncKey(e) {
      this._isKeySynced(e, !1) || this.syncedKeys.push(e);
    },
    onStorage: function onStorage(e) {
      this._isKeySynced(e.key, !0), this.localCache.setItem(e.key, e.newValue);
    },
    save: function save(e, t, r, i) {
      null == i && (i = !1), null == r && (r = 0), i && He.sharedInstance().valueForProperty(He.COMPRESS_PERSISTENCE_STORE_KEY) && (t = Ke.compressionPrefix + ot.compressStringToBase64(t)), null != t ? (this.localCache.setItem(e, t), this.sharedCache.setItem(e, t)) : (this.localCache.removeItem(e), this.sharedCache.removeItem(e)), this._syncKey(e);
    },
    load: function load(e, t, r) {
      if (null == t && (t = 0), !this._isKeySynced(e, !0)) {
        var i = this.sharedCache.getItem(e);
        null != i && this.localCache.setItem(e, i);
      }

      var n = this.localCache.getItem(e);
      return this.isCompressed(n) && (d.v("Requested persistence key " + e + " is compressed.", {
        fileName: "src/apptimize/support/persistence/ABTPIBrowserSyncedCache.hx",
        lineNumber: 101,
        className: "apptimize.support.persistence.ABTPIBrowserSyncedCache",
        methodName: "load"
      }), n = ot.decompressBase64ToString(Y.substr(n, Ke.compressionPrefix.length, null))), null != r && r(e, n), n;
    },
    clear: function clear(e) {
      null == e && (e = 2), this.syncedKeys = [], this.sharedCache.clear(), this.localCache.clear();
    },
    isCompressed: function isCompressed(e) {
      return !(null == e || e.length < Ke.compressionPrefix.length || Y.substr(e, 0, Ke.compressionPrefix.length) != Ke.compressionPrefix);
    },
    __class__: Ke
  });

  var qe = function qe() {
    this.cacheMap = new D();
  };

  (r["apptimize.support.persistence.ABTPICacheStorage"] = qe).__name__ = "apptimize.support.persistence.ABTPICacheStorage", qe.__super__ = Ve, qe.prototype = a(Ve.prototype, {
    cacheMap: null,
    save: function save(e, t, r, i) {
      if (null == i && (i = !1), null == r && (r = 0), null != t) this.cacheMap.h[e] = t;else {
        var n = this.cacheMap;
        Object.prototype.hasOwnProperty.call(n.h, e) && delete n.h[e];
      }
    },
    saveObject: function saveObject(e, t, r, i) {
      if (null == i && (i = !1), null == r && (r = 0), null != t) this.cacheMap.h[e] = t;else {
        var n = this.cacheMap;
        Object.prototype.hasOwnProperty.call(n.h, e) && delete n.h[e];
      }
    },
    loadObject: function loadObject(e, t, r) {
      null == t && (t = 0);
      var i = this.cacheMap.h[e];
      return null != r && r(e, i), i;
    },
    load: function load(e, t, r) {
      null == t && (t = 0);
      var i = this.cacheMap.h[e];
      return null != r && r(e, i), i;
    },
    clear: function clear(e) {
      null == e && (e = 0), this.cacheMap = new D();
    },
    __class__: qe
  });

  var Ge = function Ge() {};

  (r["apptimize.support.persistence.ABTPersistence"] = Ge).__name__ = "apptimize.support.persistence.ABTPersistence", Ge.getPersistentInterface = function () {
    if (null == Ge._persistentInterface) {
      if (He.sharedInstance().isPropertyAvailable(He.STORAGE_TYPE_KEY) && "memory" == He.sharedInstance().valueForProperty(He.STORAGE_TYPE_KEY)) return Ge._persistentInterface = new qe(), Ge._persistentInterface;
      Ke.isSyncedCacheSupported() ? Ge._persistentInterface = new Ke() : (d.w("Local storage not available.  Using local memory cache. No data will be persisted between sessions or tabs.", {
        fileName: "src/apptimize/support/persistence/ABTPersistence.hx",
        lineNumber: 138,
        className: "apptimize.support.persistence.ABTPersistence",
        methodName: "getPersistentInterface"
      }), Ge._persistentInterface = new qe());
    }

    return Ge._persistentInterface;
  }, Ge.shutdown = function () {
    Ge._persistentInterface = null;
  }, Ge.loadFromHighLatency = function (e) {
    e();
  }, Ge.saveToHighLatency = function () {}, Ge.clear = function () {
    f.SYSTEM_DATA_LOCK.acquire();

    try {
      Ge.getPersistentInterface().clear(Ge.ALL_LATENCY);
    } catch (e) {
      gt.lastError = e;
      var t = ct.caught(e).unwrap();
      throw f.SYSTEM_DATA_LOCK.release(), ct.thrown(t);
    }

    f.SYSTEM_DATA_LOCK.release();
  }, Ge.saveString = function (t, e, r, i) {
    null == i && (i = !1), null == r && (r = 0), f.SYSTEM_DATA_LOCK.acquire();

    try {
      try {
        Ge.getPersistentInterface().save(t, e, r, i);
      } catch (e) {
        gt.lastError = e;
        var n = ct.caught(e).unwrap();
        Ge._isFlushing || d.e('Unable to store "' + t + '" to persistent storage. Submitting all pending results data. Error: ' + O.string(n), {
          fileName: "src/apptimize/support/persistence/ABTPersistence.hx",
          lineNumber: 215,
          className: "apptimize.support.persistence.ABTPersistence",
          methodName: "saveString"
        }), Ge.flushTracking();
      }
    } catch (e) {
      gt.lastError = e;
      var a = ct.caught(e).unwrap();
      throw f.SYSTEM_DATA_LOCK.release(), ct.thrown(a);
    }

    f.SYSTEM_DATA_LOCK.release();
  }, Ge.saveObject = function (t, e, r, i) {
    null == i && (i = !1), null == r && (r = 0), f.SYSTEM_DATA_LOCK.acquire();

    try {
      try {
        Ge.getPersistentInterface().saveObject(t, e, r, i);
      } catch (e) {
        gt.lastError = e;
        var n = ct.caught(e).unwrap();
        Ge._isFlushing || d.e('Unable to store "' + t + '" to persistent storage. Submitting all pending results data. Error: ' + O.string(n), {
          fileName: "src/apptimize/support/persistence/ABTPersistence.hx",
          lineNumber: 229,
          className: "apptimize.support.persistence.ABTPersistence",
          methodName: "saveObject"
        }), Ge.flushTracking();
      }
    } catch (e) {
      gt.lastError = e;
      var a = ct.caught(e).unwrap();
      throw f.SYSTEM_DATA_LOCK.release(), ct.thrown(a);
    }

    f.SYSTEM_DATA_LOCK.release();
  }, Ge.flushTracking = function () {
    if (!Ge._isFlushing) {
      Ge._isFlushing = !0;

      try {
        z.flushTracking(), Ge._isFlushing = !1;
      } catch (e) {
        var t = ct.caught(e);
        Ge._isFlushing = !1, d.e("Error on flushing pending results data " + O.string(t), {
          fileName: "src/apptimize/support/persistence/ABTPersistence.hx",
          lineNumber: 247,
          className: "apptimize.support.persistence.ABTPersistence",
          methodName: "flushTracking"
        });
      }
    }
  }, Ge.saveStringMap = function (e, t) {
    Ge.saveObject(e, t, 0, !1);
  }, Ge.loadString = function (t, e) {
    null == e && (e = 0);
    var r = null;
    f.SYSTEM_DATA_LOCK.acquire();

    try {
      try {
        r = Ge.getPersistentInterface().load(t, e);
      } catch (e) {
        gt.lastError = e;
        var i = ct.caught(e).unwrap();
        return d.e('Unable to retrieve "' + t + '" from persistent storage. Error: ' + O.string(i), {
          fileName: "src/apptimize/support/persistence/ABTPersistence.hx",
          lineNumber: 261,
          className: "apptimize.support.persistence.ABTPersistence",
          methodName: "loadString"
        }), null;
      }
    } catch (e) {
      gt.lastError = e;
      var n = ct.caught(e).unwrap();
      throw f.SYSTEM_DATA_LOCK.release(), ct.thrown(n);
    }

    return f.SYSTEM_DATA_LOCK.release(), r;
  }, Ge.loadObject = function (t, e) {
    null == e && (e = 0);
    var r = null;
    f.SYSTEM_DATA_LOCK.acquire();

    try {
      try {
        r = Ge.getPersistentInterface().loadObject(t, e, null);
      } catch (e) {
        gt.lastError = e;
        var i = ct.caught(e).unwrap();
        return d.e('Unable to retrieve "' + t + '" from persistent storage. Error: ' + O.string(i), {
          fileName: "src/apptimize/support/persistence/ABTPersistence.hx",
          lineNumber: 274,
          className: "apptimize.support.persistence.ABTPersistence",
          methodName: "loadObject"
        }), null;
      }
    } catch (e) {
      gt.lastError = e;
      var n = ct.caught(e).unwrap();
      throw f.SYSTEM_DATA_LOCK.release(), ct.thrown(n);
    }

    return f.SYSTEM_DATA_LOCK.release(), r;
  }, Ge.loadStringMap = function (e, t) {
    return null == t && (t = 0), Ge.loadObject(e, t);
  };

  var Ye = function Ye() {
    this.PROPERTYLOCK = f.getNewLock("property_lock"), this.availableProperties = new D(), this.PROPERTYLOCK.acquire();

    try {
      this.availableProperties = new D(), this.setPropertyDefaults();
    } catch (e) {
      gt.lastError = e;
      var t = ct.caught(e).unwrap();
      throw this.PROPERTYLOCK.release(), ct.thrown(t);
    }

    this.PROPERTYLOCK.release();
  };

  (r["apptimize.support.properties.ABTProperties"] = Ye).__name__ = "apptimize.support.properties.ABTProperties", Ye.prototype = {
    availableProperties: null,
    PROPERTYLOCK: null,
    setPropertyDefaults: function setPropertyDefaults() {},
    isPropertyAvailable: function isPropertyAvailable(e) {
      var t = null;
      this.PROPERTYLOCK.acquire();

      try {
        t = this.availableProperties.h[e];
      } catch (e) {
        gt.lastError = e;
        var r = ct.caught(e).unwrap();
        throw this.PROPERTYLOCK.release(), ct.thrown(r);
      }

      return this.PROPERTYLOCK.release(), null != t;
    },
    valueForProperty: function valueForProperty(e) {
      var t = null;
      this.PROPERTYLOCK.acquire();

      try {
        t = this.availableProperties.h[e];
      } catch (e) {
        gt.lastError = e;
        var r = ct.caught(e).unwrap();
        throw this.PROPERTYLOCK.release(), ct.thrown(r);
      }

      return this.PROPERTYLOCK.release(), t;
    },
    setProperty: function setProperty(e, t) {
      this.PROPERTYLOCK.acquire();

      try {
        this.availableProperties.h[e] = t;
      } catch (e) {
        gt.lastError = e;
        var r = ct.caught(e).unwrap();
        throw this.PROPERTYLOCK.release(), ct.thrown(r);
      }

      this.PROPERTYLOCK.release();
    },
    setProperties: function setProperties(e) {
      for (var t = e.h, r = Object.keys(t), i = r.length, n = 0; n < i;) {
        var a = r[n++];
        this.setProperty(a, e.h[a]);
      }
    },
    __class__: Ye
  };

  var je = function je() {
    Ye.call(this);
  };

  (r["apptimize.support.properties.ABTApplicationProperties"] = je).__name__ = "apptimize.support.properties.ABTApplicationProperties", je.sharedInstance = function () {
    return null == je._instance && (je._instance = new je()), je._instance;
  }, je.getPlatformVersion = function () {
    return "";
  }, je.__super__ = Ye, je.prototype = a(Ye.prototype, {
    setPropertyDefaults: function setPropertyDefaults() {
      var e = this.availableProperties,
          t = z.getApptimizeSDKVersion();
      e.h.apptimize_version = t;
      e = this.availableProperties, t = z.getApptimizeSDKPlatform();
      e.h.apptimize_platform = t;
      t = null;
      this.availableProperties.h.app_version = t;
      t = null;
      this.availableProperties.h.app_name = t;
      e = this.availableProperties, t = je.getPlatformVersion();

      if (e.h.system_version = t, ur.get_supported()) {
        e = this.availableProperties, t = i.navigator.language.split("-")[0];
        e.h.system_language = t;
        e = this.availableProperties, t = i.navigator.language;
        e.h.browser_language = t;
        var r = i.navigator.userAgent;
        this.availableProperties.h.browser_userAgent = r;
        e = this.availableProperties, t = nt.getHumanReadableBrowserName(r);
        e.h.browser_name = t;
        e = this.availableProperties, t = nt.getBrowserVersion(r);
        e.h.browser_version = t;
        e = this.availableProperties, t = nt.getDeviceCategory(r);
        e.h.device_category = t;
      }
    },
    addJSONProperties: function addJSONProperties(e) {
      for (var t = this.availableProperties.h, r = Object.keys(t), i = r.length, n = 0; n < i;) {
        var a = r[n++],
            s = this.availableProperties.h[a];
        e.h[je._sigilForApplicationNamespace + a] = s;
      }
    },
    __class__: je
  });

  var He = function He() {
    Ye.call(this);
  };

  (r["apptimize.support.properties.ABTConfigProperties"] = He).__name__ = "apptimize.support.properties.ABTConfigProperties", He.sharedInstance = function () {
    return null == He._instance && (He._instance = new He()), He._instance;
  }, He.__super__ = Ye, He.prototype = a(Ye.prototype, {
    setPropertyDefaults: function setPropertyDefaults() {
      this.availableProperties.h[He.META_DATA_URL_LL_KEY] = "https://md-ll.apptimize.com/api/metadata/v4/", this.availableProperties.h[He.META_DATA_URL_HL_KEY] = "https://md-hl.apptimize.com/api/metadata/v4/";
      var e = null;
      this.availableProperties.h[He.META_DATA_URL_KEY] = e, this.availableProperties.h[He.LOG_LEVEL_KEY] = "LOG_LEVEL_WARN", this.availableProperties.h[He.FOREGROUND_PERIOD_MS_KEY] = 1e4, this.availableProperties.h[He.RESULT_POST_DELAY_MS_KEY] = 6e4, this.availableProperties.h[He.ALTERATION_CACHE_SIZE_KEY] = 10, this.availableProperties.h[He.RESULTS_CACHE_SIZE_KEY] = 10, this.availableProperties.h[He.MAXIMUM_RESULT_ENTRIES_KEY] = 1e3, this.availableProperties.h[He.MAXIMUM_PENDING_RESULTS_KEY] = 1e3, this.availableProperties.h[He.METADATA_POLLING_INTERVAL_MS_KEY] = 6e5, this.availableProperties.h[He.MAXIMUM_RESULT_POST_FAILURE_KEY] = 3, this.availableProperties.h[He.MAXIMUM_RESULT_POST_SENDER_TIMEOUT_MS_KEY] = 3e3, this.availableProperties.h[He.METADATA_POLLING_BACKGROUND_INTERVAL_MS_KEY] = 864e5;
      e = null;
      this.availableProperties.h[He.STORAGE_TYPE_KEY] = e;
      e = null;
      this.availableProperties.h[He.APPTIMIZE_ENVIRONMENT_KEY] = e, this.availableProperties.h[He.AUTOMATIC_SHUTDOWN_HOOK] = !0, this.availableProperties.h[He.GROUPS_BASE_URL_KEY] = "https://mapi.apptimize.com", this.availableProperties.h[He.LOCAL_DISK_STORAGE_PATH_KEY] = "data/apptimize/";
      e = null;
      this.availableProperties.h[He.REACT_NATIVE_STORAGE_KEY] = e, this.availableProperties.h[He.APPTIMIZE_MAXEXP_SEED_KEY] = 137900, this.availableProperties.h[He.THREADING_ENABLED_KEY] = !1, this.availableProperties.h[He.RESULT_POST_THREAD_POOL_SIZE_KEY] = 1, this.availableProperties.h[He.EXCEPTIONS_ENABLED_KEY] = !1, this.availableProperties.h[He.COMPRESS_PERSISTENCE_STORE_KEY] = !0;
    },
    __class__: He
  });
  var Je = w["apptimize.support.properties.CustomPropertyNamespace"] = {
    __ename__: "apptimize.support.properties.CustomPropertyNamespace",
    __constructs__: null,
    UserAttribute: {
      _hx_name: "UserAttribute",
      _hx_index: 0,
      __enum__: "apptimize.support.properties.CustomPropertyNamespace",
      toString: n
    },
    ApptimizeLocal: {
      _hx_name: "ApptimizeLocal",
      _hx_index: 1,
      __enum__: "apptimize.support.properties.CustomPropertyNamespace",
      toString: n
    },
    ApptimizeInternal: {
      _hx_name: "ApptimizeInternal",
      _hx_index: 2,
      __enum__: "apptimize.support.properties.CustomPropertyNamespace",
      toString: n
    },
    Mixpanel: {
      _hx_name: "Mixpanel",
      _hx_index: 3,
      __enum__: "apptimize.support.properties.CustomPropertyNamespace",
      toString: n
    }
  };
  Je.__constructs__ = [Je.UserAttribute, Je.ApptimizeLocal, Je.ApptimizeInternal, Je.Mixpanel];

  var We = function We() {
    Ye.call(this);
  };

  (r["apptimize.support.properties.ABTCustomProperties"] = We).__name__ = "apptimize.support.properties.ABTCustomProperties", We.__super__ = Ye, We.prototype = a(Ye.prototype, {
    setPropertyDefaults: function setPropertyDefaults() {},
    setProperty: function setProperty(e, t) {
      this.setPropertyForNamespace(e, t, Je.UserAttribute);
    },
    setPropertyForNamespace: function setPropertyForNamespace(e, t, r) {
      Ye.prototype.setProperty.call(this, this.sigilForNamespace(r) + e, t);
    },
    sigilForNamespace: function sigilForNamespace(e) {
      switch (e._hx_index) {
        case 0:
          return "%";

        case 1:
          return "l";

        case 2:
          return "^";

        case 3:
          return "m";
      }
    },
    isNamespacedPropertyAvailable: function isNamespacedPropertyAvailable(e, t) {
      return Ye.prototype.isPropertyAvailable.call(this, this.sigilForNamespace(t) + e);
    },
    valueForNamespacedProperty: function valueForNamespacedProperty(e, t) {
      return Ye.prototype.valueForProperty.call(this, this.sigilForNamespace(t) + e);
    },
    addJSONProperties: function addJSONProperties(e) {
      for (var t = this.availableProperties.h, r = Object.keys(t), i = r.length, n = 0; n < i;) {
        var a = r[n++];

        if (a.charAt(0) != this.sigilForNamespace(Je.ApptimizeLocal)) {
          var s = this.availableProperties.h[a];
          e.h[a] = s;
        }
      }
    },
    __class__: We
  });

  var Xe = function Xe() {
    We.call(this);
  };

  (r["apptimize.support.properties.ABTInternalProperties"] = Xe).__name__ = "apptimize.support.properties.ABTInternalProperties", Xe.sharedInstance = function () {
    return null == Xe._instance && (Xe._instance = new Xe()), Xe._instance;
  }, Xe.__super__ = We, Xe.prototype = a(We.prototype, {
    isPropertyAvailable: function isPropertyAvailable(e) {
      return this._loadProperties(), We.prototype.isPropertyAvailable.call(this, e);
    },
    valueForProperty: function valueForProperty(e) {
      return this._loadProperties(), this.availableProperties.h[e];
    },
    setProperty: function setProperty(e, t) {
      this.setPropertyForNamespace(e, t, Je.ApptimizeInternal);
    },
    _loadProperties: function _loadProperties() {
      this.availableProperties = Ge.loadObject(Ge.kInternalPropertiesKey), null == this.availableProperties && (this.availableProperties = new D());
    },
    _saveProperties: function _saveProperties() {
      Ge.saveObject(Ge.kInternalPropertiesKey, this.availableProperties);
    },
    setPropertyForNamespace: function setPropertyForNamespace(e, t, r) {
      this._loadProperties(), We.prototype.setPropertyForNamespace.call(this, e, t, r), this._saveProperties();
    },
    isNamespacedPropertyAvailable: function isNamespacedPropertyAvailable(e, t) {
      return this._loadProperties(), We.prototype.isNamespacedPropertyAvailable.call(this, e, t);
    },
    valueForNamespacedProperty: function valueForNamespacedProperty(e, t) {
      return this._loadProperties(), We.prototype.valueForNamespacedProperty.call(this, e, t);
    },
    __class__: Xe
  });

  var Ze = function Ze(e, t) {
    this.task = e, this.startTimestampMs = new Date().getTime() + t;
  };

  (r["apptimize.util.ABTDispatchTask"] = Ze).__name__ = "apptimize.util.ABTDispatchTask", Ze.prototype = {
    task: null,
    startTimestampMs: null,
    __class__: Ze
  };

  var Qe = function Qe() {};

  (r["apptimize.util.ABTException"] = Qe).__name__ = "apptimize.util.ABTException", Qe.throwException = function (e) {
    if (He.sharedInstance().valueForProperty(He.EXCEPTIONS_ENABLED_KEY)) throw ct.thrown(e);
  };

  var $e = function $e() {
    this.bytesBuffer = new Ct();
  };

  (r["apptimize.util.ABTHash"] = $e).__name__ = "apptimize.util.ABTHash", $e.Sha1 = function (e) {
    return It.make(e);
  }, $e.prototype = {
    bytesBuffer: null,
    push: function push(e) {
      this.bytesBuffer.addBytes(e, 0, e.length);
    },
    hash: function hash() {
      return $e.Sha1(this.bytesBuffer.getBytes());
    },
    __class__: $e
  };

  var et = function et() {};

  (r["apptimize.util.ABTInt64Utils"] = et).__name__ = "apptimize.util.ABTInt64Utils", et.toPreprocessedString = function (e) {
    return "wideInt_" + _t.toString(e) + "_wideInt";
  }, et._serializeInt64 = function (e, t) {
    t.serialize(e.high), t.serialize(e.low);
  }, et._deserializeInt64 = function (e) {
    return new mt(e.unserialize(), e.unserialize());
  };

  var tt = function tt() {};

  (r["apptimize.util.ABTJSONUtils"] = tt).__name__ = "apptimize.util.ABTJSONUtils", tt.stringify = function (e) {
    var t = Pt.print(e, null, null);
    return t = j.replace(t, '"wideInt_', ""), t = j.replace(t, '_wideInt"', "");
  };

  var rt = function rt(e) {
    this.cacheLock = f.getNewLock("ABTLRUCache_lock"), this._cacheSize = e, this.clear();
  };

  (r["apptimize.util.ABTLRUCache"] = rt).__name__ = "apptimize.util.ABTLRUCache", rt.prototype = {
    _cacheSize: null,
    _list: null,
    _map: null,
    cacheLock: null,
    clear: function clear(t, e) {
      this.cacheLock.acquire();

      try {
        if (null != t) for (var r = 0, i = this._list; r < i.length;) {
          var n = i[r];
          ++r;

          var a = function (e) {
            return function () {
              t(e[0]);
            };
          }([this._map.h[n]]);

          null != e ? e.dispatch(a, 0) : R.dispatchImmediately(a);
        }
        this._list = [], this._map = new D();
      } catch (r) {
        gt.lastError = r;
        var s = ct.caught(r).unwrap();
        throw this.cacheLock.release(), ct.thrown(s);
      }

      this.cacheLock.release();
    },
    hasKey: function hasKey(e) {
      var t = !1;
      this.cacheLock.acquire();

      try {
        t = null != this._map.h[e];
      } catch (e) {
        gt.lastError = e;
        var r = ct.caught(e).unwrap();
        throw this.cacheLock.release(), ct.thrown(r);
      }

      return this.cacheLock.release(), t;
    },
    getValue: function getValue(e) {
      var t = null;
      this.cacheLock.acquire();

      try {
        this.hasKey(e) && (t = this._map.h[e]);
      } catch (e) {
        gt.lastError = e;
        var r = ct.caught(e).unwrap();
        throw this.cacheLock.release(), ct.thrown(r);
      }

      return this.cacheLock.release(), t;
    },
    remove: function remove(e, t, r) {
      this.cacheLock.acquire();

      try {
        if (!this.hasKey(e)) return;

        if (null != t) {
          var i = this._map.h[e],
              n = function n() {
            t(i);
          };

          null != r ? r.dispatch(n, 0) : R.dispatchImmediately(n);
        }

        Y.remove(this._list, e);
        var a = this._map;
        Object.prototype.hasOwnProperty.call(a.h, e) && delete a.h[e];
      } catch (e) {
        gt.lastError = e;
        var s = ct.caught(e).unwrap();
        throw this.cacheLock.release(), ct.thrown(s);
      }

      this.cacheLock.release();
    },
    insert: function insert(e, t, r, i) {
      this.cacheLock.acquire();

      try {
        if (this.hasKey(e)) this._map.h[e] = t, Y.remove(this._list, e), this._list.push(e);else if (this._map.h[e] = t, this._list.push(e), this._list.length > this._cacheSize) {
          var n = this._list.shift();

          if (null != r) {
            t = this._map.h[n];

            var a = function a() {
              r(t);
            };

            null != i ? i.dispatch(a, 0) : R.dispatchImmediately(a);
          }

          var s = this._map;
          Object.prototype.hasOwnProperty.call(s.h, n) && delete s.h[n];
        }
      } catch (e) {
        gt.lastError = e;
        var l = ct.caught(e).unwrap();
        throw this.cacheLock.release(), ct.thrown(l);
      }

      this.cacheLock.release();
    },
    hxSerialize: function hxSerialize(e) {
      var t = new D();
      t.h._cacheSize = this._cacheSize, t.h._list = this._list, t.h._map = this._map;
      var r = t;
      e.serialize(r);
    },
    hxUnserialize: function hxUnserialize(e) {
      var t = e.unserialize();
      this._cacheSize = t.h._cacheSize, this._list = t.h._list, this._map = t.h._map, this.initMissingFields();
    },
    didUnserialize: function didUnserialize() {
      this.initMissingFields();
    },
    initMissingFields: function initMissingFields() {
      null == this.cacheLock && (this.cacheLock = f.getNewLock("ABTLRUCache_lock"));
    },
    __class__: rt
  };

  var it = function it() {};

  (r["apptimize.util.ABTTypes"] = it).__name__ = "apptimize.util.ABTTypes", it.isString = function (e) {
    var t = P.typeof(e);
    return 6 == t._hx_index && "String" == t.c.__name__;
  }, it.isNullOrString = function (e) {
    return null == e || it.isString(e);
  };

  var nt = function nt() {};

  (r["apptimize.util.ABTUserAgentParser"] = nt).__name__ = "apptimize.util.ABTUserAgentParser", nt.getBrowserName = function (e) {
    var t = nt.kBrowserUnknown;
    return 0 <= e.indexOf(nt.kBrowserSeaMonkey) ? t = nt.kBrowserSeaMonkey : 0 <= e.indexOf(nt.kBrowserFirefox) ? t = nt.kBrowserFirefox : 0 <= e.indexOf(nt.kBrowserFirefoxiOS) ? t = nt.kBrowserFirefoxiOS : 0 <= e.indexOf(nt.kBrowserInternetExplorer) ? t = nt.kBrowserInternetExplorer : 0 <= e.indexOf(nt.kBrowserInternetExplorer11) ? t = nt.kBrowserInternetExplorer11 : 0 <= e.indexOf(nt.kBrowserEdge) ? t = nt.kBrowserEdge : 0 <= e.indexOf(nt.kBrowserEdgeiOS) ? t = nt.kBrowserEdgeiOS : 0 <= e.indexOf(nt.kBrowserEdgeAndroid) ? t = nt.kBrowserEdgeAndroid : 0 <= e.indexOf(nt.kBrowserOperaNew) ? t = j.trim(nt.kBrowserOperaNew) : 0 <= e.indexOf(nt.kBrowserOpera) ? t = nt.kBrowserOpera : 0 <= e.indexOf(nt.kBrowserChromeiOS) ? t = nt.kBrowserChromeiOS : 0 <= e.indexOf(nt.kBrowserChrome) ? t = 0 <= e.indexOf(nt.kBrowserAndroidWebViewGeneral) && 0 <= e.indexOf(nt.kBrowserAndroidWebViewLAbove) ? j.trim(nt.kBrowserAndroidWebViewLAbove) : 0 <= e.indexOf(nt.kBrowserAndroidWebViewGeneral) && 0 <= e.indexOf(nt.kBrowserAndroidWebViewKtoL) ? j.trim(nt.kBrowserAndroidWebViewKtoL) : nt.kBrowserChrome : 0 <= e.indexOf(nt.kBrowserChromium) ? t = j.trim(nt.kBrowserChromium) : 0 <= e.indexOf(nt.kBrowserAndroidWebViewPreK) ? t = j.trim(nt.kBrowserAndroidWebViewPreK) : 0 <= e.indexOf(nt.kBrowserSafari) && (t = nt.kBrowserSafari), t;
  }, nt.getBrowserVersion = function (e) {
    var t = nt.kBrowserUnknown,
        r = nt.getBrowserName(e);

    if (r != nt.kBrowserUnknown) {
      j.trim(nt.kBrowserAndroidWebViewLAbove) == r || j.trim(nt.kBrowserAndroidWebViewKtoL) == r ? r = nt.kBrowserChrome : nt.kBrowserInternetExplorer == r && (r = nt.kBrowserInternetExplorer11);
      var i = r + "[ /]",
          n = new o("[; )$]", "");
      t = null == (t = new o(i, "").split(e)[1]) ? nt.kBrowserUnknown : n.split(t)[0];
    }

    return t;
  }, nt.getDeviceCategory = function (e) {
    var t = new o("Mobi", "").match(e),
        r = new o("iPad", "").match(e),
        i = new o("Android", "").match(e);
    return t && !r ? nt.kDeviceCategoryMobile : r || i && !t ? nt.kDeviceCategoryTablet : nt.kDeviceCategoryDesktop;
  }, nt.getHumanReadableBrowserName = function (e) {
    var t = nt.getBrowserName(e);
    return t == nt.kBrowserChrome || t == nt.kBrowserChromeiOS || t == nt.kBrowserChromium ? nt.kBrowserNameChrome : t == nt.kBrowserFirefox || t == nt.kBrowserFirefoxiOS ? nt.kBrowserNameFirefox : t == nt.kBrowserSafari ? nt.kBrowserNameSafari : t == nt.kBrowserInternetExplorer || t == nt.kBrowserInternetExplorer11 ? nt.kBrowserNameInternetExplorer : nt.kBrowserNameUnknown;
  };
  var at = w["apptimize.util.ArrayType"] = {
    __ename__: "apptimize.util.ArrayType",
    __constructs__: null,
    Int: {
      _hx_name: "Int",
      _hx_index: 0,
      __enum__: "apptimize.util.ArrayType",
      toString: n
    },
    Bool: {
      _hx_name: "Bool",
      _hx_index: 1,
      __enum__: "apptimize.util.ArrayType",
      toString: n
    },
    Double: {
      _hx_name: "Double",
      _hx_index: 2,
      __enum__: "apptimize.util.ArrayType",
      toString: n
    },
    String: {
      _hx_name: "String",
      _hx_index: 3,
      __enum__: "apptimize.util.ArrayType",
      toString: n
    },
    VariantInfo: {
      _hx_name: "VariantInfo",
      _hx_index: 4,
      __enum__: "apptimize.util.ArrayType",
      toString: n
    },
    WinnerVariantInfo: {
      _hx_name: "WinnerVariantInfo",
      _hx_index: 5,
      __enum__: "apptimize.util.ArrayType",
      toString: n
    }
  };
  at.__constructs__ = [at.Int, at.Bool, at.Double, at.String, at.VariantInfo, at.WinnerVariantInfo];

  var st = function st() {};

  (r["apptimize.util.ABTUtilArray"] = st).__name__ = "apptimize.util.ABTUtilArray", st.toNativeArray = function (e, t) {
    return e;
  };

  var lt = function lt() {};

  (r["apptimize.util.ABTUtilDictionary"] = lt).__name__ = "apptimize.util.ABTUtilDictionary", lt.dynamicToNativeDictionary = function (e) {
    var t = {},
        r = e;
    if (P.typeof(r) == p.TObject && (r = lt.dynamicObjectToStringMap(e)), null != r) for (var i = r.h, n = Object.keys(i), a = n.length, s = 0; s < a;) {
      var l = n[s++];
      t[l] = r.h[l];
    }
    return t;
  }, lt.stringMapToNativeDictionary = function (e) {
    var t = {};
    if (null != e) for (var r = e.h, i = Object.keys(r), n = i.length, a = 0; a < n;) {
      var s = i[a++];
      t[s] = e.h[s];
    }
    return t;
  }, lt.nativeObjectToStringMap = function (e) {
    return P.typeof(e) == p.TObject ? lt.dynamicObjectToStringMap(e) : or.getClass(e) == D ? e : lt.dynamicMapToStringMap(e);
  }, lt.dynamicObjectToStringMap = function (e) {
    for (var t = new D(), r = k.fields(e), i = 0; i < r.length;) {
      var n = r[i];
      ++i;
      var a = k.getProperty(e, n);
      t.h[n] = a;
    }

    return t;
  }, lt.dynamicMapToStringMap = function (e) {
    for (var t = new D(), r = e, i = 0, n = k.fields(r); i < n.length;) {
      var a = n[i];
      ++i, t.h[a] = r[a];
    }

    return t;
  }, lt.filterNullValues = function (e) {
    for (var t = new D(), r = e.h, i = Object.keys(r), n = i.length, a = 0; a < n;) {
      var s = i[a++],
          l = e.h[s];
      null != l && (t.h[s] = l);
    }

    return t;
  };

  var ot = function ot() {};

  (r["apptimize.util.ABTUtilGzip"] = ot).__name__ = "apptimize.util.ABTUtilGzip", ot.jsonSignatureLength = function (e) {
    var t = bt.ofData(e);
    return t.b[0] << 8 | t.b[1];
  }, ot.decompressBytes = function (e) {
    var t = Rt.fromBytes(e),
        r = null;

    try {
      r = Ue.inflate(t, {
        gzip: !0
      });
    } catch (e) {
      gt.lastError = e;
      var i = ct.caught(e).unwrap();
      return d.e("Error decompressing data " + O.string(i), {
        fileName: "src/apptimize/util/ABTUtilGzip.hx",
        lineNumber: 45,
        className: "apptimize.util.ABTUtilGzip",
        methodName: "decompressBytes"
      }), null;
    }

    return bt.ofData(r.buffer);
  }, ot.decompress = function (e) {
    var t = bt.ofData(e),
        r = ot.jsonSignatureLength(e) + 2,
        i = t.length - r,
        n = bt.ofData(e).sub(r, i);
    return ot.decompressBytes(n);
  }, ot.compress = function (e) {
    var t = Ue.deflate(Rt.fromBytes(e), {
      gzip: !0
    });
    return bt.ofData(t.buffer);
  }, ot.compressStringToBase64 = function (e) {
    if (null == e) return null;
    var t = bt.ofString(e),
        r = ot.compress(t);
    return xt.encode(r);
  }, ot.decompressBase64ToString = function (e) {
    if (null == e) return null;
    var t = xt.decode(e);
    return ot.decompressBytes(t).toString();
  };
  var ut = w["haxe.StackItem"] = {
    __ename__: "haxe.StackItem",
    __constructs__: null,
    CFunction: {
      _hx_name: "CFunction",
      _hx_index: 0,
      __enum__: "haxe.StackItem",
      toString: n
    },
    Module: (t = function t(e) {
      return {
        _hx_index: 1,
        m: e,
        __enum__: "haxe.StackItem",
        toString: n
      };
    }, t._hx_name = "Module", t.__params__ = ["m"], t),
    FilePos: (t = function t(e, _t2, r, i) {
      return {
        _hx_index: 2,
        s: e,
        file: _t2,
        line: r,
        column: i,
        __enum__: "haxe.StackItem",
        toString: n
      };
    }, t._hx_name = "FilePos", t.__params__ = ["s", "file", "line", "column"], t),
    Method: (t = function t(e, _t3) {
      return {
        _hx_index: 3,
        classname: e,
        method: _t3,
        __enum__: "haxe.StackItem",
        toString: n
      };
    }, t._hx_name = "Method", t.__params__ = ["classname", "method"], t),
    LocalFunction: (t = function t(e) {
      return {
        _hx_index: 4,
        v: e,
        __enum__: "haxe.StackItem",
        toString: n
      };
    }, t._hx_name = "LocalFunction", t.__params__ = ["v"], t)
  };
  ut.__constructs__ = [ut.CFunction, ut.Module, ut.FilePos, ut.Method, ut.LocalFunction];

  var pt = {
    callStack: function callStack() {
      return gt.toHaxe(gt.callStack());
    },
    exceptionStack: function exceptionStack(e) {
      null == e && (e = !1);
      var t = gt.toHaxe(gt.exceptionStack());
      return e ? t : pt.subtract(t, pt.callStack());
    },
    toString: function toString(e) {
      for (var t = new u(), r = 0, i = e; r < i.length;) {
        var n = i[r];
        ++r, t.b += "\nCalled from ", pt.itemToString(t, n);
      }

      return t.b;
    },
    subtract: function subtract(e, t) {
      for (var r = -1, i = -1; ++i < e.length;) {
        for (var n = 0, a = t.length; n < a;) {
          var s = n++;

          if (pt.equalItems(e[i], t[s])) {
            if (r < 0 && (r = i), ++i >= e.length) break;
          } else r = -1;
        }

        if (0 <= r) break;
      }

      return 0 <= r ? e.slice(0, r) : e;
    },
    equalItems: function equalItems(e, t) {
      if (null == e) return null == t;

      switch (e._hx_index) {
        case 0:
          return null != t && 0 == t._hx_index;

        case 1:
          if (null == t) return !1;

          if (1 == t._hx_index) {
            var r = t.m;
            return e.m == r;
          }

          return !1;

        case 2:
          if (null == t) return !1;

          if (2 == t._hx_index) {
            var i = t.s,
                n = t.file,
                a = t.line,
                s = t.column,
                l = e.column,
                o = e.line,
                u = e.file,
                p = e.s;
            return u == n && o == a && l == s && pt.equalItems(p, i);
          }

          return !1;

        case 3:
          if (null == t) return !1;

          if (3 == t._hx_index) {
            var c = t.classname,
                h = t.method,
                _ = e.method;
            return e.classname == c && _ == h;
          }

          return !1;

        case 4:
          if (null == t) return !1;

          if (4 == t._hx_index) {
            var m = t.v;
            return e.v == m;
          }

          return !1;
      }
    },
    itemToString: function itemToString(e, t) {
      switch (t._hx_index) {
        case 0:
          e.b += "a C function";
          break;

        case 1:
          var r = t.m;
          e.b += "module ", e.b += null == r ? "null" : "" + r;
          break;

        case 2:
          var i = t.s,
              n = t.file,
              a = t.line,
              s = t.column;
          null != i && (pt.itemToString(e, i), e.b += " ("), e.b += null == n ? "null" : "" + n, e.b += " line ", e.b += null == a ? "null" : "" + a, null != s && (e.b += " column ", e.b += null == s ? "null" : "" + s), null != i && (e.b += ")");
          break;

        case 3:
          var l = t.classname,
              o = t.method;
          e.b += O.string(null == l ? "<unknown>" : l), e.b += ".", e.b += null == o ? "null" : "" + o;
          break;

        case 4:
          var u = t.v;
          e.b += "local function #", e.b += null == u ? "null" : "" + u;
      }
    }
  },
      ct = function ct(e, t, r) {
    Error.call(this, e), this.message = e, this.__previousException = t, this.__nativeException = null != r ? r : this, this.__skipStack = 0;
    var i = Error.prepareStackTrace;
    if (Error.prepareStackTrace = function (e) {
      return e.stack;
    }, r instanceof Error) this.stack = r.stack;else {
      var n = null;
      if (Error.captureStackTrace) Error.captureStackTrace(this, ct), n = this;else if (void 0 === (n = new Error()).stack) {
        try {
          throw n;
        } catch (e) {}

        this.__skipStack++;
      }
      this.stack = n.stack;
    }
    Error.prepareStackTrace = i;
  };

  (r["haxe.Exception"] = ct).__name__ = "haxe.Exception", ct.caught = function (e) {
    return e instanceof ct ? e : e instanceof Error ? new ct(e.message, null, e) : new Nt(e, null, e);
  }, ct.thrown = function (e) {
    if (e instanceof ct) return e.get_native();
    if (e instanceof Error) return e;
    var t = new Nt(e);
    return t.__skipStack++, t;
  }, ct.__super__ = Error, ct.prototype = a(Error.prototype, {
    __skipStack: null,
    __nativeException: null,
    __previousException: null,
    unwrap: function unwrap() {
      return this.__nativeException;
    },
    toString: function toString() {
      return this.get_message();
    },
    __shiftStack: function __shiftStack() {
      this.__skipStack++;
    },
    get_message: function get_message() {
      return this.message;
    },
    get_native: function get_native() {
      return this.__nativeException;
    },
    get_stack: function get_stack() {
      var e = this.__exceptionStack;

      if (null == e) {
        var t = gt.toHaxe(gt.normalize(this.stack), this.__skipStack);
        return this.setProperty("__exceptionStack", t), t;
      }

      return e;
    },
    setProperty: function setProperty(t, r) {
      try {
        Object.defineProperty(this, t, {
          value: r
        });
      } catch (e) {
        this[t] = r;
      }
    },
    __class__: ct,
    __properties__: {
      get_native: "get_native",
      get_stack: "get_stack",
      get_message: "get_message"
    }
  });

  var ht = {
    ucompare: function ucompare(e, t) {
      return e < 0 ? t < 0 ? ~t - ~e | 0 : 1 : t < 0 ? -1 : e - t | 0;
    }
  },
      _t = {
    toString: function toString(e) {
      var t = e,
          r = 0,
          i = 0;
      if (t.high == r && t.low == i) return "0";
      var n = "",
          a = !1;
      t.high < 0 && (a = !0);

      for (var s = e = new mt(0, 10);;) {
        r = 0, i = 0;
        if (t.high == r && t.low == i) break;

        var l = _t.divMod(t, s);

        if (l.modulus.high < 0) {
          var o = l.modulus,
              u = ~o.high,
              p = 1 + ~o.low | 0;

          if (0 == p) {
            u++;
            u |= 0;
          }

          n = p + n;

          var c = l.quotient,
              h = ~c.high,
              _ = 1 + ~c.low | 0;

          if (0 == _) {
            h++;
            h |= 0;
          }

          t = e = new mt(h, _);
        } else n = l.modulus.low + n, t = l.quotient;
      }

      return a && (n = "-" + n), n;
    },
    divMod: function divMod(e, t) {
      if (0 == t.high) switch (t.low) {
        case 0:
          throw ct.thrown("divide by zero");

        case 1:
          return {
            quotient: new mt(e.high, e.low),
            modulus: new mt(0, 0)
          };
      }
      var r,
          i = e.high < 0 != t.high < 0;

      if (e.high < 0) {
        var n = ~e.high;

        if (0 == (c = 1 + ~e.low | 0)) {
          n++;
          n |= 0;
        }

        r = new mt(n, c);
      } else {
        r = new mt(e.high, e.low);
      }

      if (t.high < 0) {
        n = ~t.high;

        if (0 == (c = 1 + ~t.low | 0)) {
          n++;
          n |= 0;
        }

        t = new mt(n, c);
      }

      for (var a = new mt(0, 0), s = new mt(0, 1); !(t.high < 0);) {
        var l = 0 != (p = ht.ucompare(t.high, r.high)) ? p : ht.ucompare(t.low, r.low),
            o = 1;
        if (0 == (o &= 63)) t = new mt(t.high, t.low);else if (o < 32) {
          t = new mt(t.high << o | t.low >>> 32 - o, t.low << o);
        } else {
          t = new mt(t.low << o - 32, 0);
        }
        var u = 1;
        if (0 == (u &= 63)) s = new mt(s.high, s.low);else if (u < 32) {
          s = new mt(s.high << u | s.low >>> 32 - u, s.low << u);
        } else {
          s = new mt(s.low << u - 32, 0);
        }
        if (0 <= l) break;
      }

      for (;;) {
        var p;
        if (0 == s.high && 0 == s.low) break;

        if (0 <= (0 != (p = ht.ucompare(r.high, t.high)) ? p : ht.ucompare(r.low, t.low))) {
          a = new mt(a.high | s.high, a.low | s.low);
          n = r.high - t.high | 0;
          var c = r.low - t.low | 0;

          if (ht.ucompare(r.low, t.low) < 0) {
            n--;
            n |= 0;
          }

          r = new mt(n, c);
        }

        o = 1;
        if (0 == (o &= 63)) s = new mt(s.high, s.low);else if (o < 32) {
          s = new mt(s.high >>> o, s.high << 32 - o | s.low >>> o);
        } else {
          s = new mt(0, s.high >>> o - 32);
        }
        u = 1;
        if (0 == (u &= 63)) t = new mt(t.high, t.low);else if (u < 32) {
          t = new mt(t.high >>> u, t.high << 32 - u | t.low >>> u);
        } else {
          t = new mt(0, t.high >>> u - 32);
        }
      }

      if (i) {
        n = ~a.high;

        if (0 == (c = 1 + ~a.low | 0)) {
          n++;
          n |= 0;
        }

        a = new mt(n, c);
      }

      if (e.high < 0) {
        n = ~r.high;

        if (0 == (c = 1 + ~r.low | 0)) {
          n++;
          n |= 0;
        }

        r = new mt(n, c);
      }

      return {
        quotient: a,
        modulus: r
      };
    }
  },
      mt = function mt(e, t) {
    this.high = e, this.low = t;
  };

  (r["haxe._Int64.___Int64"] = mt).__name__ = "haxe._Int64.___Int64", mt.prototype = {
    high: null,
    low: null,
    __class__: mt
  };

  var ft = function ft() {};

  (r["haxe.Int64Helper"] = ft).__name__ = "haxe.Int64Helper", ft.parseString = function (e) {
    var t = new mt(0, 0),
        r = new mt(0, 1),
        i = !1,
        n = j.trim(e);
    "-" == n.charAt(0) && (i = !0, n = n.substring(1, n.length));

    for (var a = n.length, s = 0, l = a; s < l;) {
      var o = s++,
          u = Y.cca(n, a - 1 - o) - 48;
      if (u < 0 || 9 < u) throw ct.thrown("NumberFormatError");

      if (0 != u) {
        var p = u >> 31,
            c = u;

        if (i) {
          var h = 65535 & r.low,
              _ = r.low >>> 16,
              m = 65535 & c,
              f = c >>> 16,
              d = ht._mul(h, m),
              g = ht._mul(_, m),
              v = ht._mul(h, f),
              A = d,
              T = (ht._mul(_, f) + (v >>> 16) | 0) + (g >>> 16) | 0;

          if (A = A + (v <<= 16) | 0, ht.ucompare(A, v) < 0) {
            T++;
            T |= 0;
          }

          if (A = A + (g <<= 16) | 0, ht.ucompare(A, g) < 0) {
            T++;
            T |= 0;
          }

          var y = T = T + (ht._mul(r.low, p) + ht._mul(r.high, c) | 0) | 0,
              N = A,
              b = t.high - y | 0,
              S = t.low - N | 0;

          if (ht.ucompare(t.low, N) < 0) {
            b--;
            b |= 0;
          }

          if (!((t = new mt(b, S)).high < 0)) throw ct.thrown("NumberFormatError: Underflow");
        } else {
          var x = 65535 & r.low,
              E = r.low >>> 16,
              I = 65535 & c,
              w = c >>> 16,
              z = ht._mul(x, I),
              B = ht._mul(E, I),
              F = ht._mul(x, w),
              k = z,
              O = (ht._mul(E, w) + (F >>> 16) | 0) + (B >>> 16) | 0;

          if (k = k + (F <<= 16) | 0, ht.ucompare(k, F) < 0) {
            O++;
            O |= 0;
          }

          if (k = k + (B <<= 16) | 0, ht.ucompare(k, B) < 0) {
            O++;
            O |= 0;
          }

          var P = O = O + (ht._mul(r.low, p) + ht._mul(r.high, c) | 0) | 0,
              C = k,
              D = t.high + P | 0,
              R = t.low + C | 0;

          if (ht.ucompare(R, t.low) < 0) {
            D++;
            D |= 0;
          }

          if ((t = new mt(D, R)).high < 0) throw ct.thrown("NumberFormatError: Overflow");
        }
      }

      var L = 65535 & r.low,
          U = r.low >>> 16,
          M = ht._mul(L, 10),
          V = ht._mul(U, 10),
          K = ht._mul(L, 0),
          q = M,
          G = (ht._mul(U, 0) + (K >>> 16) | 0) + (V >>> 16) | 0;

      if (q = q + (K <<= 16) | 0, ht.ucompare(q, K) < 0) {
        G++;
        G |= 0;
      }

      if (q = q + (V <<= 16) | 0, ht.ucompare(q, V) < 0) {
        G++;
        G |= 0;
      }

      G = G + (ht._mul(r.low, 0) + ht._mul(r.high, 10) | 0) | 0, r = new mt(G, q);
    }

    return t;
  }, ft.fromFloat = function (e) {
    if (isNaN(e) || !isFinite(e)) throw ct.thrown("Number is NaN or Infinite");
    var t = e - e % 1;
    if (9007199254740991 < t) throw ct.thrown("Conversion overflow");
    if (t < -9007199254740991) throw ct.thrown("Conversion underflow");

    for (var r = new mt(0, 0), i = t < 0, n = i ? -t : t, a = 0; 1 <= n;) {
      var s = n % 2;

      if (n /= 2, 1 <= s) {
        var l,
            o = a;
        if (0 == (o &= 63)) l = new mt(0, 1);else if (o < 32) {
          l = new mt(0 << o | 1 >>> 32 - o, 1 << o);
        } else {
          l = new mt(1 << o - 32, 0);
        }
        var u = r.high + l.high | 0,
            p = r.low + l.low | 0;

        if (ht.ucompare(p, r.low) < 0) {
          u++;
          u |= 0;
        }

        r = new mt(u, p);
      }

      ++a;
    }

    if (i) {
      u = ~r.high;

      if (0 == (p = 1 + ~r.low | 0)) {
        u++;
        u |= 0;
      }

      r = new mt(u, p);
    }

    return r;
  };

  var dt = function dt() {};

  (r["haxe.Log"] = dt).__name__ = "haxe.Log", dt.formatOutput = function (e, t) {
    var r = O.string(e);
    if (null == t) return r;
    var i = t.fileName + ":" + t.lineNumber;
    if (null != t.customParams) for (var n = 0, a = t.customParams; n < a.length;) {
      e = a[n];
      ++n, r += ", " + O.string(e);
    }
    return i + ": " + r;
  }, dt.trace = function (e, t) {
    var r = dt.formatOutput(e, t);
    "undefined" != typeof console && null != console.log && console.log(r);
  };

  var gt = function gt() {};

  (r["haxe.NativeStackTrace"] = gt).__name__ = "haxe.NativeStackTrace", gt.saveStack = function (e) {
    gt.lastError = e;
  }, gt.callStack = function () {
    var e = new Error(""),
        t = gt.tryHaxeStack(e);

    if (void 0 === t) {
      try {
        throw e;
      } catch (e) {}

      t = e.stack;
    }

    return gt.normalize(t, 2);
  }, gt.exceptionStack = function () {
    return gt.normalize(gt.tryHaxeStack(gt.lastError));
  }, gt.toHaxe = function (e, t) {
    if (null == t && (t = 0), null == e) return [];

    if ("string" == typeof e) {
      var r = e.split("\n");
      "Error" == r[0] && r.shift();

      for (var i = [], n = 0, a = r.length; n < a;) {
        var s = n++;

        if (!(s < t)) {
          var l = r[s],
              o = l.match(/^    at ([A-Za-z0-9_. ]+) \(([^)]+):([0-9]+):([0-9]+)\)$/);

          if (null != o) {
            var u = o[1].split(".");
            "$hxClasses" == u[0] && u.shift();

            var p = u.pop(),
                c = o[2],
                h = O.parseInt(o[3]),
                _ = O.parseInt(o[4]);

            i.push(ut.FilePos("Anonymous function" == p ? ut.LocalFunction() : "Global code" == p ? null : ut.Method(u.join("."), p), c, h, _));
          } else i.push(ut.Module(j.trim(l)));
        }
      }

      return i;
    }

    return 0 < t && Array.isArray(e) ? e.slice(t) : e;
  }, gt.tryHaxeStack = function (e) {
    if (null == e) return [];
    var t = Error.prepareStackTrace;
    Error.prepareStackTrace = gt.prepareHxStackTrace;
    var r = e.stack;
    return Error.prepareStackTrace = t, r;
  }, gt.prepareHxStackTrace = function (e, t) {
    for (var r = [], i = 0; i < t.length;) {
      var n = t[i];
      ++i, null != gt.wrapCallSite && (n = gt.wrapCallSite(n));
      var a = null,
          s = n.getFunctionName();

      if (null != s) {
        var l = s.lastIndexOf(".");

        if (0 <= l) {
          var o = s.substring(0, l),
              u = s.substring(l + 1);
          a = ut.Method(o, u);
        } else a = ut.Method(null, s);
      }

      var p = n.getFileName(),
          c = null == p ? -1 : p.indexOf("file:");
      null != gt.wrapCallSite && 0 < c && (p = p.substring(c + 6)), r.push(ut.FilePos(a, p, n.getLineNumber(), n.getColumnNumber()));
    }

    return r;
  }, gt.normalize = function (e, t) {
    if (null == t && (t = 0), Array.isArray(e) && 0 < t) return e.slice(t);

    if ("string" == typeof e) {
      switch (e.substring(0, 6)) {
        case "Error\n":
        case "Error:":
          ++t;
      }

      return gt.skipLines(e, t);
    }

    return e;
  }, gt.skipLines = function (e, t, r) {
    return null == r && (r = 0), 0 < t ? (r = e.indexOf("\n", r)) < 0 ? "" : gt.skipLines(e, --t, r + 1) : e.substring(r);
  };

  var vt = function vt() {
    this.buf = new u(), this.cache = [], this.useCache = vt.USE_CACHE, this.useEnumIndex = vt.USE_ENUM_INDEX, this.shash = new D(), this.scount = 0;
  };

  (r["haxe.Serializer"] = vt).__name__ = "haxe.Serializer", vt.prototype = {
    buf: null,
    cache: null,
    shash: null,
    scount: null,
    useCache: null,
    useEnumIndex: null,
    toString: function toString() {
      return this.buf.b;
    },
    serializeString: function serializeString(e) {
      var t = this.shash.h[e];
      if (null != t) return this.buf.b += "R", void (this.buf.b += null == t ? "null" : "" + t);
      this.shash.h[e] = this.scount++, this.buf.b += "y", e = encodeURIComponent(e), this.buf.b += O.string(e.length), this.buf.b += ":", this.buf.b += null == e ? "null" : "" + e;
    },
    serializeRef: function serializeRef(e) {
      for (var t = _typeof(e), r = 0, i = this.cache.length; r < i;) {
        var n = r++,
            a = this.cache[n];
        if (_typeof(a) == t && a == e) return this.buf.b += "r", this.buf.b += null == n ? "null" : "" + n, !0;
      }

      return this.cache.push(e), !1;
    },
    serializeFields: function serializeFields(e) {
      for (var t = 0, r = k.fields(e); t < r.length;) {
        var i = r[t];
        ++t, this.serializeString(i), this.serialize(k.field(e, i));
      }

      this.buf.b += "g";
    },
    serialize: function serialize(e) {
      switch ((E = P.typeof(e))._hx_index) {
        case 0:
          this.buf.b += "n";
          break;

        case 1:
          if (0 == (t = e)) return void (this.buf.b += "z");
          this.buf.b += "i", this.buf.b += null == t ? "null" : "" + t;
          break;

        case 2:
          var t = e;
          isNaN(t) ? this.buf.b += "k" : isFinite(t) ? (this.buf.b += "d", this.buf.b += null == t ? "null" : "" + t) : this.buf.b += t < 0 ? "m" : "p";
          break;

        case 3:
          this.buf.b += e ? "t" : "f";
          break;

        case 4:
          if (or.__instanceof(e, Tr)) {
            var r = e.__name__;
            this.buf.b += "A", this.serializeString(r);
          } else if (or.__instanceof(e, yr)) this.buf.b += "B", this.serializeString(e.__ename__);else {
            if (this.useCache && this.serializeRef(e)) return;
            this.buf.b += "o", this.serializeFields(e);
          }

          break;

        case 5:
          throw ct.thrown("Cannot serialize function");

        case 6:
          var i = E.c;
          if (i == String) return void this.serializeString(e);
          if (this.useCache && this.serializeRef(e)) return;

          switch (i) {
            case Array:
              var n = 0;
              this.buf.b += "a";

              for (var a = 0, s = e.length; a < s;) {
                null == e[h = a++] ? ++n : (0 < n && (1 == n ? this.buf.b += "n" : (this.buf.b += "u", this.buf.b += null == n ? "null" : "" + n), n = 0), this.serialize(e[h]));
              }

              0 < n && (1 == n ? this.buf.b += "n" : (this.buf.b += "u", this.buf.b += null == n ? "null" : "" + n)), this.buf.b += "h";
              break;

            case Date:
              var l = e;
              this.buf.b += "v", this.buf.b += O.string(l.getTime());
              break;

            case wt:
              this.buf.b += "q";

              for (var o = (t = e).keys(); o.hasNext();) {
                var u = o.next();
                this.buf.b += ":", this.buf.b += null == u ? "null" : "" + u, this.serialize(t.h[u]);
              }

              this.buf.b += "h";
              break;

            case zt:
              this.buf.b += "l";

              for (var p = (t = e).h; null != p;) {
                var c = p.item;
                p = p.next;
                var h = c;
                this.serialize(h);
              }

              this.buf.b += "h";
              break;

            case kt:
              this.buf.b += "M";

              for (o = (t = e).keys(); o.hasNext();) {
                u = o.next();

                var _ = k.field(u, "__id__");

                k.deleteField(u, "__id__"), this.serialize(u), u.__id__ = _, this.serialize(t.h[u.__id__]);
              }

              this.buf.b += "h";
              break;

            case D:
              this.buf.b += "b";

              for (var m = (t = e).h, f = Object.keys(m), d = f.length, g = 0; g < d;) {
                o = f[g++];
                this.serializeString(o), this.serialize(t.h[o]);
              }

              this.buf.b += "h";
              break;

            case bt:
              t = e;
              this.buf.b += "s", this.buf.b += O.string(Math.ceil(8 * t.length / 6)), this.buf.b += ":";
              h = 0;
              var v = t.length - 2,
                  A = vt.BASE64_CODES;

              if (null == A) {
                A = new Array(vt.BASE64.length);

                for (a = 0, s = vt.BASE64.length; a < s;) {
                  var T = a++;
                  A[T] = Y.cca(vt.BASE64, T);
                }

                vt.BASE64_CODES = A;
              }

              for (; h < v;) {
                var y = t.b[h++],
                    N = t.b[h++],
                    b = t.b[h++];
                this.buf.b += String.fromCodePoint(A[y >> 2]), this.buf.b += String.fromCodePoint(A[63 & (y << 4 | N >> 4)]), this.buf.b += String.fromCodePoint(A[63 & (N << 2 | b >> 6)]), this.buf.b += String.fromCodePoint(A[63 & b]);
              }

              if (h == v) {
                y = t.b[h++], N = t.b[h++];
                this.buf.b += String.fromCodePoint(A[y >> 2]), this.buf.b += String.fromCodePoint(A[63 & (y << 4 | N >> 4)]), this.buf.b += String.fromCodePoint(A[N << 2 & 63]);
              } else if (h == v + 1) {
                y = t.b[h++];
                this.buf.b += String.fromCodePoint(A[y >> 2]), this.buf.b += String.fromCodePoint(A[y << 4 & 63]);
              }

              break;

            default:
              this.useCache && this.cache.pop(), null != e.hxSerialize ? (this.buf.b += "C", this.serializeString(i.__name__), this.useCache && this.cache.push(e), e.hxSerialize(this), this.buf.b += "g") : (this.buf.b += "c", this.serializeString(i.__name__), this.useCache && this.cache.push(e), this.serializeFields(e));
          }

          break;

        case 7:
          var S = E.e;

          if (this.useCache) {
            if (this.serializeRef(e)) return;
            this.cache.pop();
          }

          if (this.buf.b += O.string(this.useEnumIndex ? "j" : "w"), this.serializeString(S.__ename__), this.useEnumIndex) this.buf.b += ":", this.buf.b += O.string(e._hx_index);else {
            S = e;
            this.serializeString(w[S.__enum__].__constructs__[S._hx_index]._hx_name);
          }
          this.buf.b += ":";
          var x = P.enumParameters(e);
          this.buf.b += O.string(x.length);

          for (var E = 0; E < x.length;) {
            var I = x[E];
            ++E, this.serialize(I);
          }

          this.useCache && this.cache.push(e);
          break;

        default:
          throw ct.thrown("Cannot serialize " + O.string(e));
      }
    },
    __class__: vt
  };

  var At = function At(e) {
    var t = this;
    this.id = setInterval(function () {
      t.run();
    }, e);
  };

  (r["haxe.Timer"] = At).__name__ = "haxe.Timer", At.delay = function (e, t) {
    var r = new At(t);
    return r.run = function () {
      r.stop(), e();
    }, r;
  }, At.prototype = {
    id: null,
    stop: function stop() {
      null != this.id && (clearInterval(this.id), this.id = null);
    },
    run: function run() {},
    __class__: At
  };

  var Tt = function Tt() {};

  (r["haxe._Unserializer.DefaultResolver"] = Tt).__name__ = "haxe._Unserializer.DefaultResolver", Tt.prototype = {
    resolveClass: function resolveClass(e) {
      return r[e];
    },
    resolveEnum: function resolveEnum(e) {
      return w[e];
    },
    __class__: Tt
  };

  var yt = function yt(e) {
    this.buf = e, this.length = this.buf.length, this.pos = 0, this.scache = [], this.cache = [];
    var t = yt.DEFAULT_RESOLVER;
    null == t && (t = new Tt(), yt.DEFAULT_RESOLVER = t), this.resolver = t;
  };

  (r["haxe.Unserializer"] = yt).__name__ = "haxe.Unserializer", yt.initCodes = function () {
    for (var e = [], t = 0, r = yt.BASE64.length; t < r;) {
      var i = t++;
      e[yt.BASE64.charCodeAt(i)] = i;
    }

    return e;
  }, yt.prototype = {
    buf: null,
    pos: null,
    length: null,
    cache: null,
    scache: null,
    resolver: null,
    readDigits: function readDigits() {
      for (var e = 0, t = !1, r = this.pos;;) {
        var i = this.buf.charCodeAt(this.pos);
        if (i != i) break;

        if (45 != i) {
          if (i < 48 || 57 < i) break;
          e = 10 * e + (i - 48), this.pos++;
        } else {
          if (this.pos != r) break;
          t = !0, this.pos++;
        }
      }

      return t && (e *= -1), e;
    },
    readFloat: function readFloat() {
      for (var e = this.pos;;) {
        var t = this.buf.charCodeAt(this.pos);
        if (t != t) break;
        if (!(43 <= t && t < 58 || 101 == t || 69 == t)) break;
        this.pos++;
      }

      return parseFloat(Y.substr(this.buf, e, this.pos - e));
    },
    unserializeObject: function unserializeObject(e) {
      for (;;) {
        if (this.pos >= this.length) throw ct.thrown("Invalid object");
        if (103 == this.buf.charCodeAt(this.pos)) break;
        var t = this.unserialize();
        if ("string" != typeof t) throw ct.thrown("Invalid object key");
        var r = this.unserialize();
        e[t] = r;
      }

      this.pos++;
    },
    unserializeEnum: function unserializeEnum(e, t) {
      if (58 != this.buf.charCodeAt(this.pos++)) throw ct.thrown("Invalid enum format");
      var r = this.readDigits();
      if (0 == r) return P.createEnum(e, t);

      for (var i = []; 0 < r--;) {
        i.push(this.unserialize());
      }

      return P.createEnum(e, t, i);
    },
    unserialize: function unserialize() {
      switch (this.buf.charCodeAt(this.pos++)) {
        case 65:
          var e = this.unserialize();
          if (null == (o = this.resolver.resolveClass(e))) throw ct.thrown("Class not found " + e);
          return o;

        case 66:
          e = this.unserialize();
          if (null == (f = this.resolver.resolveEnum(e))) throw ct.thrown("Enum not found " + e);
          return f;

        case 67:
          e = this.unserialize();
          if (null == (o = this.resolver.resolveClass(e))) throw ct.thrown("Class not found " + e);
          var t = Object.create(o.prototype);
          if (this.cache.push(t), t.hxUnserialize(this), 103 != this.buf.charCodeAt(this.pos++)) throw ct.thrown("Invalid custom data");
          return t;

        case 77:
          var r = new kt();
          this.cache.push(r);

          for (var i = this.buf; 104 != this.buf.charCodeAt(this.pos);) {
            var n = this.unserialize();
            r.set(n, this.unserialize());
          }

          return this.pos++, r;

        case 82:
          if ((s = this.readDigits()) < 0 || s >= this.scache.length) throw ct.thrown("Invalid string reference");
          return this.scache[s];

        case 97:
          i = this.buf;
          var a = [];

          for (this.cache.push(a);;) {
            if (104 == (g = this.buf.charCodeAt(this.pos))) {
              this.pos++;
              break;
            }

            if (117 == g) {
              this.pos++;
              var s = this.readDigits();
              a[a.length + s - 1] = null;
            } else a.push(this.unserialize());
          }

          return a;

        case 98:
          r = new D();
          this.cache.push(r);

          for (i = this.buf; 104 != this.buf.charCodeAt(this.pos);) {
            n = this.unserialize();
            var l = this.unserialize();
            r.h[n] = l;
          }

          return this.pos++, r;

        case 99:
          var o;
          e = this.unserialize();
          if (null == (o = this.resolver.resolveClass(e))) throw ct.thrown("Class not found " + e);
          t = Object.create(o.prototype);
          return this.cache.push(t), this.unserializeObject(t), t;

        case 100:
          return this.readFloat();

        case 102:
          return !1;

        case 105:
          return this.readDigits();

        case 106:
          e = this.unserialize();
          if (null == (B = this.resolver.resolveEnum(e))) throw ct.thrown("Enum not found " + e);
          this.pos++;

          for (var u = this.readDigits(), p = B.__constructs__, c = new Array(p.length), h = 0, _ = p.length; h < _;) {
            c[v = h++] = p[v]._hx_name;
          }

          var m = c[u];
          if (null == m) throw ct.thrown("Unknown enum index " + e + "@" + u);
          var f = this.unserializeEnum(B, m);
          return this.cache.push(f), f;

        case 107:
          return NaN;

        case 108:
          var d = new zt();
          this.cache.push(d);

          for (i = this.buf; 104 != this.buf.charCodeAt(this.pos);) {
            d.add(this.unserialize());
          }

          return this.pos++, d;

        case 109:
          return -1 / 0;

        case 110:
          return null;

        case 111:
          t = {};
          return this.cache.push(t), this.unserializeObject(t), t;

        case 112:
          return 1 / 0;

        case 113:
          r = new wt();
          this.cache.push(r);
          i = this.buf;

          for (var g = this.buf.charCodeAt(this.pos++); 58 == g;) {
            var v = this.readDigits();
            l = this.unserialize();
            r.h[v] = l, g = this.buf.charCodeAt(this.pos++);
          }

          if (104 != g) throw ct.thrown("Invalid IntMap format");
          return r;

        case 114:
          if ((s = this.readDigits()) < 0 || s >= this.cache.length) throw ct.thrown("Invalid reference");
          return this.cache[s];

        case 115:
          var A = this.readDigits();
          i = this.buf;
          if (58 != this.buf.charCodeAt(this.pos++) || this.length - this.pos < A) throw ct.thrown("Invalid bytes length");
          var T = yt.CODES;
          null == T && (T = yt.initCodes(), yt.CODES = T);

          for (var y = 3 & A, N = (v = this.pos) + (A - y), b = new bt(new ArrayBuffer(3 * (A >> 2) + (2 <= y ? y - 1 : 0))), S = 0; v < N;) {
            var x = T[i.charCodeAt(v++)],
                E = T[i.charCodeAt(v++)];
            b.b[S++] = x << 2 | E >> 4;
            var I = T[i.charCodeAt(v++)];
            b.b[S++] = E << 4 | I >> 2;
            var w = T[i.charCodeAt(v++)];
            b.b[S++] = I << 6 | w;
          }

          if (2 <= y) {
            x = T[i.charCodeAt(v++)], E = T[i.charCodeAt(v++)];

            if (b.b[S++] = x << 2 | E >> 4, 3 == y) {
              I = T[i.charCodeAt(v++)];
              b.b[S++] = E << 4 | I >> 2;
            }
          }

          return this.pos += A, this.cache.push(b), b;

        case 116:
          return !0;

        case 118:
          var z;
          return 48 <= this.buf.charCodeAt(this.pos) && this.buf.charCodeAt(this.pos) <= 57 && 48 <= this.buf.charCodeAt(this.pos + 1) && this.buf.charCodeAt(this.pos + 1) <= 57 && 48 <= this.buf.charCodeAt(this.pos + 2) && this.buf.charCodeAt(this.pos + 2) <= 57 && 48 <= this.buf.charCodeAt(this.pos + 3) && this.buf.charCodeAt(this.pos + 3) <= 57 && 45 == this.buf.charCodeAt(this.pos + 4) ? (z = Y.strDate(Y.substr(this.buf, this.pos, 19)), this.pos += 19) : z = new Date(this.readFloat()), this.cache.push(z), z;

        case 119:
          var B;
          e = this.unserialize();
          if (null == (B = this.resolver.resolveEnum(e))) throw ct.thrown("Enum not found " + e);
          f = this.unserializeEnum(B, this.unserialize());
          return this.cache.push(f), f;

        case 120:
          throw ct.thrown(this.unserialize());

        case 121:
          A = this.readDigits();
          if (58 != this.buf.charCodeAt(this.pos++) || this.length - this.pos < A) throw ct.thrown("Invalid string length");
          n = Y.substr(this.buf, this.pos, A);
          return this.pos += A, n = decodeURIComponent(n.split("+").join(" ")), this.scache.push(n), n;

        case 122:
          return 0;
      }

      throw this.pos--, ct.thrown("Invalid char " + this.buf.charAt(this.pos) + " at position " + this.pos);
    },
    __class__: yt
  };

  var Nt = function Nt(e, t, r) {
    ct.call(this, String(e), t, r), this.value = e, this.__skipStack++;
  };

  (r["haxe.ValueException"] = Nt).__name__ = "haxe.ValueException", Nt.__super__ = ct, Nt.prototype = a(ct.prototype, {
    value: null,
    unwrap: function unwrap() {
      return this.value;
    },
    __class__: Nt
  });

  var bt = function bt(e) {
    this.length = e.byteLength, this.b = new Uint8Array(e), (this.b.bufferValue = e).hxBytes = this, e.bytes = this.b;
  };

  (r["haxe.io.Bytes"] = bt).__name__ = "haxe.io.Bytes", bt.ofString = function (e, t) {
    if (t == St.RawNative) {
      for (var r = new Uint8Array(e.length << 1), i = 0, n = e.length; i < n;) {
        var a = i++,
            s = e.charCodeAt(a);
        r[a << 1] = 255 & s, r[a << 1 | 1] = s >> 8;
      }

      return new bt(r.buffer);
    }

    var l = [];

    for (a = 0; a < e.length;) {
      55296 <= (s = e.charCodeAt(a++)) && s <= 56319 && (s = s - 55232 << 10 | 1023 & e.charCodeAt(a++)), s <= 127 ? l.push(s) : (s <= 2047 ? l.push(192 | s >> 6) : (s <= 65535 ? l.push(224 | s >> 12) : (l.push(240 | s >> 18), l.push(128 | s >> 12 & 63)), l.push(128 | s >> 6 & 63)), l.push(128 | 63 & s));
    }

    return new bt(new Uint8Array(l).buffer);
  }, bt.ofData = function (e) {
    var t = e.hxBytes;
    return null != t ? t : new bt(e);
  }, bt.prototype = {
    length: null,
    b: null,
    sub: function sub(e, t) {
      if (e < 0 || t < 0 || e + t > this.length) throw ct.thrown(Dt.OutsideBounds);
      return new bt(this.b.buffer.slice(e + this.b.byteOffset, e + this.b.byteOffset + t));
    },
    getString: function getString(e, t, r) {
      if (e < 0 || t < 0 || e + t > this.length) throw ct.thrown(Dt.OutsideBounds);
      null == r && (r = St.UTF8);
      var i = "",
          n = this.b,
          a = e,
          s = e + t;

      switch (r._hx_index) {
        case 0:
          for (; a < s;) {
            if ((p = n[a++]) < 128) {
              if (0 == p) break;
              i += String.fromCodePoint(p);
            } else if (p < 224) {
              var l = (63 & p) << 6 | 127 & n[a++];
              i += String.fromCodePoint(l);
            } else if (p < 240) {
              var o = (31 & p) << 12 | (127 & n[a++]) << 6 | 127 & n[a++];
              i += String.fromCodePoint(o);
            } else {
              var u = (15 & p) << 18 | (127 & n[a++]) << 12 | (127 & n[a++]) << 6 | 127 & n[a++];
              i += String.fromCodePoint(u);
            }
          }

          break;

        case 1:
          for (; a < s;) {
            var p = n[a++] | n[a++] << 8;
            i += String.fromCodePoint(p);
          }

      }

      return i;
    },
    toString: function toString() {
      return this.getString(0, this.length);
    },
    toHex: function toHex() {
      for (var e = "", t = [], r = "0123456789abcdef", i = 0, n = r.length; i < n;) {
        var a = i++;
        t.push(Y.cca(r, a));
      }

      for (i = 0, n = this.length; i < n;) {
        a = i++;
        var s = this.b[a];
        e += String.fromCodePoint(t[s >> 4]), e += String.fromCodePoint(t[15 & s]);
      }

      return e;
    },
    __class__: bt
  };
  var St = w["haxe.io.Encoding"] = {
    __ename__: "haxe.io.Encoding",
    __constructs__: null,
    UTF8: {
      _hx_name: "UTF8",
      _hx_index: 0,
      __enum__: "haxe.io.Encoding",
      toString: n
    },
    RawNative: {
      _hx_name: "RawNative",
      _hx_index: 1,
      __enum__: "haxe.io.Encoding",
      toString: n
    }
  };
  St.__constructs__ = [St.UTF8, St.RawNative];

  var xt = function xt() {};

  (r["haxe.crypto.Base64"] = xt).__name__ = "haxe.crypto.Base64", xt.encode = function (e, t) {
    null == t && (t = !0);
    var r = new Et(xt.BYTES).encodeBytes(e).toString();
    if (t) switch (e.length % 3) {
      case 1:
        r += "==";
        break;

      case 2:
        r += "=";
    }
    return r;
  }, xt.decode = function (e, t) {
    if (null == t && (t = !0), t) for (; 61 == Y.cca(e, e.length - 1);) {
      e = Y.substr(e, 0, -1);
    }
    return new Et(xt.BYTES).decodeBytes(bt.ofString(e));
  };

  var Et = function Et(e) {
    for (var t = e.length, r = 1; 1 << r < t;) {
      ++r;
    }

    if (8 < r || t != 1 << r) throw ct.thrown("BaseCode : base length must be a power of two.");
    this.base = e, this.nbits = r;
  };

  (r["haxe.crypto.BaseCode"] = Et).__name__ = "haxe.crypto.BaseCode", Et.prototype = {
    base: null,
    nbits: null,
    tbl: null,
    encodeBytes: function encodeBytes(e) {
      for (var t = this.nbits, r = this.base, i = 8 * e.length / t | 0, n = new bt(new ArrayBuffer(i + (8 * e.length % t == 0 ? 0 : 1))), a = 0, s = 0, l = (1 << t) - 1, o = 0, u = 0; u < i;) {
        for (; s < t;) {
          s += 8, a <<= 8, a |= e.b[o++];
        }

        s -= t, n.b[u++] = r.b[a >> s & l];
      }

      return 0 < s && (n.b[u++] = r.b[a << t - s & l]), n;
    },
    initTable: function initTable() {
      for (var e = [], t = 0; t < 256;) {
        e[i = t++] = -1;
      }

      t = 0;

      for (var r = this.base.length; t < r;) {
        var i = t++;
        e[this.base.b[i]] = i;
      }

      this.tbl = e;
    },
    decodeBytes: function decodeBytes(e) {
      var t = this.nbits;
      this.base;
      null == this.tbl && this.initTable();

      for (var r = this.tbl, i = e.length * t >> 3, n = new bt(new ArrayBuffer(i)), a = 0, s = 0, l = 0, o = 0; o < i;) {
        for (; s < 8;) {
          s += t, a <<= t;
          var u = r[e.b[l++]];
          if (-1 == u) throw ct.thrown("BaseCode : invalid encoded char");
          a |= u;
        }

        s -= 8, n.b[o++] = a >> s & 255;
      }

      return n;
    },
    __class__: Et
  };

  var It = function It() {};

  (r["haxe.crypto.Sha1"] = It).__name__ = "haxe.crypto.Sha1", It.make = function (e) {
    var t = new It().doEncode(It.bytes2blks(e)),
        r = new bt(new ArrayBuffer(20)),
        i = 0;
    return r.b[i++] = t[0] >>> 24, r.b[i++] = t[0] >> 16 & 255, r.b[i++] = t[0] >> 8 & 255, r.b[i++] = 255 & t[0], r.b[i++] = t[1] >>> 24, r.b[i++] = t[1] >> 16 & 255, r.b[i++] = t[1] >> 8 & 255, r.b[i++] = 255 & t[1], r.b[i++] = t[2] >>> 24, r.b[i++] = t[2] >> 16 & 255, r.b[i++] = t[2] >> 8 & 255, r.b[i++] = 255 & t[2], r.b[i++] = t[3] >>> 24, r.b[i++] = t[3] >> 16 & 255, r.b[i++] = t[3] >> 8 & 255, r.b[i++] = 255 & t[3], r.b[i++] = t[4] >>> 24, r.b[i++] = t[4] >> 16 & 255, r.b[i++] = t[4] >> 8 & 255, r.b[i++] = 255 & t[4], r;
  }, It.bytes2blks = function (e) {
    for (var t = 1 + (e.length + 8 >> 6), r = [], i = 0, n = 16 * t; i < n;) {
      r[a = i++] = 0;
    }

    for (i = 0, n = e.length; i < n;) {
      r[(a = i++) >> 2] |= e.b[a] << 24 - ((3 & a) << 3);
    }

    var a;
    return r[(a = e.length) >> 2] |= 128 << 24 - ((3 & a) << 3), r[16 * t - 1] = 8 * e.length, r;
  }, It.prototype = {
    doEncode: function doEncode(e) {
      for (var t = [], r = 1732584193, i = -271733879, n = -1732584194, a = 271733878, s = -1009589776, l = 0; l < e.length;) {
        for (var o = r, u = i, p = n, c = a, h = s, _ = 0; _ < 80;) {
          if (_ < 16) t[_] = e[l + _];else {
            var m = t[_ - 3] ^ t[_ - 8] ^ t[_ - 14] ^ t[_ - 16];
            t[_] = m << 1 | m >>> 31;
          }
          var f = (r << 5 | r >>> 27) + this.ft(_, i, n, a) + s + t[_] + this.kt(_);
          s = a, a = n, n = i << 30 | i >>> 2, i = r, r = f, ++_;
        }

        r += o, i += u, n += p, a += c, s += h, l += 16;
      }

      return [r, i, n, a, s];
    },
    ft: function ft(e, t, r, i) {
      return e < 20 ? t & r | ~t & i : e < 40 ? t ^ r ^ i : e < 60 ? t & r | t & i | r & i : t ^ r ^ i;
    },
    kt: function kt(e) {
      return e < 20 ? 1518500249 : e < 40 ? 1859775393 : e < 60 ? -1894007588 : -899497514;
    },
    __class__: It
  };

  var wt = function wt() {
    this.h = {};
  };

  (r["haxe.ds.IntMap"] = wt).__name__ = "haxe.ds.IntMap", wt.__interfaces__ = [b], wt.prototype = {
    h: null,
    keys: function keys() {
      var e = [];

      for (var t in this.h) {
        this.h.hasOwnProperty(t) && e.push(+t);
      }

      return new Lt(e);
    },
    iterator: function iterator() {
      return {
        ref: this.h,
        it: this.keys(),
        hasNext: function hasNext() {
          return this.it.hasNext();
        },
        next: function next() {
          var e = this.it.next();
          return this.ref[e];
        }
      };
    },
    __class__: wt
  };

  var zt = function zt() {
    this.length = 0;
  };

  (r["haxe.ds.List"] = zt).__name__ = "haxe.ds.List", zt.prototype = {
    h: null,
    q: null,
    length: null,
    add: function add(e) {
      var t = new Bt(e, null);
      null == this.h ? this.h = t : this.q.next = t, this.q = t, this.length++;
    },
    pop: function pop() {
      if (null == this.h) return null;
      var e = this.h.item;
      return this.h = this.h.next, null == this.h && (this.q = null), this.length--, e;
    },
    isEmpty: function isEmpty() {
      return null == this.h;
    },
    remove: function remove(e) {
      for (var t = null, r = this.h; null != r;) {
        if (r.item == e) return null == t ? this.h = r.next : t.next = r.next, this.q == r && (this.q = t), this.length--, !0;
        r = (t = r).next;
      }

      return !1;
    },
    iterator: function iterator() {
      return new Ft(this.h);
    },
    filter: function filter(e) {
      for (var t = new zt(), r = this.h; null != r;) {
        var i = r.item;
        r = r.next, e(i) && t.add(i);
      }

      return t;
    },
    __class__: zt
  };

  var Bt = function Bt(e, t) {
    this.item = e, this.next = t;
  };

  (r["haxe.ds._List.ListNode"] = Bt).__name__ = "haxe.ds._List.ListNode", Bt.prototype = {
    item: null,
    next: null,
    __class__: Bt
  };

  var Ft = function Ft(e) {
    this.head = e;
  };

  (r["haxe.ds._List.ListIterator"] = Ft).__name__ = "haxe.ds._List.ListIterator", Ft.prototype = {
    head: null,
    hasNext: function hasNext() {
      return null != this.head;
    },
    next: function next() {
      var e = this.head.item;
      return this.head = this.head.next, e;
    },
    __class__: Ft
  };

  var kt = function kt() {
    this.h = {
      __keys__: {}
    };
  };

  (r["haxe.ds.ObjectMap"] = kt).__name__ = "haxe.ds.ObjectMap", kt.__interfaces__ = [b], kt.prototype = {
    h: null,
    set: function set(e, t) {
      var r = e.__id__;
      null == r && (r = e.__id__ = i.$haxeUID++), this.h[r] = t, this.h.__keys__[r] = e;
    },
    keys: function keys() {
      var e = [];

      for (var t in this.h.__keys__) {
        this.h.hasOwnProperty(t) && e.push(this.h.__keys__[t]);
      }

      return new Lt(e);
    },
    __class__: kt
  };

  var Ot = function Ot(e) {
    this.str = e, this.pos = 0;
  };

  (r["haxe.format.JsonParser"] = Ot).__name__ = "haxe.format.JsonParser", Ot.prototype = {
    str: null,
    pos: null,
    doParse: function doParse() {
      for (var e, t = this.parseRec();;) {
        e = this.str.charCodeAt(this.pos++);
        if (e != e) break;

        switch (e) {
          case 9:
          case 10:
          case 13:
          case 32:
            break;

          default:
            this.invalidChar();
        }
      }

      return t;
    },
    parseRec: function parseRec() {
      for (;;) {
        var e = this.str.charCodeAt(this.pos++);

        switch (e) {
          case 9:
          case 10:
          case 13:
          case 32:
            break;

          case 34:
            return this.parseString();

          case 45:
          case 48:
          case 49:
          case 50:
          case 51:
          case 52:
          case 53:
          case 54:
          case 55:
          case 56:
          case 57:
            for (var t = e, r = this.pos - 1, i = 45 == t, n = !i, a = 48 == t, s = !1, l = !1, o = !1, u = !1;;) {
              switch (t = this.str.charCodeAt(this.pos++)) {
                case 43:
                case 45:
                  l && !o || this.invalidNumber(r), o = !(n = !1);
                  break;

                case 46:
                  (i || s || l) && this.invalidNumber(r), s = !(n = !1);
                  break;

                case 48:
                  a && !s && this.invalidNumber(r), i && (a = !(i = !1)), n = !0;
                  break;

                case 49:
                case 50:
                case 51:
                case 52:
                case 53:
                case 54:
                case 55:
                case 56:
                case 57:
                  a && !s && this.invalidNumber(r), i && (i = !1), a = !(n = !0);
                  break;

                case 69:
                case 101:
                  (i || a || l) && this.invalidNumber(r), l = !(n = !1);
                  break;

                default:
                  n || this.invalidNumber(r), this.pos--, u = !0;
              }

              if (u) break;
            }

            var p = parseFloat(Y.substr(this.str, r, this.pos - r));
            if (s) return p;
            var c = 0 | p;
            return c == p ? c : p;

          case 91:
            for (var h = [], _ = null;;) {
              switch (this.str.charCodeAt(this.pos++)) {
                case 9:
                case 10:
                case 13:
                case 32:
                  break;

                case 44:
                  _ ? _ = !1 : this.invalidChar();
                  break;

                case 93:
                  return 0 == _ && this.invalidChar(), h;

                default:
                  _ && this.invalidChar(), this.pos--, h.push(this.parseRec()), _ = !0;
              }
            }

            break;

          case 102:
            var m = this.pos;
            return 97 == this.str.charCodeAt(this.pos++) && 108 == this.str.charCodeAt(this.pos++) && 115 == this.str.charCodeAt(this.pos++) && 101 == this.str.charCodeAt(this.pos++) || (this.pos = m, this.invalidChar()), !1;

          case 110:
            var f = this.pos;
            return 117 == this.str.charCodeAt(this.pos++) && 108 == this.str.charCodeAt(this.pos++) && 108 == this.str.charCodeAt(this.pos++) || (this.pos = f, this.invalidChar()), null;

          case 116:
            var d = this.pos;
            return 114 == this.str.charCodeAt(this.pos++) && 117 == this.str.charCodeAt(this.pos++) && 101 == this.str.charCodeAt(this.pos++) || (this.pos = d, this.invalidChar()), !0;

          case 123:
            for (var g = {}, v = null, A = null;;) {
              switch (this.str.charCodeAt(this.pos++)) {
                case 9:
                case 10:
                case 13:
                case 32:
                  break;

                case 34:
                  (null != v || A) && this.invalidChar(), v = this.parseString();
                  break;

                case 44:
                  A ? A = !1 : this.invalidChar();
                  break;

                case 58:
                  null == v && this.invalidChar(), g[v] = this.parseRec(), A = !(v = null);
                  break;

                case 125:
                  return null == v && 0 != A || this.invalidChar(), g;

                default:
                  this.invalidChar();
              }
            }

            break;

          default:
            this.invalidChar();
        }
      }
    },
    parseString: function parseString() {
      for (var e = this.pos, t = null, r = -1;;) {
        var i = this.str.charCodeAt(this.pos++);
        if (34 == i) break;

        if (92 == i) {
          null == t && (t = new u());
          var n = this.str,
              a = this.pos - e - 1;

          switch (t.b += null == a ? Y.substr(n, e, null) : Y.substr(n, e, a), 117 != (i = this.str.charCodeAt(this.pos++)) && -1 != r && (t.b += String.fromCodePoint(65533), r = -1), i) {
            case 34:
            case 47:
            case 92:
              t.b += String.fromCodePoint(i);
              break;

            case 98:
              t.b += String.fromCodePoint(8);
              break;

            case 102:
              t.b += String.fromCodePoint(12);
              break;

            case 110:
              t.b += String.fromCodePoint(10);
              break;

            case 114:
              t.b += String.fromCodePoint(13);
              break;

            case 116:
              t.b += String.fromCodePoint(9);
              break;

            case 117:
              var s = O.parseInt("0x" + Y.substr(this.str, this.pos, 4));
              this.pos += 4, -1 != r ? (t.b += s < 56320 || 57343 < s ? String.fromCodePoint(65533) : String.fromCodePoint(s - 56320 + (r - 55296 << 10) + 65536), r = -1) : 55296 <= s && s <= 56319 ? r = s : t.b += String.fromCodePoint(s);
              break;

            default:
              throw ct.thrown("Invalid escape sequence \\" + String.fromCodePoint(i) + " at position " + (this.pos - 1));
          }

          e = this.pos;
        } else if (i != i) throw ct.thrown("Unclosed string");
      }

      if (-1 != r && (t.b += String.fromCodePoint(65533), r = -1), null == t) return Y.substr(this.str, e, this.pos - e - 1);
      n = this.str, a = this.pos - e - 1;
      return t.b += null == a ? Y.substr(n, e, null) : Y.substr(n, e, a), t.b;
    },
    invalidChar: function invalidChar() {
      throw this.pos--, ct.thrown("Invalid char " + this.str.charCodeAt(this.pos) + " at position " + this.pos);
    },
    invalidNumber: function invalidNumber(e) {
      throw ct.thrown("Invalid number at position " + e + ": " + Y.substr(this.str, e, this.pos - e));
    },
    __class__: Ot
  };

  var Pt = function Pt(e, t) {
    this.replacer = e, this.indent = t, this.pretty = null != t, this.nind = 0, this.buf = new u();
  };

  (r["haxe.format.JsonPrinter"] = Pt).__name__ = "haxe.format.JsonPrinter", Pt.print = function (e, t, r) {
    var i = new Pt(t, r);
    return i.write("", e), i.buf.b;
  }, Pt.prototype = {
    buf: null,
    replacer: null,
    indent: null,
    pretty: null,
    nind: null,
    write: function write(e, t) {
      null != this.replacer && (t = this.replacer(e, t));
      var r = P.typeof(t);

      switch (r._hx_index) {
        case 0:
          this.buf.b += "null";
          break;

        case 1:
          this.buf.b += O.string(t);
          break;

        case 2:
          var i = isFinite(t) ? O.string(t) : "null";
          this.buf.b += O.string(i);
          break;

        case 3:
          this.buf.b += O.string(t);
          break;

        case 4:
          this.fieldsString(t, k.fields(t));
          break;

        case 5:
          this.buf.b += '"<fun>"';
          break;

        case 6:
          var n = r.c;
          if (n == String) this.quote(t);else if (n == Array) {
            i = t;
            this.buf.b += String.fromCodePoint(91);

            for (var a = i.length, s = a - 1, l = 0, o = a; l < o;) {
              if (0 < (d = l++) ? this.buf.b += String.fromCodePoint(44) : this.nind++, this.pretty && (this.buf.b += String.fromCodePoint(10)), this.pretty) {
                var u = j.lpad("", this.indent, this.nind * this.indent.length);
                this.buf.b += O.string(u);
              }

              if (this.write(d, i[d]), d == s && (this.nind--, this.pretty && (this.buf.b += String.fromCodePoint(10)), this.pretty)) {
                var p = j.lpad("", this.indent, this.nind * this.indent.length);
                this.buf.b += O.string(p);
              }
            }

            this.buf.b += String.fromCodePoint(93);
          } else if (n == D) {
            for (var c = {}, h = (i = t).h, _ = Object.keys(h), m = _.length, f = 0; f < m;) {
              c[e = _[f++]] = i.h[e];
            }

            i = c;
            this.fieldsString(i, k.fields(i));
          } else if (n == Date) {
            i = t;
            this.quote(Y.dateStr(i));
          } else this.classString(t);
          break;

        case 7:
          l = r.e;
          var d = t._hx_index;
          this.buf.b += O.string(d);
          break;

        case 8:
          this.buf.b += '"???"';
      }
    },
    classString: function classString(e) {
      this.fieldsString(e, P.getInstanceFields(or.getClass(e)));
    },
    fieldsString: function fieldsString(e, t) {
      this.buf.b += String.fromCodePoint(123);

      for (var r = t.length, i = r - 1, n = !0, a = 0, s = r; a < s;) {
        var l = a++,
            o = t[l],
            u = k.field(e, o);

        if (!k.isFunction(u)) {
          if (n ? (this.nind++, n = !1) : this.buf.b += String.fromCodePoint(44), this.pretty && (this.buf.b += String.fromCodePoint(10)), this.pretty) {
            var p = j.lpad("", this.indent, this.nind * this.indent.length);
            this.buf.b += O.string(p);
          }

          if (this.quote(o), this.buf.b += String.fromCodePoint(58), this.pretty && (this.buf.b += String.fromCodePoint(32)), this.write(o, u), l == i && (this.nind--, this.pretty && (this.buf.b += String.fromCodePoint(10)), this.pretty)) {
            var c = j.lpad("", this.indent, this.nind * this.indent.length);
            this.buf.b += O.string(c);
          }
        }
      }

      this.buf.b += String.fromCodePoint(125);
    },
    quote: function quote(e) {
      this.buf.b += String.fromCodePoint(34);

      for (var t = 0, r = e.length; t < r;) {
        var i = e.charCodeAt(t++);

        switch (i) {
          case 8:
            this.buf.b += "\\b";
            break;

          case 9:
            this.buf.b += "\\t";
            break;

          case 10:
            this.buf.b += "\\n";
            break;

          case 12:
            this.buf.b += "\\f";
            break;

          case 13:
            this.buf.b += "\\r";
            break;

          case 34:
            this.buf.b += '\\"';
            break;

          case 92:
            this.buf.b += "\\\\";
            break;

          default:
            this.buf.b += String.fromCodePoint(i);
        }
      }

      this.buf.b += String.fromCodePoint(34);
    },
    __class__: Pt
  };

  var Ct = function Ct() {
    this.pos = 0, this.size = 0;
  };

  (r["haxe.io.BytesBuffer"] = Ct).__name__ = "haxe.io.BytesBuffer", Ct.prototype = {
    buffer: null,
    view: null,
    u8: null,
    pos: null,
    size: null,
    addBytes: function addBytes(e, t, r) {
      if (t < 0 || r < 0 || t + r > e.length) throw ct.thrown(Dt.OutsideBounds);

      if (this.pos + r > this.size && this.grow(r), 0 != this.size) {
        var i = new Uint8Array(e.b.buffer, e.b.byteOffset + t, r);
        this.u8.set(i, this.pos), this.pos += r;
      }
    },
    grow: function grow(e) {
      for (var t = this.pos + e, r = 0 == this.size ? 16 : this.size; r < t;) {
        r = 3 * r >> 1;
      }

      var i = new ArrayBuffer(r),
          n = new Uint8Array(i);
      0 < this.size && n.set(this.u8), this.size = r, this.buffer = i, this.u8 = n, this.view = new DataView(this.buffer);
    },
    getBytes: function getBytes() {
      if (0 == this.size) return new bt(new ArrayBuffer(0));
      var e = new bt(this.buffer);
      return e.length = this.pos, e;
    },
    __class__: Ct
  };
  var Dt = w["haxe.io.Error"] = {
    __ename__: "haxe.io.Error",
    __constructs__: null,
    Blocked: {
      _hx_name: "Blocked",
      _hx_index: 0,
      __enum__: "haxe.io.Error",
      toString: n
    },
    Overflow: {
      _hx_name: "Overflow",
      _hx_index: 1,
      __enum__: "haxe.io.Error",
      toString: n
    },
    OutsideBounds: {
      _hx_name: "OutsideBounds",
      _hx_index: 2,
      __enum__: "haxe.io.Error",
      toString: n
    },
    Custom: (t = function t(e) {
      return {
        _hx_index: 3,
        e: e,
        __enum__: "haxe.io.Error",
        toString: n
      };
    }, t._hx_name = "Custom", t.__params__ = ["e"], t)
  };
  Dt.__constructs__ = [Dt.Blocked, Dt.Overflow, Dt.OutsideBounds, Dt.Custom];

  var Rt = {
    fromBytes: function fromBytes(e, t, r) {
      return null == t && (t = 0), null == r && (r = e.length - t), new Uint8Array(e.b.bufferValue, t, r);
    }
  },
      Lt = function Lt(e) {
    this.current = 0, this.array = e;
  };

  (r["haxe.iterators.ArrayIterator"] = Lt).__name__ = "haxe.iterators.ArrayIterator", Lt.prototype = {
    array: null,
    current: null,
    hasNext: function hasNext() {
      return this.current < this.array.length;
    },
    next: function next() {
      return this.array[this.current++];
    },
    __class__: Lt
  };

  var Ut = function Ut(e) {
    this.cause = e, this.causeStackTrace = pt.exceptionStack();
  };

  (r["hx.concurrent.ConcurrentException"] = Ut).__name__ = "hx.concurrent.ConcurrentException", Ut.prototype = {
    cause: null,
    causeStackTrace: null,
    toString: function toString() {
      var e = "";
      e += "rethrown exception:\n", e += "  ", e += "--------------------\n", e += "  ", e += "| Exception : ", e += O.string(this.cause), e += "\n";

      for (var t = 0, r = pt.toString(this.causeStackTrace).split("\n"); t < r.length;) {
        var i = r[t];
        ++t, "" != i && (e += "  ", e += O.string(j.replace(i, "Called from", "| at")), e += "\n");
      }

      return e += "  ", e += "--------------------";
    },
    __class__: Ut
  };

  var Mt = function Mt() {};

  (r["hx.concurrent.Future"] = Mt).__name__ = "hx.concurrent.Future", Mt.__isInterface__ = !0;
  var Vt = w["hx.concurrent.FutureResult"] = {
    __ename__: "hx.concurrent.FutureResult",
    __constructs__: null,
    VALUE: (t = function t(e, _t4, r) {
      return {
        _hx_index: 0,
        result: e,
        time: _t4,
        future: r,
        __enum__: "hx.concurrent.FutureResult",
        toString: n
      };
    }, t._hx_name = "VALUE", t.__params__ = ["result", "time", "future"], t),
    FAILURE: (t = function t(e, _t5, r) {
      return {
        _hx_index: 1,
        ex: e,
        time: _t5,
        future: r,
        __enum__: "hx.concurrent.FutureResult",
        toString: n
      };
    }, t._hx_name = "FAILURE", t.__params__ = ["ex", "time", "future"], t),
    PENDING: (t = function t(e) {
      return {
        _hx_index: 2,
        future: e,
        __enum__: "hx.concurrent.FutureResult",
        toString: n
      };
    }, t._hx_name = "PENDING", t.__params__ = ["future"], t)
  };
  Vt.__constructs__ = [Vt.VALUE, Vt.FAILURE, Vt.PENDING];

  var Kt = function Kt() {
    this.sync = new sr(), this.completionListeners = [], this.result = Vt.PENDING(this);
  };

  (r["hx.concurrent.AbstractFuture"] = Kt).__name__ = "hx.concurrent.AbstractFuture", Kt.__interfaces__ = [Mt], Kt.prototype = {
    completionListeners: null,
    sync: null,
    result: null,
    isComplete: function isComplete() {
      var e = this.result;

      if (2 == e._hx_index) {
        e.future;
        return !1;
      }

      return !0;
    },
    __class__: Kt
  };

  var qt = function qt() {
    Kt.call(this);
  };

  (r["hx.concurrent.CompletableFuture"] = qt).__name__ = "hx.concurrent.CompletableFuture", qt.__super__ = Kt, qt.prototype = a(Kt.prototype, {
    complete: function complete(a, s) {
      null == s && (s = !1);
      var l = this;
      return this.sync.execute(function () {
        if (s || !l.isComplete()) {
          switch ((r = a)._hx_index) {
            case 0:
              var e = r.v;
              l.result = Vt.VALUE(e, Date.now(), l);
              break;

            case 1:
              var t = r.v;
              l.result = Vt.FAILURE(t, Date.now(), l);
          }

          for (var r = 0, i = l.completionListeners; r < i.length;) {
            var n = i[r];
            ++r;

            try {
              n(l.result);
            } catch (e) {
              t = ct.caught(e);
              dt.trace(t, {
                fileName: "hx/concurrent/Future.hx",
                lineNumber: 117,
                className: "hx.concurrent.CompletableFuture",
                methodName: "complete"
              });
            }
          }

          return !0;
        }

        return !1;
      });
    },
    __class__: qt
  });

  var Gt = function Gt() {};

  (r["hx.concurrent.Service"] = Gt).__name__ = "hx.concurrent.Service", Gt.__isInterface__ = !0;
  var Yt = w["hx.concurrent.ServiceState"] = {
    __ename__: "hx.concurrent.ServiceState",
    __constructs__: null,
    STARTING: {
      _hx_name: "STARTING",
      _hx_index: 0,
      __enum__: "hx.concurrent.ServiceState",
      toString: n
    },
    RUNNING: {
      _hx_name: "RUNNING",
      _hx_index: 1,
      __enum__: "hx.concurrent.ServiceState",
      toString: n
    },
    STOPPING: {
      _hx_name: "STOPPING",
      _hx_index: 2,
      __enum__: "hx.concurrent.ServiceState",
      toString: n
    },
    STOPPED: {
      _hx_name: "STOPPED",
      _hx_index: 3,
      __enum__: "hx.concurrent.ServiceState",
      toString: n
    }
  };
  Yt.__constructs__ = [Yt.STARTING, Yt.RUNNING, Yt.STOPPING, Yt.STOPPED];

  var jt = function jt() {
    this._stateLock = new sr(), this.state = Yt.STOPPED, this.id = jt._ids.incrementAndGet(), dt.trace("[" + O.string(this) + "] instantiated.", {
      fileName: "hx/concurrent/Service.hx",
      lineNumber: 53,
      className: "hx.concurrent.ServiceBase",
      methodName: "new"
    });
  };

  (r["hx.concurrent.ServiceBase"] = jt).__name__ = "hx.concurrent.ServiceBase", jt.__interfaces__ = [Gt], jt.prototype = {
    id: null,
    state: null,
    set_state: function set_state(e) {
      switch (e._hx_index) {
        case 0:
          dt.trace("[" + O.string(this) + "] is starting...", {
            fileName: "hx/concurrent/Service.hx",
            lineNumber: 42,
            className: "hx.concurrent.ServiceBase",
            methodName: "set_state"
          });
          break;

        case 1:
          dt.trace("[" + O.string(this) + "] is running.", {
            fileName: "hx/concurrent/Service.hx",
            lineNumber: 43,
            className: "hx.concurrent.ServiceBase",
            methodName: "set_state"
          });
          break;

        case 2:
          dt.trace("[" + O.string(this) + "] is stopping...", {
            fileName: "hx/concurrent/Service.hx",
            lineNumber: 44,
            className: "hx.concurrent.ServiceBase",
            methodName: "set_state"
          });
          break;

        case 3:
          dt.trace("[" + O.string(this) + "] is stopped.", {
            fileName: "hx/concurrent/Service.hx",
            lineNumber: 45,
            className: "hx.concurrent.ServiceBase",
            methodName: "set_state"
          });
      }

      return this.state = e;
    },
    _stateLock: null,
    start: function start() {
      var e = this;

      this._stateLock.execute(function () {
        switch (e.state._hx_index) {
          case 0:
          case 1:
            break;

          case 2:
            throw ct.thrown("Service [" + O.string(e) + "] is currently stopping!");

          case 3:
            e.set_state(Yt.STARTING), e.onStart(), e.set_state(Yt.RUNNING);
        }
      });
    },
    onStart: function onStart() {},
    toString: function toString() {
      return or.getClass(this).__name__ + "#" + this.id;
    },
    __class__: jt,
    __properties__: {
      set_state: "set_state"
    }
  };

  var Ht = {
    _new: function _new(e) {
      var t = new Jt();
      return null != e && t.addAll(e), t;
    }
  },
      Jt = function Jt() {
    this._sync = new sr(), this._items = [];
  };

  (r["hx.concurrent.collection._CopyOnWriteArray.CopyOnWriteArrayImpl"] = Jt).__name__ = "hx.concurrent.collection._CopyOnWriteArray.CopyOnWriteArrayImpl", Jt.__interfaces__ = [E], Jt.prototype = {
    _items: null,
    _sync: null,
    addAll: function addAll(u) {
      var p = this;

      this._sync.execute(function () {
        var e = null,
            t = u;

        switch (t._hx_index) {
          case 0:
            var r = t.v;
            e = p._items.slice();

            for (var i = r.iterator(); i.hasNext();) {
              var n = i.next();
              e.push(n);
            }

            break;

          case 1:
            var a = t.v;
            e = p._items.concat(a);
            break;

          case 2:
            var s = t.v;
            e = p._items.slice();

            for (var l = s.h; null != l;) {
              var o = l.item;
              l = l.next;
              i = o;
              e.push(i);
            }

        }

        p._items = e;
      });
    },
    iterator: function iterator() {
      return new Lt(this._items);
    },
    __class__: Jt
  };
  var Wt = w["hx.concurrent.executor.Schedule"] = {
    __ename__: "hx.concurrent.executor.Schedule",
    __constructs__: null,
    ONCE: (t = function t(e) {
      return {
        _hx_index: 0,
        initialDelayMS: e,
        __enum__: "hx.concurrent.executor.Schedule",
        toString: n
      };
    }, t._hx_name = "ONCE", t.__params__ = ["initialDelayMS"], t),
    FIXED_DELAY: (t = function t(e, _t6) {
      return {
        _hx_index: 1,
        intervalMS: e,
        initialDelayMS: _t6,
        __enum__: "hx.concurrent.executor.Schedule",
        toString: n
      };
    }, t._hx_name = "FIXED_DELAY", t.__params__ = ["intervalMS", "initialDelayMS"], t),
    FIXED_RATE: (t = function t(e, _t7) {
      return {
        _hx_index: 2,
        intervalMS: e,
        initialDelayMS: _t7,
        __enum__: "hx.concurrent.executor.Schedule",
        toString: n
      };
    }, t._hx_name = "FIXED_RATE", t.__params__ = ["intervalMS", "initialDelayMS"], t),
    HOURLY: (t = function t(e, _t8) {
      return {
        _hx_index: 3,
        minute: e,
        second: _t8,
        __enum__: "hx.concurrent.executor.Schedule",
        toString: n
      };
    }, t._hx_name = "HOURLY", t.__params__ = ["minute", "second"], t),
    DAILY: (t = function t(e, _t9, r) {
      return {
        _hx_index: 4,
        hour: e,
        minute: _t9,
        second: r,
        __enum__: "hx.concurrent.executor.Schedule",
        toString: n
      };
    }, t._hx_name = "DAILY", t.__params__ = ["hour", "minute", "second"], t),
    WEEKLY: (t = function t(e, _t10, r, i) {
      return {
        _hx_index: 5,
        day: e,
        hour: _t10,
        minute: r,
        second: i,
        __enum__: "hx.concurrent.executor.Schedule",
        toString: n
      };
    }, t._hx_name = "WEEKLY", t.__params__ = ["day", "hour", "minute", "second"], t)
  };
  Wt.__constructs__ = [Wt.ONCE, Wt.FIXED_DELAY, Wt.FIXED_RATE, Wt.HOURLY, Wt.DAILY, Wt.WEEKLY];

  var Xt = function Xt() {
    this.completionListeners = Ht._new(), jt.call(this);
  };

  (r["hx.concurrent.executor.Executor"] = Xt).__name__ = "hx.concurrent.executor.Executor", Xt.create = function (e, t) {
    return null == t && (t = !0), null == e && (e = 1), new er(t);
  }, Xt.__super__ = jt, Xt.prototype = a(jt.prototype, {
    completionListeners: null,
    notifyResult: function notifyResult(e) {
      for (var t = 0, r = this.completionListeners._items; t < r.length;) {
        var i = r[t++];

        try {
          i(e);
        } catch (e) {
          var n = ct.caught(e);
          dt.trace(n, {
            fileName: "hx/concurrent/executor/Executor.hx",
            lineNumber: 49,
            className: "hx.concurrent.executor.Executor",
            methodName: "notifyResult"
          });
        }
      }

      if (0 == this.completionListeners._items.length && 1 == e._hx_index) {
        e.time, e.future, n = e.ex;
        dt.trace(n, {
          fileName: "hx/concurrent/executor/Executor.hx",
          lineNumber: 52,
          className: "hx.concurrent.executor.Executor",
          methodName: "notifyResult"
        });
      }
    },
    submit: null,
    __class__: Xt
  });

  var Zt = function Zt() {};

  (r["hx.concurrent.executor.TaskFuture"] = Zt).__name__ = "hx.concurrent.executor.TaskFuture", Zt.__isInterface__ = !0, Zt.__interfaces__ = [Mt];

  var Qt = function Qt(e, t, r) {
    this.isStopped = !1, qt.call(this), this._executor = e, this._task = t, this.schedule = $t.assertValid(r);
  };

  (r["hx.concurrent.executor.AbstractTaskFuture"] = Qt).__name__ = "hx.concurrent.executor.AbstractTaskFuture", Qt.__interfaces__ = [Zt], Qt.__super__ = qt, Qt.prototype = a(qt.prototype, {
    schedule: null,
    isStopped: null,
    _executor: null,
    _task: null,
    __class__: Qt
  });

  var $t = function $t() {};

  (r["hx.concurrent.executor.ScheduleTools"] = $t).__name__ = "hx.concurrent.executor.ScheduleTools", $t.applyDefaults = function (e) {
    switch (e._hx_index) {
      case 0:
        if (null == e.initialDelayMS) return Wt.ONCE(0);
        break;

      case 1:
        var t = e.intervalMS;
        if (null == e.initialDelayMS) return Wt.FIXED_DELAY(t, 0);
        break;

      case 2:
        t = e.intervalMS;
        if (null == e.initialDelayMS) return Wt.FIXED_RATE(t, 0);
        break;

      case 3:
        var r = e.minute,
            i = e.second;
        if (null == r || null == i) return Wt.HOURLY(null == r ? 0 : r, null == i ? 0 : i);
        break;

      case 4:
        var n = e.hour;
        r = e.minute, i = e.second;
        if (null == n || null == r || null == i) return Wt.DAILY(null == n ? 0 : n, null == r ? 0 : r, null == i ? 0 : i);
        break;

      case 5:
        var a = e.day;
        n = e.hour, r = e.minute, i = e.second;
        if (null == a || null == n || null == r || null == i) return Wt.WEEKLY(null == a ? 0 : a, null == n ? 0 : n, null == r ? 0 : r, null == i ? 0 : i);
    }

    return e;
  }, $t.assertValid = function (e) {
    switch ((e = $t.applyDefaults(e))._hx_index) {
      case 0:
        if ((r = e.initialDelayMS) < 0) throw ct.thrown("[Schedule.ONCE.initialDelayMS] must be >= 0");
        break;

      case 1:
        var t = e.intervalMS,
            r = e.initialDelayMS;
        if (t <= 0) throw ct.thrown("[Schedule.FIXED_DELAY.intervalMS] must be > 0");
        if (null == r || r < 0) throw ct.thrown("[Schedule.FIXED_DELAY.initialDelayMS] must be >= 0");
        break;

      case 2:
        t = e.intervalMS, r = e.initialDelayMS;
        if (t <= 0) throw ct.thrown("[Schedule.FIXED_RATE.intervalMS] must be > 0");
        if (r < 0) throw ct.thrown("[Schedule.FIXED_RATE.initialDelayMS] must be >= 0");
        break;

      case 3:
        var i = e.minute,
            n = e.second;
        if (null == i || i < 0) throw ct.thrown("[Schedule.DAILY.minute] must be between >= 0 and <= 59");
        if (null == n || n < 0) throw ct.thrown("[Schedule.DAILY.second] must be between >= 0 and <= 59");
        break;

      case 4:
        var a = e.hour;
        i = e.minute, n = e.second;
        if (null == a || a < 0) throw ct.thrown("[Schedule.DAILY.hour] must be between >= 0 and <= 23");
        if (null == i || i < 0) throw ct.thrown("[Schedule.DAILY.minute] must be between >= 0 and <= 59");
        if (null == n || n < 0) throw ct.thrown("[Schedule.DAILY.second] must be between >= 0 and <= 59");
        break;

      case 5:
        e.day, a = e.hour, i = e.minute, n = e.second;
        if (null == a || a < 0) throw ct.thrown("[Schedule.WEEKLY.hour] must be between >= 0 and <= 23");
        if (null == i || i < 0) throw ct.thrown("[Schedule.WEEKLY.minute] must be between >= 0 and <= 59");
        if (null == n || n < 0) throw ct.thrown("[Schedule.WEEKLY.second] must be between >= 0 and <= 59");
    }

    return e;
  }, $t.firstRunAt = function (e) {
    switch ((e = $t.assertValid(e))._hx_index) {
      case 0:
        var t = e.initialDelayMS;
        return Date.now() + t;

      case 1:
      case 2:
        e.intervalMS, t = e.initialDelayMS;
        return Date.now() + t;

      case 3:
        var r = e.minute,
            i = e.second,
            n = Date.now(),
            a = 60 * r + i,
            s = 60 * (o = new Date(n)).getMinutes() + o.getSeconds();
        return n + 1e3 * (a - s) + (a < s ? 36e5 : 0);

      case 4:
        var l = e.hour;
        r = e.minute, i = e.second;
        return (n = Date.now()) + 1e3 * ((p = 60 * l * 60 + 60 * r + i) - (c = 60 * (o = new Date(n)).getHours() * 60 + 60 * o.getMinutes() + o.getSeconds())) + (p < c ? 864e5 : 0);

      case 5:
        var o,
            u = e.day,
            p = (l = e.hour, r = e.minute, i = e.second, n = Date.now(), 60 * l * 60 + 60 * r + i),
            c = 60 * (o = new Date(n)).getHours() * 60 + 60 * o.getMinutes() + o.getSeconds(),
            h = u;
        return h == o.getDay() ? n + 1e3 * (p - c) + (p < c ? 6048e5 : 0) : o.getDate() < h ? n + 1e3 * (p - c) + 864e5 * (h - o.getDate()) : n + 1e3 * (p - c) + 864e5 * (7 - (h - o.getDate()));
    }
  };

  var er = function er(e) {
    null == e && (e = !0), this._scheduledTasks = [], Xt.call(this), e && this.start();
  };

  (r["hx.concurrent.executor.TimerExecutor"] = er).__name__ = "hx.concurrent.executor.TimerExecutor", er.__super__ = Xt, er.prototype = a(Xt.prototype, {
    _scheduledTasks: null,
    submit: function submit(i, e) {
      var n = this,
          a = null == e ? Xt.NOW_ONCE : e;
      return this._stateLock.execute(function () {
        if (n.state != Yt.RUNNING) throw ct.thrown("Cannot accept new tasks. Executor is not in state [RUNNING] but [" + O.string(n.state) + "].");

        for (var e = n._scheduledTasks.length; 0 < e--;) {
          n._scheduledTasks[e].isStopped && n._scheduledTasks.splice(e, 1);
        }

        var t = new tr(n, i, a);

        if (0 == a._hx_index) {
          var r = a.initialDelayMS;
          null == r ? n._scheduledTasks.push(t) : 0 != r && n._scheduledTasks.push(t);
        } else n._scheduledTasks.push(t);

        return t;
      });
    },
    __class__: er
  });

  var tr = function tr(e, t, r) {
    Qt.call(this, e, t, r);
    var i = $t.firstRunAt(this.schedule) - Date.now() | 0;
    i < 0 && (i = 0), At.delay(mr(this, this.run), i);
  };

  (r["hx.concurrent.executor._TimerExecutor.TaskFutureImpl"] = tr).__name__ = "hx.concurrent.executor._TimerExecutor.TaskFutureImpl", tr.__super__ = Qt, tr.prototype = a(Qt.prototype, {
    _timer: null,
    run: function run() {
      if (!this.isStopped) {
        if (null == this._timer) {
          var e = null;

          switch ((i = this.schedule)._hx_index) {
            case 2:
              i.initialDelayMS;
              var t = i.intervalMS;
              (e = new At(t)).run = mr(this, this.run);
              break;

            case 3:
              i.minute, i.second;
              (e = new At(36e5)).run = mr(this, this.run);
              break;

            case 4:
              i.hour, i.minute, i.second;
              (e = new At(864e5)).run = mr(this, this.run);
              break;

            case 5:
              i.day, i.hour, i.minute, i.second;
              (e = new At(6048e5)).run = mr(this, this.run);
          }

          this._timer = e;
        }

        var r;

        try {
          var i;

          switch ((i = this._task)._hx_index) {
            case 0:
              var n = i.v;
              r = rr.a(n());
              break;

            case 1:
              (0, i.v)(), r = null;
          }
        } catch (i) {
          var a = ct.caught(i);
          r = rr.b(new Ut(a));
        }

        switch ((i = this.schedule)._hx_index) {
          case 0:
            i.initialDelayMS;
            this.isStopped = !0;
            break;

          case 1:
            i.initialDelayMS, t = i.intervalMS;
            this._timer = At.delay(mr(this, this.run), t);
        }

        this.complete(r, !0), this._executor.notifyResult(this.result);
      }
    },
    __class__: tr
  });
  var rr = w["hx.concurrent.internal._Either2._Either2"] = {
    __ename__: "hx.concurrent.internal._Either2._Either2",
    __constructs__: null,
    a: (t = function t(e) {
      return {
        _hx_index: 0,
        v: e,
        __enum__: "hx.concurrent.internal._Either2._Either2",
        toString: n
      };
    }, t._hx_name = "a", t.__params__ = ["v"], t),
    b: (t = function t(e) {
      return {
        _hx_index: 1,
        v: e,
        __enum__: "hx.concurrent.internal._Either2._Either2",
        toString: n
      };
    }, t._hx_name = "b", t.__params__ = ["v"], t)
  };
  rr.__constructs__ = [rr.a, rr.b];
  var ir = w["hx.concurrent.internal._Either3._Either3"] = {
    __ename__: "hx.concurrent.internal._Either3._Either3",
    __constructs__: null,
    a: (t = function t(e) {
      return {
        _hx_index: 0,
        v: e,
        __enum__: "hx.concurrent.internal._Either3._Either3",
        toString: n
      };
    }, t._hx_name = "a", t.__params__ = ["v"], t),
    b: (t = function t(e) {
      return {
        _hx_index: 1,
        v: e,
        __enum__: "hx.concurrent.internal._Either3._Either3",
        toString: n
      };
    }, t._hx_name = "b", t.__params__ = ["v"], t),
    c: (t = function t(e) {
      return {
        _hx_index: 2,
        v: e,
        __enum__: "hx.concurrent.internal._Either3._Either3",
        toString: n
      };
    }, t._hx_name = "c", t.__params__ = ["v"], t)
  };
  ir.__constructs__ = [ir.a, ir.b, ir.c];

  var nr = function nr() {};

  (r["hx.concurrent.lock.Acquirable"] = nr).__name__ = "hx.concurrent.lock.Acquirable", nr.__isInterface__ = !0;

  var ar = function ar() {};

  (r["hx.concurrent.lock.AbstractAcquirable"] = ar).__name__ = "hx.concurrent.lock.AbstractAcquirable", ar.__interfaces__ = [nr], ar.prototype = {
    release: null,
    acquire: null,
    execute: function execute(e, t) {
      null == t && (t = !1);
      var r = null,
          i = null;
      this.acquire();

      try {
        i = e();
      } catch (e) {
        var n = ct.caught(e);
        r = new Ut(n);
      }

      if (this.release(), !t && null != r) throw ct.thrown(r.toString());
      return i;
    },
    __class__: ar
  };

  var sr = function sr() {
    this._holderEntranceCount = 0, this._holder = null;
  };

  (r["hx.concurrent.lock.RLock"] = sr).__name__ = "hx.concurrent.lock.RLock", sr.__super__ = ar, sr.prototype = a(ar.prototype, {
    _holder: null,
    _holderEntranceCount: null,
    acquire: function acquire() {
      this._holder = lr.get_current(), this._holderEntranceCount++;
    },
    release: function release() {
      if (this._holder != lr.get_current()) throw null != this._holder && this._holder != lr.get_current() ? ct.thrown("Lock was aquired by another thread!") : ct.thrown("Lock was not aquired by any thread!");
      this._holderEntranceCount--, 0 == this._holderEntranceCount && (this._holder = null);
    },
    __class__: sr
  });

  var lr = function lr() {};

  (r["hx.concurrent.thread.Threads"] = lr).__name__ = "hx.concurrent.thread.Threads", lr.__properties__ = {
    get_current: "get_current"
  }, lr.get_current = function () {
    return "MainThread";
  };

  var or = function or() {};

  (r["js.Boot"] = or).__name__ = "js.Boot", or.getClass = function (e) {
    if (null == e) return null;
    if (e instanceof Array) return Array;
    var t = e.__class__;
    if (null != t) return t;

    var r = or.__nativeClassName(e);

    return null != r ? or.__resolveNativeClass(r) : null;
  }, or.__string_rec = function (a, s) {
    if (null == a) return "null";
    if (5 <= s.length) return "<...>";

    var e = _typeof(a);

    switch ("function" == e && (a.__name__ || a.__ename__) && (e = "object"), e) {
      case "function":
        return "<function>";

      case "object":
        if (a.__enum__) {
          var l = w[a.__enum__].__constructs__[a._hx_index],
              t = l._hx_name;
          return l.__params__ ? (s += "\t", t + "(" + function (e) {
            for (var t = [], r = 0, i = l.__params__; r < i.length;) {
              var n = i[r];
              r += 1, t.push(or.__string_rec(a[n], s));
            }

            return t;
          }().join(",") + ")") : t;
        }

        if (a instanceof Array) {
          var r = "[";
          s += "\t";

          for (var i = 0, n = a.length; i < n;) {
            var o = i++;
            r += (0 < o ? "," : "") + or.__string_rec(a[o], s);
          }

          return r += "]";
        }

        var u;

        try {
          u = a.toString;
        } catch (i) {
          return gt.lastError = i, "???";
        }

        if (null != u && u != Object.toString && "function" == typeof u) {
          var p = a.toString();
          if ("[object Object]" != p) return p;
        }

        r = "{\n";
        s += "\t";
        var c = null != a.hasOwnProperty,
            h = null;

        for (h in a) {
          c && !a.hasOwnProperty(h) || "prototype" != h && "__class__" != h && "__super__" != h && "__interfaces__" != h && "__properties__" != h && (2 != r.length && (r += ", \n"), r += s + h + " : " + or.__string_rec(a[h], s));
        }

        return r += "\n" + (s = s.substring(1)) + "}";

      case "string":
        return a;

      default:
        return String(a);
    }
  }, or.__interfLoop = function (e, t) {
    if (null == e) return !1;
    if (e == t) return !0;
    var r = e.__interfaces__;
    if (null != r) for (var i = 0, n = r.length; i < n;) {
      var a = r[i++];
      if (a == t || or.__interfLoop(a, t)) return !0;
    }
    return or.__interfLoop(e.__super__, t);
  }, or.__instanceof = function (e, t) {
    if (null == t) return !1;

    switch (t) {
      case Array:
        return e instanceof Array;

      case Ar:
        return "boolean" == typeof e;

      case gr:
        return null != e;

      case vr:
        return "number" == typeof e;

      case dr:
        return "number" == typeof e && (0 | e) === e;

      case String:
        return "string" == typeof e;

      default:
        if (null == e) return !1;

        if ("function" == typeof t) {
          if (or.__downcastCheck(e, t)) return !0;
        } else if ("object" == _typeof(t) && or.__isNativeObj(t) && e instanceof t) return !0;

        return t == Tr && null != e.__name__ || t == yr && null != e.__ename__ || null != e.__enum__ && w[e.__enum__] == t;
    }
  }, or.__downcastCheck = function (e, t) {
    return e instanceof t || !!t.__isInterface__ && or.__interfLoop(or.getClass(e), t);
  }, or.__cast = function (e, t) {
    if (null == e || or.__instanceof(e, t)) return e;
    throw ct.thrown("Cannot cast " + O.string(e) + " to " + O.string(t));
  }, or.__nativeClassName = function (e) {
    var t = or.__toStr.call(e).slice(8, -1);

    return "Object" == t || "Function" == t || "Math" == t || "JSON" == t ? null : t;
  }, or.__isNativeObj = function (e) {
    return null != or.__nativeClassName(e);
  }, or.__resolveNativeClass = function (e) {
    return i[e];
  };

  var ur = function ur() {};

  (r["js.Browser"] = ur).__name__ = "js.Browser", ur.__properties__ = {
    get_supported: "get_supported"
  }, ur.get_supported = function () {
    return "undefined" != typeof window && void 0 !== window.location && "string" == typeof window.location.protocol;
  };

  var pr = function pr() {};

  (r["js.lib._ArrayBuffer.ArrayBufferCompat"] = pr).__name__ = "js.lib._ArrayBuffer.ArrayBufferCompat", pr.sliceImpl = function (e, t) {
    var r = new Uint8Array(this, e, null == t ? null : t - e),
        i = new Uint8Array(r.byteLength);
    return i.set(r), i.buffer;
  };
  var cr = {
    stringToVersion: function stringToVersion(e) {
      if (!cr.VERSION.match(e)) throw ct.thrown('Invalid SemVer format for "' + e + '"');
      return {
        version: [O.parseInt(cr.VERSION.matched(1)), O.parseInt(cr.VERSION.matched(2)), O.parseInt(cr.VERSION.matched(3))],
        pre: cr.parseIdentifiers(cr.VERSION.matched(4)),
        build: cr.parseIdentifiers(cr.VERSION.matched(5))
      };
    },
    equals: function equals(e, t) {
      return e.version[0] == t.version[0] && e.version[1] == t.version[1] && e.version[2] == t.version[2] && cr.equalsIdentifiers(e.pre, t.pre);
    },
    greaterThan: function greaterThan(e, t) {
      return 0 < e.pre.length && 0 < t.pre.length ? e.version[0] == t.version[0] && e.version[1] == t.version[1] && e.version[2] == t.version[2] && cr.greaterThanIdentifiers(e.pre, t.pre) : 0 < t.pre.length ? e.version[0] != t.version[0] ? e.version[0] > t.version[0] : e.version[1] != t.version[1] ? e.version[1] > t.version[1] : e.version[2] != t.version[2] ? e.version[2] > t.version[2] : !(0 < e.pre.length) || cr.greaterThanIdentifiers(e.pre, t.pre) : e.pre.length <= 0 && (e.version[0] != t.version[0] ? e.version[0] > t.version[0] : e.version[1] != t.version[1] ? e.version[1] > t.version[1] : e.version[2] != t.version[2] ? e.version[2] > t.version[2] : cr.greaterThanIdentifiers(e.pre, t.pre));
    },
    greaterThanOrEqual: function greaterThanOrEqual(e, t) {
      return !!cr.equals(e, t) || cr.greaterThan(e, t);
    },
    lessThan: function lessThan(e, t) {
      return !cr.greaterThanOrEqual(e, t);
    },
    lessThanOrEqual: function lessThanOrEqual(e, t) {
      return !cr.greaterThan(e, t);
    },
    parseIdentifiers: function parseIdentifiers(e) {
      for (var t = (null == e ? "" : e).split("."), r = cr.sanitize, i = new Array(t.length), n = 0, a = t.length; n < a;) {
        i[o = n++] = r(t[o]);
      }

      n = [], a = 0;

      for (var s = i; a < s.length;) {
        var l = s[a];
        ++a, "" != l && n.push(l);
      }

      for (t = n, r = cr.parseIdentifier, i = new Array(t.length), n = 0, a = t.length; n < a;) {
        var o;
        i[o = n++] = r(t[o]);
      }

      return i;
    },
    parseIdentifier: function parseIdentifier(e) {
      var t = O.parseInt(e);
      return null == t ? hr.StringId(e) : hr.IntId(t);
    },
    equalsIdentifiers: function equalsIdentifiers(e, t) {
      if (e.length != t.length) return !1;

      for (var r = 0, i = e.length; r < i;) {
        var n = r++,
            a = e[n],
            s = t[n];

        switch (a._hx_index) {
          case 0:
            if (0 == s._hx_index) {
              var l = s.value;
              if (a.value != l) return !1;
            }

            break;

          case 1:
            if (1 == s._hx_index) {
              var o = s.value;
              if (a.value != o) return !1;
            }

        }
      }

      return !0;
    },
    greaterThanIdentifiers: function greaterThanIdentifiers(e, t) {
      for (var r = 0, i = e.length; r < i;) {
        var n = r++,
            a = e[n],
            s = t[n];

        switch (a._hx_index) {
          case 0:
            var l = a.value;

            switch (s._hx_index) {
              case 0:
                var o = s.value;
                if (l == o) continue;
                return o < l;

              case 1:
                s.value;
                return !0;

              default:
                return !1;
            }

            break;

          case 1:
            var u = a.value;

            if (1 == s._hx_index) {
              var p = s.value;
              if (u == p) continue;
              return p < u;
            }

            return !1;

          default:
            return !1;
        }
      }

      return !1;
    },
    sanitize: function sanitize(e) {
      return e.replace(cr.SANITIZER.r, "");
    }
  },
      hr = w["thx.semver.Identifier"] = {
    __ename__: "thx.semver.Identifier",
    __constructs__: null,
    StringId: (t = function t(e) {
      return {
        _hx_index: 0,
        value: e,
        __enum__: "thx.semver.Identifier",
        toString: n
      };
    }, t._hx_name = "StringId", t.__params__ = ["value"], t),
    IntId: (t = function t(e) {
      return {
        _hx_index: 1,
        value: e,
        __enum__: "thx.semver.Identifier",
        toString: n
      };
    }, t._hx_name = "IntId", t.__params__ = ["value"], t)
  };

  function _r(e) {
    return e instanceof Array ? new Lt(e) : e.iterator();
  }

  function mr(e, t) {
    return null == t ? null : (null == t.__id__ && (t.__id__ = i.$haxeUID++), null == e.hx__closures__ ? e.hx__closures__ = {} : r = e.hx__closures__[t.__id__], null == r && (r = t.bind(e), e.hx__closures__[t.__id__] = r), r);
    var r;
  }

  hr.__constructs__ = [hr.StringId, hr.IntId], i.$haxeUID |= 0, "undefined" != typeof performance && "function" == typeof performance.now && (Y.now = performance.now.bind(performance)), r.Math = Math, null == String.fromCodePoint && (String.fromCodePoint = function (e) {
    return e < 65536 ? String.fromCharCode(e) : String.fromCharCode(55232 + (e >> 10)) + String.fromCharCode(56320 + (1023 & e));
  }), String.prototype.__class__ = r.String = String, String.__name__ = "String", r.Array = Array, Array.__name__ = "Array", Date.prototype.__class__ = r.Date = Date, Date.__name__ = "Date";
  var fr,
      dr = {},
      gr = {},
      vr = Number,
      Ar = Boolean,
      Tr = {},
      yr = {};
  kt.count = 0, or.__toStr = {}.toString, null == ArrayBuffer.prototype.slice && (ArrayBuffer.prototype.slice = pr.sliceImpl), f.SYSTEM_DATA_LOCK = f.getNewLock("system_data_lock"), f.METADATA_LOCK = f.getNewLock("meta_data_lock"), f.CHECK_TIME_LOCK = f.getNewLock("last_check_time_lock"), f.INITIALIZATION = f.getNewLock("initialize_lock"), C.resultsLock = f.getNewLock("datastore_results_lock"), d.LOG_LEVEL_VERBOSE = 0, d.LOG_LEVEL_DEBUG = 1, d.LOG_LEVEL_INFO = 2, d.LOG_LEVEL_WARN = 3, d.LOG_LEVEL_ERROR = 4, d.LOG_LEVEL_NONE = 5, d.logLevel = d.LOG_LEVEL_VERBOSE, d.useTraceForLogging = !1, g.kABTEventSourceApptimize = "a", g.kABTValueEventKey = "value", g._state = 0, L.MAX_FAILURE_DELAY_MS = 6e4, L.DEFAULT_FAILURE_DELAY_MS = 1e3, L._failureDelayMs = (null == (fr = L.DEFAULT_FAILURE_DELAY_MS) && (fr = 0), new N(fr)), L._pendingMap = new D(), L._pendingResults = S._new(), L._postDispatch = new R("Results Post Dispatch Queue"), L._loadedPending = !1, L.PENDING_LOCK = f.getNewLock("pending_results_key"), Q.kABTFilterKeyValue = "value", Q.kABTFilterKeyType = "type", Q.kABTFilterKeyProperty = "property", Q.kABTFilterKeyOperator = "operator", Q.kABTFilterKeyPropertySource = "propertySource", Q.kABTFilterKeyCallServerInputs = "callServerInputs", Q.kABTFilterKeyCallURLKey = "callServerUrlKey", Q.kABTFilterKeyUserAttribute = "userAttribute", Q.kABTFilterKeyPrefixedAttribute = "prefixedAttribute", Q.kABTFilterKeyNamedFilter = "namedFilter", se.__meta__ = {
    statics: {
      ABTEvaluateString: {
        static: null
      },
      ABTEvaluateBool: {
        static: null
      },
      ABTEvaluateNumber: {
        static: null
      }
    }
  }, ce.kABTNamedFilterKeyFilterName = "filterName", ce.kABTNamedFilterKeyTrueIsSticky = "trueIsSticky", ce.kABTNamedFilterKeyFalseIsSticky = "falseIsSticky", ce.kABTNamedFilterKeyNullIsSticky = "nullIsSticky", ze.RESULT_ENTRY_CREATION_LOCK = f.getNewLock("result_entry_creation_lock_key"), Ke.compressionPrefix = "ABTGZIP+", Ge.ALL_LATENCY = 2, Ge.kMetadataKey = "METADATA_KEY", Ge.kUserIDKey = "USER_ID_KEY", Ge.kAnonymousGuidKey = "ANONYMOUS_GUID_KEY", Ge.kCustomPropertiesKey = "CUSTOM_PROPERTIES_KEY", Ge.kInternalPropertiesKey = "INTERNAL_PROPERTIES_KEY", Ge.kResultLogsKey = "RESULT_LOGS_KEY", Ge.kResultPostsListKey = "RESULT_POSTS_LIST_KEY", Ge.kResultEntrySequenceKey = "RESULT_ENTRY_SEQUENCE_KEY", Ge.kResultEntryTimestampKey = "RESULT_ENTRY_TIMESTAMP_KEY", Ge.kApptimizeVersionKey = "APPTIMIZE_VERSION_KEY", Ge.kResultLastSubmitTimeKey = "RESULT_LAST_SUBMIT_TIME_KEY", Ge.kMetadataLastCheckTimeKey = "METADATA_LAST_CHECK_TIME_KEY", Ge.kDisabledVersions = "DISABLED_VERSIONS_KEY", Ge._isFlushing = !1, je._sigilForApplicationNamespace = "$", He.META_DATA_URL_KEY = "meta_data_url", He.META_DATA_URL_LL_KEY = "meta_data_ll_url", He.META_DATA_URL_HL_KEY = "meta_data_hl_url", He.LOG_LEVEL_KEY = "log_level", He.FOREGROUND_PERIOD_MS_KEY = "foreground_period_ms", He.RESULT_POST_DELAY_MS_KEY = "result_post_delay_ms", He.THREADING_ENABLED_KEY = "threading_enabled", He.RESULT_POST_THREAD_POOL_SIZE_KEY = "result_post_thread_pool_size", He.ALTERATION_CACHE_SIZE_KEY = "alteration_cache_size", He.RESULTS_CACHE_SIZE_KEY = "results_cache_size", He.MAXIMUM_RESULT_ENTRIES_KEY = "maximum_result_entries", He.MAXIMUM_PENDING_RESULTS_KEY = "maximum_pending_results", He.METADATA_POLLING_INTERVAL_MS_KEY = "metadata_polling_interval_ms", He.METADATA_POLLING_BACKGROUND_INTERVAL_MS_KEY = "metadata_polling_background_interval_ms", He.EXCEPTIONS_ENABLED_KEY = "exceptions_enabled", He.MAXIMUM_RESULT_POST_FAILURE_KEY = "maximum_result_failures", He.MAXIMUM_RESULT_POST_SENDER_TIMEOUT_MS_KEY = "maximum_result_post_sender_timeout_ms", He.STORAGE_TYPE_KEY = "storage_type", He.AUTOMATIC_SHUTDOWN_HOOK = "automatic_shutdown_hook", He.APPTIMIZE_ENVIRONMENT_KEY = "apptimize_environment", He.APPTIMIZE_MAXEXP_SEED_KEY = "apptimize_maxseed", He.APPTIMIZE_REGION_KEY = "apptimize_region", He.COMPRESS_PERSISTENCE_STORE_KEY = "compress_persistence_store", He.GROUPS_BASE_URL_KEY = "groups_base_url", He.REACT_NATIVE_STORAGE_KEY = "react_native_storage", He.LOCAL_DISK_STORAGE_PATH_KEY = "local_disk_storage_path", nt.kBrowserNameUnknown = "Unknown", nt.kBrowserNameChrome = "Chrome", nt.kBrowserNameFirefox = "Firefox", nt.kBrowserNameSafari = "Safari", nt.kBrowserNameInternetExplorer = "Internet Explorer", nt.kBrowserAndroidWebViewGeneral = " Version/", nt.kBrowserAndroidWebViewPreK = " Android ", nt.kBrowserAndroidWebViewKtoL = " Mobile ", nt.kBrowserAndroidWebViewLAbove = " wv", nt.kBrowserChrome = "Chrome", nt.kBrowserChromeiOS = "CriOS", nt.kBrowserChromium = " Chromium", nt.kBrowserEdge = "Edge", nt.kBrowserEdgeiOS = "EdgiOS", nt.kBrowserEdgeAndroid = "EdgA", nt.kBrowserFirefox = "Firefox", nt.kBrowserFirefoxiOS = "FxiOS", nt.kBrowserInternetExplorer = "MSIE", nt.kBrowserInternetExplorer11 = "Trident", nt.kBrowserSafari = "Safari", nt.kBrowserSeaMonkey = "SeaMonkey", nt.kBrowserOpera = "Opera", nt.kBrowserOperaNew = " OPR", nt.kBrowserUnknown = "Unknown", nt.kDeviceCategoryDesktop = "Desktop", nt.kDeviceCategoryTablet = "Tablet", nt.kDeviceCategoryMobile = "Mobile", ht._mul = null != Math.imul ? Math.imul : function (e, t) {
    return e * (65535 & t) + (e * (t >>> 16) << 16 | 0) | 0;
  }, vt.USE_CACHE = !1, vt.USE_ENUM_INDEX = !1, vt.BASE64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789%:", yt.DEFAULT_RESOLVER = new Tt(), yt.BASE64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789%:", xt.CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", xt.BYTES = bt.ofString(xt.CHARS), jt._ids = new N(0), Xt.NOW_ONCE = Wt.ONCE(0), cr.VERSION = new o("^(\\d+)\\.(\\d+)\\.(\\d+)(?:[-]([a-z0-9.-]+))?(?:[+]([a-z0-9.-]+))?$", "i"), cr.SANITIZER = new o("[^0-9A-Za-z-]", "g");
}("undefined" != typeof exports ? exports : "undefined" != typeof window ? window : "undefined" != typeof self ? self : this, "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : this);